import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Keresés",
  "text2": "Az Ön megrendelése",
  "text3": "Várakozik a banki átutalásra",
  "text4": "Jó napot",
  "text5": "A megrendelésért",
  "text6": "várjuk a banki átutalást",
  "text7": "A megrendelés kézbesítve",
  "text8": "Az Ön megrendelése sikeresen kézbesítve lett",
  "text9": "Paraméterek",
  "text10": "Facebook",
  "text11": "Megrendelése el lett küldve",
  "text12": "úton van Önhöz",
  "text13": "Csomagjának mozgását a csomagszámra kattintva követheti nyomon",
  "text14": "Csomag nyomonkövetési száma",
  "text15": "köszönjük a vásárlást",
  "text16": "Az Ön megrendelését ez a kód alatt regisztráljuk",
  "text17": "Megrendelés részletei",
  "text18": "Létrehozva:",
  "text19": "Kódszám",
  "text20": "Termék",
  "text21": "Egységes ár",
  "text22": "Mennyiség",
  "text23": "Teljes összeg",
  "text24": "Kedvezmény",
  "text25": "Kedvezmények",
  "text26": "Teljes összeg",
  "text27": "Fizetési adatok",
  "text28": "IBAN szám",
  "text29": "Pénzintézet",
  "text30": "Összeg",
  "text31": "Változó szimbólum",
  "text32": "Szállítási cím",
  "text33": "Keresztnév",
  "text34": "Vezetéknév",
  "text35": "E-mail",
  "text36": "Telefonszám",
  "text37": "Vállalkozás neve",
  "text38": "Utca, házszám",
  "text39": "Város",
  "text40": "Irányítószám",
  "text41": "Ország",
  "text42": "azonosító szám",
  "text43": "Adószám",
  "text44": "Áfa azonosító szám",
  "text45": "Számlázási cím",
  "text46": "Megrendelés törölve",
  "text47": "törölve lett.",
  "text48": "Fizetés elfogadva",
  "text49": "ki volt fizetve",
  "text50": "A megrendelés állapota a fiókba való bejelentkezés után is nyomon követhető",
  "text51": "Bejelentkezés a fiókomba",
  "text52": "Visszatérített megrendelés",
  "text53": "vissze lett adva",
  "text54": "Pénzvisszatérítés",
  "text55": "A rendelésért",
  "text56": "A pénz vissza lett téritve",
  "text57": "Jegyzet",
  "text58": "Szállítási költség",
  "text59": "Fizetési ár",
  "text60": "Hasonló termékek",
  "text61": "Kedvenc termékek",
  "text62": "Megrendelés beérkezett",
  "text63": "Megrendelés",
  "text64": "Áfa",
  "text65": "száma:",
  "text66": "úton van Önhöz",
  "text67": "A regisztráció sikeres",
  "text68": "Az Ön regisztrációja sikeres.",
  "text69": "Generált jelszó:",
  "text70": "Bejelentkezés után javasoljuk jelszavának megváltoztatását.",
  "text71": "A szekcióban tud bejelentkezni fiókjába",
  "text72": "Felhasználói fiók",
  "text73": "vagy a bejelnetkezés gombra kattintva",
  "text74": "Bejelentkezés a fiókomba",
  "text75": "AZ ÉN E-MAILEM",
  "text76": "OLCSÓBB TERMÉK LINKJE:",
  "text77": "AZ ÖN TERMÉK LINKJE",
  "text78": "Születésnapja alkalmából minden jót kívánunk.",
  "text79": "TERMÉK LINKJE:",
  "text80": "Üzenet:",
  "text81": "Tárgy",
  "text82": "Kapcsolatfelvételi űrlap",
  "text83": "a bizalom jeléül akciós kupont küldünk",
  "text84": "összegben",
  "text85": "A kupon érvényessége ettől",
  "text86": "eddig",
  "text87": "Feliratkozás a hírlevélre",
  "text88": "kattintson az alábbi gombra a hírlevélre való feliratkozáshoz.",
  "text89": "Erősítse meg a hírlevélre való feliratkozást",
  "text90": "A tételek megerősítése",
  "text91": "Az Ön által visszaküldött terméket megkaptuk. Köszönjük. A pénz visszatérítés úton van. A pénzviszatérítés módja függ a megrendelésben választott fizetés módjától.",
  "text92": "Amennyiben a felhasználói fiókjából bejelentett termékre vonatkozó adatai eltérnek  a visszaküldött terméktől, fenntartjuk a jogot, hogy a már kifizetett összeggel újból megterheljük a hitelkártyáját.",
  "text93": "Vegyék figyelembe kérem, hogy minden visszaküldött csomag külön van feldolgozva. Ha esetleg más csomagban is küldtek vissza termékek, különálló megerősítést fog kapni róla.",
  "text94": "Visszaküldött termékek:",
  "text95": "kattintson az alábbi gombra a jelszó visszaállításához.",
  "text96": "Jelszó visszaállítása",
  "text97": "A megrendelés kifizetése nem megfelelően történt",
  "text98": "Megismételheti a fizetést",
  "text99": "A linkre kattintva át írányítjuk a fizetési átjáróhoz.",
  "text100": "Köszönjük a vásárlást",
  "text101": "Kérdés",
  "text102": "Kérdés a termékről:",
  "text103": "Kérvény a visszaküldéshez",
  "text104": "megkaptuk a kérvényét a visszaküldéshez. Elkezdheti készíteni a csomagot.",
  "text105": "A visszaküldött áru kézhezvételét követően haladéktalanul, de legkésőbb 14 napon belül visszatérítjük a pénzét.",
  "text106": "Előleg fizetéssel rendeltél árut? Ha még nem fizetett az áruért, úgy módosítjuk a fizetendő összeget, hogy az ne tartalmazza az Ön által visszaküldött árut.",
  "text107": "Visszatéríti:",
  "text108": "Megrendelés száma",
  "text109": "Követelését törölték",
  "text110": "Az Ön követelése nem került jóváhagyásra",
  "text111": "Indok",
  "text112": "Az Ön követelését feldolgozzuk",
  "text113": "Kiállította",
  "text114": "Oldal 1/1",
  "text115": "Jelszó megváltoztatása",
  "text116": "Számla",
  "text117": "Szállító",
  "text118": "Művelet",
  "text119": "Vevő",
  "text120": "Telefonszám",
  "text121": "Számla kelte",
  "text122": "Kézbesítés dátuma",
  "text123": "Fizetési határidő",
  "text124": "Fizetés módja",
  "text125": "Szállítás módja",
  "text126": "SWIFT",
  "text127": "Fizetési díj",
  "text128": "Termék/ Kód",
  "text129": "Alapár/ Kedvezmény",
  "text130": "Áfa",
  "text131": "Mennyiség",
  "text132": "Bruttó érték",
  "text133": "Egységár ÁFÁ-val",
  "text134": "Szállítási költség",
  "text135": "Adó bizonylat a beérkezett fizetésről",
  "text136": "Nettó érték",
  "text137": "Összesen ÁFÁ-val együtt",
  "text138": "Összesen",
  "text139": "Állandó szimbólum",
  "text140": "Fizetendő összeg",
  "text141": "Hiteljegy",
  "text142": "számla számhoz",
  "text143": "Fuvarlevél",
  "text144": "Fuvalevél száma:",
  "text145": "Eladta",
  "text146": "Átvette",
  "text147": "Dátum",
  "text148": "ÁFA  adatok (HUF)",
  "text149": "ÁFA",
  "text150": "Termékek",
  "text151": "Számla sz:",
  "text152": "Adatok (HUF)",
  "text153": "Szállítás",
  "text154": "Megrendelések",
  "text155": "Megrendelés száma",
  "text156": "Vásárló",
  "text157": "Cím",
  "text158": "Fizetés",
  "text159": "Előlegszámla sz.",
  "text160": "Kezdőlap",
  "text161": "Blog",
  "text162": "Keresett kifejezés...",
  "text163": "Bevásárló kosár",
  "text164": "Ára",
  "text165": "Összesen",
  "text166": "Kosár frissítése",
  "text167": "Kedvezmény kupon",
  "text168": "Elküldeni a megrendelést",
  "text169": "Megrendelés összegzése",
  "text170": "A termék ára",
  "text171": "A bevásárló kosár üres",
  "text172": "Bevásárolni",
  "text173": "termékekből",
  "text174": "Szűrő",
  "text175": "Gyártó",
  "text176": "Kategória",
  "text177": "Legolcsóbb",
  "text178": "Legdrágább",
  "text179": "Legújabb",
  "text180": "Legrégibb",
  "text181": "Legeladottabb",
  "text182": "Iratkozzon fel",
  "text183": "Az Ön e-mail címe",
  "text184": "Iratkozz fel hírlevelünkre most, és élvezzd az exkluzív előnyöket!",
  "text185": "Elküldeni",
  "text186": "Kapcsolat",
  "text187": "Jelszó módosítása",
  "text188": "Elfelejtette a jelszavát?",
  "text189": "Bejelentkezni",
  "text190": "Bejelentkezés",
  "text191": "Jelszó",
  "text192": "Regisztrálni",
  "text193": "Még nincs fiókja?",
  "text194": "Oops...a keresett oldal nem létezik",
  "text195": "Gyártók",
  "text196": "További termékek megtekintése",
  "text197": "Fiókom",
  "text198": "Személyes adatok",
  "text199": "Vállalati adatok",
  "text200": "Cég",
  "text201": "Elmenteni",
  "text202": "Régi jelszó",
  "text203": "Új jelszó",
  "text204": "Jelszó megváltoztatása",
  "text205": "Teljes cikk",
  "text206": "Megrendelését elfogadtuk, a fizetés sajnos nem sikerült. Kérjük, nézze meg e-mailjét a megrendelés állapotával kapcsolatos további információkért.",
  "text207": "Megrendelés kifizetése",
  "text208": "Folytatni a vásárlást",
  "text209": "Érdekelheti Önt",
  "text210": "Megvenni",
  "text211": "Keresés",
  "text212": "Tétel/ek",
  "text213": "Keresés",
  "text214": "Kézbesítés másnap",
  "text215": "Magyarországon belül",
  "text216": "Ingyen ajándék",
  "text217": "Minden megrendeléshez",
  "text218": "Kézbesítési garancia",
  "text219": "sértetlen árú",
  "text220": "300 kiadóhely",
  "text221": "Szlovákia és Csehország területén",
  "text222": "Legújabb termékek",
  "text223": "Top termékek",
  "text224": "Top olvasmányok",
  "text225": "Ára ÁFÁ-val",
  "text226": "Ára Áfa nélkül",
  "text227": "Kosárba helyezni",
  "text228": "Termék kódja:",
  "text229": "Megosztani",
  "text230": "Kategória:",
  "text231": "Termék leírás",
  "text232": "Kiegészítők",
  "text233": "További információ",
  "text234": "Már feliratkozott a hírlevélre",
  "text235": "Folytatni a vásárlást",
  "text236": "Sikeresen feliratkozott a hírlevélre",
  "text237": "Elérhetőseg:",
  "text238": "Raktáron",
  "text239": "Rendelésre",
  "text240": "Rólunk",
  "text241": "Szűrő",
  "text242": "termékek",
  "text243": "Sorrend",
  "text244": "Szűrő visszaállítása",
  "text245": "Megrendelés állapota",
  "text246": "Vissza",
  "text247": "Méret:",
  "text248": "darab",
  "text249": "HUF",
  "text250": "Avatar módosítása",
  "text251": "Sikeresen bejelentkezett",
  "text252": "Férfi",
  "text253": "Nő",
  "text254": "Más",
  "text255": "Nem",
  "text256": "Szia",
  "text257": "Megrendeléseim",
  "text258": "Kijelentkezni",
  "text259": "Adja meg az email címét",
  "text260": "Állandó bejelentkezés",
  "text261": "Regisztráció",
  "text262": "Új fiók regisztrációja",
  "text263": "Jelszó ismétlése",
  "text264": "Egyetértek az",
  "text265": "üzleti feltételekkel",
  "text266": "Már van fiókom és szertenék bejelentkezni",
  "text267": "Információk a cookie-król",
  "text268": "Az Elfogadom gombra kattintva technikai, elemző és marketing cookie-k kerülnek tárolásra, hogy lehetővé tegyük Önnek az oldal kényelmes használatát, mérjük oldalunk funkcionalitását és célozhassuk meg Önt a reklámokkal. A Cookie-beállítások lehetőségre kattintva könnyedén módosíthatja beállításait.",
  "text269": "Elfogadom",
  "text270": "Cookie-beállítások",
  "text271": "Beállítások mentése",
  "text272": "Bezárni",
  "text273": "Cookie",
  "text274": "Leírás",
  "text275": "Cookie-kat használunk",
  "text276": "Cookie-kat használunk a látogatóink adatainak elemzésére, weboldalaink fejlesztésére, személyre szabott tartalom megjelenítésére és nagyszerű internetes élmény biztosítására. A weboldal használatával Ön hozzájárul ehhez a használathoz.",
  "text277": "Műszaki cookie-k",
  "text278": "Ezek a cookie-k szükségesek a weboldal működéséhez, ezért letiltása nem lehetséges. Általában a webhelyen saját maga által végrehajtott műveletekre reagálnak, mint például a biztonság beállítása, a bejelentkezés és az űrlapok kitöltése. Beállíthatja böngészőjét, hogy blokkolja a cookie-kat, vagy értesítést küldjön azokról. Ne feledje, hogy egyes oldalak nem működnek e fájlok nélkül. Ezek a cookie-k nem tárolnak olyan információt, amely egy adott személyhez rendelhető. Ezeket a cookie-kat mi vagy harmadik fél szolgáltató állíthatja be, amelynek szolgáltatásait a weboldalon használjuk. Ezek a cookie-k nem tárolnak olyan információt, amely egy adott személyhez rendelhető.",
  "text279": "Az Ön cookie-beállításai ebből a párbeszédpanelből",
  "text280": "Analitikai cookie-k",
  "text281": "Ezeket a cookie-kat a weboldal működésének javítására használjuk. Lehetővé teszik számunkra, hogy felismerjük és nyomon kövessük a látogatók számát, és nyomon kövessük, hogyan használják a látogatók a weboldalt. Segítenek nekünk a webhely működésének javításában, például azáltal, hogy megkönnyítik a felhasználók számára, hogy megtalálják, amit keresnek. Ezek a cookie-k nem gyűjtenek olyan információkat, amelyek alapján azonosítható lenne. Ezeket az eszközöket weboldalaink működésének elemzésére és rendszeres fejlesztésére használjuk. A kapott statisztikákat felhasználhatjuk a felhasználói kényelem javítására, valamint arra, hogy a Weboldal látogatását érdekesebbé tegyük Ön, mint felhasználó számára.",
  "text282": "Google Analytics – tárolja és kiszámítja az oldalmegtekintések számát és a webhely viselkedését",
  "text283": "Google Tag Manager – linkkonverziók",
  "text284": "Incomaker – tárolja és kiszámítja az oldalmegtekintéseket és a konverziókat",
  "text285": "Marketing cookie-k",
  "text286": "A felhasználó webes preferenciáinak nyomon követésére szolgálnak hirdetési célzás céljából, azaz olyan marketing- és hirdetési közlemények megjelenítésére (harmadik fél webhelyein is), amelyek a weblátogató érdeklődésére tarthatnak számot, ezen preferenciáknak megfelelően. A marketing cookie-k külső cégek eszközeit használják. Ezeket a marketing cookie-kat csak az Ön hozzájárulásával használjuk fel.",
  "text287": "Facebook Pixel - hirdetések megjelenítése és információk továbbítása a Facebookra",
  "text288": "Feltölteni",
  "text289": "Árúcsere",
  "text290": "Pénzvisszatérítés",
  "text291": "Vásárló adatai",
  "text292": "Számlaszám",
  "text293": "Banki adatok",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Visszaküldés oka",
  "text297": "Válassza ki a listából a visszaküldeni kívánt árut",
  "text298": "E-shop",
  "text299": "Üzlet",
  "text300": "E-shop + Üzlet",
  "text301": "Megkaptuk visszaküldési kérelmét. Elkezdheti a csomag elkészítését.",
  "text302": "A visszaküldött áru kézhezvétele után azonnal, de legkésőbb 14 napon belül visszatérítjük a pénzét.",
  "text303": "Előleg fizetéssel rendeltél árut? Ha még nem fizetett az áruért, úgy módosítjuk a fizetendő összeget, hogy az ne tartalmazza az Ön által visszaküldött árut.",
  "text304": "Visszatéríti:",
  "text305": "Megrendelés száma:",
  "text306": "Az Ön által visszaküldött terméket megkaptuk. Köszönjük. A pénz visszatérítés úton van. A pénzviszatérítés módja függ a megrendelésben választott fizetés módjától.",
  "text307": "Amennyiben a felhasználói fiókjából bejelentett termékekre vonatkozó adatai eltérnek a visszaküldött termékektől, úgy fenntartjuk a jogot, hogy a már kifizetett összeggel újból megterheljük hitelkártyáját.",
  "text308": "Vegyék figyelembe kérem, hogy minden visszaküldött csomag külön van feldolgozva. Ha esetleg más csomagban is küldtek vissza termékek, különálló megerősítést fog kapni róla.",
  "text309": "Visszaküldött termék",
  "text310": "Új",
  "text311": "Jóváhagyott",
  "text312": "Elutasítva",
  "text313": "Törölve",
  "text314": "Folyamatban",
  "text315": "Kérvény a visszaküldéshez",
  "text316": "A tételek megerősítése",
  "text317": "Követelését törölték",
  "text318": "Az Ön követelését feldolgozzuk",
  "text319": "Az Ön követelése nem került jóváhagyásra",
  "text320": "Az Ön kérvénye nem lett feldolgozva",
  "text321": "Feliratkozás a hírlevélre",
  "text322": "aru-csere-es-visszakuldes",
  "text323": "Áru csere és visszaküldés",
  "text324": "Cég adatai",
  "text325": "Az Ön e-shopjának domainje",
  "text326": "Új domain hozzáadása",
  "text327": "Egyéb domainek",
  "text328": "Cégnév",
  "text329": "Üzleti cím megadása",
  "text330": "Üzleti címe",
  "text331": "Üzlet neve",
  "text332": "Felhasználónév",
  "text333": "Mellékletek",
  "text334": "Cégbizonylat",
  "text335": "Válassza ki a mellékletet",
  "text336": "Egyetértek az üzleti feltételekkel",
  "text337": "Alkategóriák",
  "text338": "Mutass többet",
  "text339": "Elérhetőség",
  "text340": "Ár",
  "text341": "Szűrni szerint",
  "text342": "Az Ön által kiválasztott termék kosárba lett helyezve.",
  "text343": "Kosár",
  "text344": "Fizetési ár",
  "text345": "Szállítási ár",
  "text346": "Válasszon szállítási módot",
  "text347": "Kupon száma",
  "text348": "Válasszon fizetési módot",
  "text349": "Ingyenes",
  "text350": "Megrendelés összefoglalása",
  "text351": "Termék ára",
  "text352": "A rendelést elküldtük",
  "text353": "Az Ön megrendelés száma:",
  "text354": "be lett jegyezve és előkészítjük. Kérem ellenőrizze az Ön email címét.",
  "text355": "a megrendeléssel kapcsolatos további információkért",
  "text356": "Jelszó megerősítése",
  "text357": "Jelentkezzen be",
  "text358": "Van fiókja?",
  "text359": "Szállítási adatok",
  "text360": "Elérhetőségi adatok",
  "text361": "Vásárlás a cég számára",
  "text362": "Hozzon létre fiókot és használja a regisztrált felhasználó előnyeit.",
  "text363": "Egyetértek az üzleti feltételekkel",
  "text364": "Egyetértek a személyes adatok védelmével.",
  "text365": "A kézbesítési cím különbözik a számlázási címtól",
  "text366": "Dropshipping",
  "text367": "Az üzlet címe",
  "text368": "Személyes adatok beállításai",
  "text369": "Szállítási cím módosítása",
  "text370": "Folytassa a pénztárhoz",
  "text371": "Iratkozzon fel a hírekre és értesüljön az aktuális akciókról",
  "text372": "Áru visszaküldése",
  "text373": "Visszaküldött termék",
  "text374": "Mit szeretne visszaküldeni?",
  "text375": "Az elmúlt 30 napban nem rendelt semmit.",
  "text376": "Megerősíteni a termék visszaküldését",
  "text377": "Törölni",
  "text378": "én-fiókom-visszaküldött-termék",
  "text379": "én-fiókom-visszaküldött-termék-1",
  "text380": "én-fiókom-visszaküldött-termék-2",
  "text381": "én-fiókom-viszaküldött-termék-3",
  "text382": "Szlovákia",
  "text383": "Csehország",
  "text384": "Magyarország",
  "text385": "Bejelentkezési adatok",
  "text386": "Olvasni",
  "text387": "Az Ön kosarában",
  "text388": "Az elfelejtett jelszó megújításához adja meg az email címét",
  "text389": "Születés dátuma",
  "text390": "Használni",
  "text391": "/altalanos-uzleti-feltetelek",
  "text392": "/szemelyes-adatok-vedelme",
  "text393": "Megrendelés dátuma",
  "text394": "Megrendelés száma:",
  "text395": "Válassza ki az okot",
  "text396": "A termék nem felel meg a leírásnak",
  "text397": "Nem megfelelő terméket kaptam",
  "text398": "Ez a termék nem tetszik nekem",
  "text399": "A tétel túl nagy",
  "text400": "A termék sérült",
  "text401": "A termék későn érkezett",
  "text402": "A termék kicsi",
  "text403": "A termék elég drága",
  "text404": "Semmilyen részlet",
  "text405": "Visszaküldeni",
  "text406": "cégek tárgya/i",
  "text407": "Termékek, melyeket visszaküld a cégnek",
  "text408": "Elküldtük Önnek a visszaküldött termékek áttekintését a",
  "text409": "Az Ön termékei készen állnak a visszatérítéshez",
  "text410": "Hogyan tovább?",
  "text411": "Készítse el a csomagot",
  "text412": "Most elég elküldeni a csomagot",
  "text413": "Kapja vissza a pénzét",
  "text414": "Csomagolja be a terméket, ragasszon rá címkét és küldje vissza a megadott címre.Tudta, hogy több terméket is visszaküldhet egy csomagban? Egyszerűen mellékelje az egyes rendelésekhez tartozó visszaküldési címkéket",
  "text415": "Vigye a csomagot a legközelebbi logisztikai központba, amelyet az űrlapon kiválasztott",
  "text416": "A visszaküldött áru kézhezvétele után azonnal, de legkésőbb azt követően 14 napon belül visszatérítjük a pénzét. Előre fizetéssel rendeltél árut? Ha még nem fizette ki az árut, úgy módosítjuk a fizetési összeget, hogy az ne tartalmazza az Ön által visszaküldött árut",
  "text417": "Termékek száma",
  "text418": "Visszaküldeni a cégnek",
  "text419": "Állapot",
  "text420": "Létrehozás napja",
  "text421": "Nincsenek visszaküldött tételei.",
  "text422": "Állítsa be IBAN-ját és SWIFT-jét a fiókbeállításokban.",
  "text423": "Nincsenek beállítva banki adatok",
  "text424": "Vásároljon még",
  "text425": "és a szállítás",
  "text426": "INGYENES",
  "text427": "Gratulálunk, a szállítása",
  "text428": "Az Ön üzenete sikeresen el lett küldve!",
  "text429": "Hiba, az Ön üzenete nem lett elküldve!",
  "text430": "",
  "text431": "Email létezik: kérem használjon  másikat.",
  "text432": "A regisztráció sikeres",
  "text433": "Variant kód",
  "text434": "én-fiókom-visszaküldeni-terméket-1",
  "text435": "Eladó egység",
  "text436": "Személyes adatok védelme",
  "text437": "Címkék",
  "text438": "Utca szám",
  "text439": "Betöltöm",
  "text440": "Válassza ki a gyűjtőpontot",
  "text441": "Válasszon variánst",
  "text442": "Hozzáadás a kedvencekhez",
  "text443": "ÁFA nélkül",
  "text444": "Az ár tájékoztató jellegű",
  "text445": "Nincsenek tételek",
  "text446": "Termék kérdés",
  "text447": "Vélemények",
  "text448": "További szolgáltatások",
  "text449": "Csomagok",
  "text450": "Elküldeni",
  "text451": "Videó",
  "text452": "Teljes leírás",
  "text453": "Sajnos ebből a termékből csak korlátozott mennyiség van raktáron",
  "text454": "már nem helyezhet be termékeket a kosárba.",
  "text455": "OK",
  "text456": "Menj a kosárba",
  "text457": "",
  "text458": "A bevásárló kosara várja Önt",
  "text459": "Utolsó látogatása során nem fejezte be megrendelését. A kiválasztott áru a kosaradban vár. Ne hagyja ki, és fejezze be a vásárlást most.",
  "text460": "Megrendelése sikeresen megérkezett. Kérjük, ellenőrizze e-mail postafiókját.",
  "text461": "Üzenete sikeresen elküldve!",
  "text462": "Az e-mail cím megadása kötelező.",
  "text463": "A megadott e-mail cím nem érvényes.",
  "text464": "Az e-mail legfeljebb 255 karakterből állhat.",
  "text465": "A megadott e-mail már regisztrálva van.",
  "text466": "A jelszó kötelező adat.",
  "text467": "A jelszónak legalább 6 karakterből kell állnia.",
  "text468": "A jelszavak nem egyeznek.",
  "text469": "Az üzleti feltételek elfogadása kötelező.",
  "text470": "Ellenőrizze a captcha űrlapot.",
  "text471": "Az online súgó megnyitása",
  "text472": "Kérdések és válaszok témák megtekintése",
  "text473": "Kérdések és válaszok elrejtése",
  "text474": "Tovább a blogra",
  "text475": "Tanácsadó szoba",
  "text476": "Kérdezze közvetlenül gyógyszerészünket",
  "text477": "Nincsenek lehetőségek",
  "text478": "Kategóriák kiválasztása",
  "text479": "több mint",
  "text480": "Vissza a boltba",
  "text481": "Ár / db ÁFÁ-val együtt",
  "text482": "Teljes ár",
  "text483": "Ár / db ÁFA nélkül",
  "text484": "",
  "text485": "Házszám",
  "text486": "Profil",
  "text487": "Adatok módosítása",
  "text488": "Biztonság",
  "text489": "Helyváltoztatás",
  "text490": "Betölteni a következőt",
  "text491": "Adataim",
  "text492": "Kövessen minket",
  "text493": "Legjobban eladott",
  "text494": "Minden termék",
  "text495": "Nem elérhető",
  "text496": "Válasszon egy változatot",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Teljes név",
  "text503": "Erősítse meg az új jelszót",
  "text504": "Kérjük, erősítse meg, hogy egyetért a személyes adatok védelmével.",
  "text505": "A megadott e-mail cím már feliratkozott a hírek fogadására.",
  "text506": "Kérjük, ellenőrizze e-mail postafiókját.",
  "text507": "Kiadóhely",
  "text508": "Termék érdeklődés",
  "text509": "Kérdés a termék elérhetőségéről",
  "text510": "Speciális ajánlatt",
  "text511": "Szélesség",
  "text512": "Hosszúság",
  "text513": "Magasság",
  "text514": "Súly",
  "text515": "Értékelve e napon",
  "text516": "Kedvelt",
  "text517": "Vissza a főoldalra",
  "text518": "Termék állapota",
  "text519": "Ország",
  "text520": "Szállítási és számlázási adatok",
  "text521": "Vásárolt már nálunk?",
  "text522": "Vissza a kosárba",
  "text523": "Kedvezmény kupon",
  "text524": "Hozzáadás a rendeléshez",
  "text525": "A bevásárlókosár tartalma",
  "text526": "A rendelés folytatása",
  "text527": "Megosztani a terméket",
  "text528": "Elrejteni a leírást",
  "text529": "Teljes leírás",
  "text530": "Hiba történt. Kérjük, próbálja újra egy pillanat múlva.",
  "text531": "Add hozzá a kedvencekhez",
  "text532": "Eltávolítás a kedvencekből",
  "text533": "Részlet",
  "text534": "Új foglalás",
  "text535": "A foglalás sikeresen létrejött",
  "text536": "Fizetési kedvezmény",
  "text537": "Leiratkozás",
  "text538": "Válasszon egy kifejezést",
  "text539": "Előfizetés helye",
  "text540": "Lejárat",
  "text541": "Kedvezmény az ügyfél számára",
  "text542": "Összesen feladott rendelés száma",
  "text543": "Megrendelés száma",
  "text544": "Nem bejelentkezett felhasználó",
  "text545": "A kupon érvényes",
  "text546": "A kupon nem létezik, lejárt vagy a kupon alkalmazásának feltételei nem teljesülnek.",
  "text547": "A kupon érvénytelen",
  "text548": "A kupon hozzá lett adva",
  "text549": "Válasz a következő címre",
  "text550": "Erre a kérdésre a következő válaszolt",
  "text551": "Kérdés feltevése",
  "text552": "Név",
  "text553": "Be kell jelentkeznie ahhoz, hogy saját kérdést tegyen fel a tanácsadás szekcióban.",
  "text554": "Nem találtunk megfelelő bejegyzést",
  "text555": "Ma van a névnapja",
  "text556": "Figyelem",
  "text557": "Helytelen bejelentkezési adatok",
  "text558": "Az eredeti jelszó nem egyezik",
  "text559": "Érdeklődés egy állás iránt",
  "text560": "Új jelentkező",
  "text561": "Köszönjük megrendelését, melynek feldolgozását fizetés után azonnal megkezdjük.",
  "text562": "Sikeres fizetés.",
  "text563": "Fizetés meghiúsult.",
  "text564": "A Captcha ellenőrzése nem sikerült.",
  "text565": "Nincsenek paraméterek",
  "text566": "Termékszűrő",
  "text567": "tanácsra van szükségem",
  "text568": "Kapcsolatfelvétel és támogatás",
  "text569": "Lépjen kapcsolatba velünk",
  "text570": "Kövessen minket a közösségi hálózatokon",
  "text571": "Szállítás és fizetés",
  "text572": "Hűségprogram",
  "text573": "Hiba történt a hírlevélre való feliratkozás során",
  "text574": "Feliratkozás a hírekre e-mailben",
  "text575": "Szeretnél az elsők között értesülni az akciókról és kedvezményekről? Csak írja be az e-mail címét.",
  "text576": "Köszönjük, hogy feliratkozott a hírlevélre. A regisztrációs visszaigazolást elküldtük az Ön e-mail címére.",
  "text577": "Cikkek",
  "text578": "Online chat",
  "text579": "Online konzultáció",
  "text580": "Terméktanácsadás",
  "text581": "Gyakran Ismételt Kérdések",
  "text582": "Személyes átvétel",
  "text583": "hírek",
  "text584": "Műveletek",
  "text585": "Írja meg a véleményét",
  "text586": "Felülvizsgálat",
  "text587": "Értékelés",
  "text588": "További cikkek megtekintése",
  "text589": "Témák",
  "text590": "Keressen egy cikket",
  "text591": "Olvassa el a teljes cikket",
  "text592": "Közzétett",
  "text593": "Vélemény írásához be kell jelentkeznie.",
  "text594": "Valami elromlott",
  "text595": "Próbáld újra",
  "text596": "Válasz elrejtése",
  "text597": "Mutasd a választ",
  "text598": "Népszerű cikkek",
  "text599": "Kategóriák szűrése",
  "text600": "Vissza a blogok oldalára",
  "text601": "Találja meg álmai munkáját!",
  "text602": "Szállítási ország",
  "text603": "A szállítási országot az előző lépésben módosíthatja",
  "text604": "Mutass kevesebbet",
  "text605": "",
  "text606": "maximális",
  "text607": "Kiválogattunk Önnek",
  "text608": "Nincs vélemény",
  "text609": "Szeretnék e-mailben kapni híreket az aktuális trendekről, akciókról és kedvezményes kuponokról. Bármikor ingyenesen leiratkozhat.",
  "text610": "Feliratkozás a hírekre",
  "text611": "Tanácsra van szüksége?",
  "text612": "Lépjen kapcsolatba velünk:",
  "text613": "Egyetértek",
  "text614": "személyes adatok kezelése",
  "text615": "Üzenet",
  "text616": "Üzleti adatok",
  "text617": "Forgalmi adatok",
  "text618": "Kereskedelmi nyilvántartás",
  "text619": "A bank neve",
  "text620": "Ha még nem vásárolt nálunk, és nincs fiókja, hozzon létre egyet itt",
  "text621": "hozzon létre egyet itt",
  "text622": "elfelejtettem a jelszavamat",
  "text623": "Már van fiókod?",
  "text624": "Belépés.",
  "text625": "A fiók regisztrálásával Ön elfogadja a miénket",
  "text626": "használati feltételek.",
  "text627": "Olvassa el a miénket",
  "text628": "Személyes adatok védelmére vonatkozó szabályzat.",
  "text629": "Igen, szeretnék alkalmanként különleges ajánlatokat tartalmazó e-maileket kapni. Az előfizetésemet bármikor lemondhatom. (Választható)",
  "text630": "A jelszónak legalább 8 karakterből kell állnia.",
  "text631": "Hozzáadva a kosárhoz",
  "text632": "Takarítani",
  "text633": "Minden blog",
  "text634": "Eredmények mutatása",
  "text635": "Írj egy kérdést",
  "text636": "A szakember válaszának megjelenítése",
  "text637": "Ebben a kategóriában még nincsenek kérdések",
  "text638": "Vissza a tanácsadó iroda főoldalára",
  "text639": "Ő hozta létre a projektet",
  "text640": "Minden jog fenntartva.",
  "text641": "Szállítási és fizetési mód",
  "text642": "Kérdése akkor jelenik meg, ha azt egy rendszergazda jóváhagyta",
  "text643": "Köszönjük",
  "text644": "vagy írj ide",
  "text645": "Aktiválja a kedvezmény kódot",
  "text646": "Kupon kód",
  "text647": "Alkalmazza a kedvezménykódot",
  "text648": "Egy vélemény került hozzáadásra",
  "text649": "A jelszó sikeresen megváltozott",
  "text650": "Nem sikerült megváltoztatni a jelszót",
  "text651": "Hiba történt a jelszó visszaállítása közben",
  "text652": "Jelszó-visszaállítási e-mailt kapott",
  "text653": "Hiba történt a regisztráció során",
  "text654": "Sikeresen regisztráltál",
  "text655": "Hiba történt a bejelentkezéskor",
  "text656": "Ön bejelentkezett",
  "text657": "Hiba történt a kapcsolatfelvételi űrlap elküldése közben",
  "text658": "A kapcsolatfelvételi űrlapot sikeresen elküldtük",
  "text659": "Kérdését sikeresen elküldtük",
  "text660": "Hiba történt a kérdés elküldésekor",
  "text661": "Hiba történt a vélemény létrehozásakor",
  "text662": "Ár / db",
  "text663": "Együtt",
  "text664": "Ajándék",
  "text665": "Kövess minket Instagramon",
  "text666": "Instagram megtekintése",
  "text667": "A szín rossz formátumú.",
  "text668": "több..",
  "text669": "megvesz",
  "text670": "Mutasd az összes terméket",
  "text671": "Blogok",
  "text672": "Nincsenek címkék",
  "text673": "Nincsenek blogok",
  "text674": "Nincsenek kategóriák",
  "text675": "Részösszeg",
  "text676": "Vásárolt már nálunk?",
  "text677": "Ha már vásárolt nálunk, jelentkezzen be fiókjába a rendelési adatok automatikus kitöltéséhez és a rendelés teljesítésének felgyorsításához.",
  "text678": "Új vásárló vagyok",
  "text679": "Számlázási információ",
  "text680": "Sérült termék",
  "text681": "Nem megfelelő ajándék",
  "text682": "nem akarom kijelenteni",
  "text683": "Válassz egy okot",
  "text684": "futár",
  "text685": "Visszaküldött termékek:",
  "text686": "Törölje a visszaküldést",
  "text687": "Erősítse meg a termék visszaküldését",
  "text688": "Cég címe",
  "text689": "Cég Részletek",
  "text690": "NYITVATARTÁSI IDŐ",
  "text691": "Ellenőrizd az elérhetőséget",
  "text692": "E-recept",
  "text693": "Foglalás e-recept",
  "text694": "Hűségkártyák",
  "text695": "kártyát szeretnék",
  "text696": "van egy kártyám",
  "text697": "Azonosító szám",
  "text698": "A telefon elengedhetetlen a foglalás állapotáról való tájékoztatáshoz",
  "text699": "Szükségünk van a társadalombiztosítási számára a recept ellenőrzéséhez",
  "text700": "Receptfoglalás benyújtása",
  "text701": "Válasszon várost",
  "text702": "Hűségkártya száma",
  "text703": "Termék név",
  "text704": "Adja meg a termék nevét/vonalkód számát",
  "text705": "Keresés név vagy vonalkód alapján - számok a termék vonalkódja alatt",
  "text706": "Egyedi gyártású termék",
  "text707": "Írj dedikációt...",
  "text708": "Válasszon kiszállítási dátumot",
  "text709": "További alkategóriák megjelenítése",
  "text710": "Alkategóriák elrejtése",
  "text711": "Van egy papír receptem",
  "text712": "Állítsa be az IBAN-t és a SWIFT-et is a fiókbeállításokban",
  "text713": "Sikeresen regisztráltuk a visszaküldést",
  "text714": "Visszaküldött rendelések",
  "text715": "Áruk visszaigénylése",
  "text716": "A visszaküldés dátuma",
  "text717": "Letöltés",
  "text718": "Szállítók",
  "text719": "Termék információ",
  "text720": "Termék ára",
  "text721": "Menj az üzletbe",
  "text722": "A követelés állapotának változása",
  "text723": "Csak olyan formátumot tartalmazhat, ahol maximum 4 szám van a tizedesvessző előtt és 8 a tizedesvessző után.",
  "text724": "Ahol mindenhol voltunk",
  "text725": "Tovább a főoldalra",
  "text726": "Adja meg a rendelés számát és e-mail címét",
  "text727": "Link",
  "text728": "A szállító helye",
  "text729": "A karakterek minimális száma",
  "text730": "A karakterek maximális száma",
  "text731": "Ez a mező nem lehet üres",
  "text732": "Az e-mail címnek érvényesnek kell lennie",
  "text733": "A telefonszámnak érvényesnek kell lennie",
  "text734": "Ez a mező kötelező",
  "text735": "A dátumnak érvényesnek kell lennie",
  "text736": "A beírt bevitelnek számnak kell lennie",
  "text737": "A megadott bevitelnek egész számnak kell lennie",
  "text738": "A beírt bevitelnek decimális számnak kell lennie",
  "text739": "A jelszavak nem egyeznek",
  "text740": "El kell fogadnia a GDPR-t",
  "text741": "El kell fogadnia a használati feltételeket",
  "text742": "Legalább egy terméket ki kell választania",
  "text743": "Adja meg a juttatási kártya adatait vagy a nevét",
  "text744": "Kapcsolódó termékek",
  "text745": "Connecté en tant que",
  "text746": "Keresés",
  "text747": "Kulcsszó",
  "text748": "Távolság",
  "text749": "Kategória",
  "text750": "Kötelező mezők",
  "text751": "Forduljon hozzánk bármikor, ha bármilyen különleges kérése van, vagy bármilyen kérdése van.",
  "text752": "Nincs eredmény",
  "text753": "A kiválasztott napok nem elérhetők",
  "text754": "Beállítani",
  "text755": "Fiók törlése",
  "text756": "Üzleti",
  "text757": "Ha kapcsolatba kell lépnünk Önnel a megrendelésével kapcsolatban.",
  "text758": "Hozzon létre egy fiókot",
  "text759": "A kiválasztott távolságon belül nincsenek beszállítók",
  "text760": "Válasszon beszállítót",
  "text761": "Város kiválasztása",
  "text762": "Adja meg számlázási címét, hogy ne kelljen minden alkalommal megtennie, amikor megrendeli.",
  "text763": "A nagykereskedelmi űrlap kitöltéséhez be kell jelentkeznie.",
  "text764": "Nagykereskedelem",
  "text765": "Gratulálunk! Ön már regisztrált nagykereskedő.",
  "text766": "A vállalat típusa és a domainek",
  "text767": "Kapcsolattartási információk",
  "text768": "Maximális fájlméret 2MB",
  "text769": "Dropshipping",
  "text770": "Rendelés készletre",
  "text771": "Dropship szállítási cím",
  "text772": "Személyes és kapcsolattartási adatok",
  "text773": "Szállítási cím",
  "text774": "Az űrlapot sikeresen elküldtük. A lehető leghamarabb felvesszük Önnel a kapcsolatot a nagykereskedelmi feltételekkel kapcsolatban.",
  "text775": "Helymeghatározás engedélyezése",
  "text776": "Ki kell választani a szállítási dátumot",
  "text777": "Egy adott adagolási pontot kell kiválasztani.",
  "text778": "A csomag ára magasabb a megengedett értéknél.",
  "text779": "A csomag a következőket tartalmazza",
  "text780": "A csomagnak nincs maximális ára",
  "text781": "Adja meg az irányítószámát",
  "text782": "Adja meg a várost",
  "text783": "Számítsa ki az árat",
  "text784": "Küldje el a menhelyre",
  "text785": "Márka",
  "text786": "Kérdés a gyógyszerészhez",
  "text787": "Válaszolt a kérdésre",
  "text788": "Állásajánlatok",
  "text789": "Online tanácsadás",
  "text790": "Kérdések és válaszok elrejtése",
  "text791": "Kérdések és válaszok témák megtekintése",
  "text792": "Tudjon meg többet",
  "text793": "Minden ajánlat megtekintése",
  "text794": "Ajánlat részletei",
  "text795": "Munkahely",
  "text796": "Bruttó bér",
  "text797": "Foglalkoztatás",
  "text798": "Retrieved from",
  "text799": "További referenciák",
  "text800": "Hívjon minket",
  "text801": "Rendelkezésre állunk",
  "text802": "A vállalatról",
  "text803": "Elérhetőségek",
  "text804": "Dokumentumok megrendelése",
  "text805": "Ehhez a megrendeléshez nem állnak rendelkezésre dokumentumok",
  "text806": "Válasszon menedéket",
  "text807": "Részletek megtekintése",
  "text808": "Érdekel a végrehajtás",
  "text809": "z",
  "text810": "ajánlatok",
  "text811": "A  címről",
  "text812": "bruttó",
  "text813": "Érdekel a pozíció",
  "text814": "Önéletrajz feltöltése",
  "text815": "Érdeklődés küldése",
  "text816": "Részletfizetési kalkulátor",
  "text817": "Lásd az ajánlatot",
  "text818": "Konfigurátor",
  "text819": "Minden megvalósítás",
  "text820": "Hol talál minket",
  "text821": "Értékesítési osztály",
  "text822": "Értékesítési képviselők",
  "text823": "Jogi megjegyzés",
  "text824": "Lásd a műszaki paramétereket",
  "text825": "Kérjük, válassza ki a szállítási helyet",
  "text826": "Változatok",
  "text827": "Névnap van",
  "text828": "Letöltés",
  "text829": "Álláskeresés",
  "text830": "Népszerű kategóriák",
  "text831": "Találd meg a neked megfelelő munkát! A munka a vásárlás és a követelmények biztosítása után azonnal megkezdődik.",
  "text832": "nyitott pozíciók",
  "text833": "Önéletrajz készítése",
  "text834": "Hozzon létre profilt és találjon több ezer állást, építse karrierjét és\n  állást!",
  "text835": "Legújabb állásajánlatok",
  "text836": "Találd meg a neked megfelelő munkát! A munka a vásárlás és a követelmények biztosítása után azonnal megkezdődik.",
  "text837": "Önéletrajz küldése",
  "text838": "/ havonta",
  "text839": "Szükséges a menedékhely kiválasztása",
  "text840": "Menedékek, amelyeket velünk együtt támogathat",
  "text841": "18 év feletti vagyok",
  "text842": "Az oldal tartalma nem alkalmas személyek számára.",
  "text843": "18 év alattiak.",
  "text844": "Minden",
  "text845": "Csak új",
  "text846": "Csak használt",
  "text847": "Típus",
  "text848": "Év",
  "text849": "Modell",
  "text850": "Önéletrajzom",
  "text851": "Önéletrajz előnézet",
  "text852": "Fiók törlése",
  "text853": "Ha fiókja törlésre került, adatai nem állíthatók helyre.",
  "text854": "Fiók törlése",
  "text855": "Beállítások",
  "text856": "Szeretnék e-mailben állásajánlatokat kapni",
  "text857": "Kedvelt nyelv",
  "text858": "Tovább az összes állásajánlathoz",
  "text859": "CV",
  "text860": "Lépés",
  "text861": "Alapvető adatok",
  "text862": "Fényképezés",
  "text863": "Munkahelyi tapasztalat",
  "text864": "Oktatás",
  "text865": "Tudás",
  "text866": "Nyelvek",
  "text867": "További alkatrészek",
  "text868": "Végleges beállítások",
  "text869": "Keresés kulcsszó, cégnév alapján",
  "text870": "Önkormányzat, kerület, régió",
  "text871": "Retrieved from",
  "text872": "Utca és házszám",
  "text873": "Töltse fel a fényképét",
  "text874": "A fénykép nem kötelező, de a fényképes önéletrajz személyesebb, és jobban felkelti a felvételi tanácsadó figyelmét.\n  többet.",
  "text875": "Tudta, hogy átlagosan 7 másodpercbe telik, amíg egy toborzó először átfut egy önéletrajzot? Ezért csak a releváns tapasztalatokat említse meg, és azokat csak felsorolásszerűen vagy rövid bekezdésekben írja le.",
  "text876": "Pozíció megnevezése, vállalat",
  "text877": "Város vagy irányítószám",
  "text878": "Milyen végzettséggel rendelkezik?",
  "text879": "Tudassa a munkáltatókkal, hogy mi az Ön iskolai végzettsége",
  "text880": "Oktatás hozzáadása",
  "text881": "Állásajánlat",
  "text882": "Aktív ajánlatok",
  "text883": "Fókusz",
  "text884": "Főiskola",
  "text885": "Középiskola",
  "text886": "Tanfolyam vagy tanúsítvány",
  "text887": "Érdekel egy állás",
  "text888": "Az Ön készségei és ismeretei",
  "text889": "Adja meg, hogy milyen készségekkel és tudással rendelkezik, és milyen szinten.",
  "text890": "Szakma",
  "text891": "Beszélt nyelv",
  "text892": "A név mellett tüntesse fel a tudományos fokozatot",
  "text893": "Fizetés",
  "text894": "A foglalkoztatás típusa",
  "text895": "Állásajánlatra válaszadás",
  "text896": "Információk a szakmáról",
  "text897": "Önálló vállalkozó vagyok",
  "text898": "Választható mellékletek",
  "text899": "Önéletrajz, motivációs levél, nyilatkozatok, bizonyítványok, egyéb... (max. 10MB)",
  "text900": "Az Ön által beszélt nyelv",
  "text901": "Nyelv kiválasztása",
  "text902": "Cím",
  "text903": "Ország",
  "text904": "Válasszon egy országot",
  "text905": "Válasszon ki egy régiót",
  "text906": "A fájl maximális mérete 10MB",
  "text907": "Melléklet hozzáadása",
  "text908": "Csatolmányok száma",
  "text909": "Vezetői engedély",
  "text910": "Milyen jogosítványokkal rendelkezik?",
  "text911": "Mivel tölti a szabadidejét?",
  "text912": "Érdeklődési kör vagy hobbi",
  "text913": "Röviden és tömören írja le, hogyan szereti eltölteni a szabadidejét.",
  "text914": "Elkészült az önéletrajzod tartalma. Kérjük, add meg a következő információkat, amelyek segítenek majd az álláskeresésben a pracaslovensko.sk oldalon.",
  "text915": "Munkahely",
  "text916": "Milyen területen vagy milyen konkrét pozícióban szeretne dolgozni?",
  "text917": "Munkaterület",
  "text918": "Válasszon ki egy munkaterületet",
  "text919": "Munkahely",
  "text920": "Milyen helyen keres munkát?",
  "text921": "A foglalkoztatás típusa",
  "text922": "Kérjük, jelölje meg, hogy melyik munkaidő-típus felel meg Önnek.",
  "text923": "Érkezés dátuma",
  "text924": "Kérjük, adja meg a lehetséges érkezés dátumát",
  "text925": "Várható minimálbér (bruttó)",
  "text926": "Kérjük, adja meg az Ön elképzelését a minimálbérről (bruttó).",
  "text927": "Kedvelt munkaidő-beosztás",
  "text928": "Kérjük, adja meg a műszakokra vonatkozó preferenciáit",
  "text929": "Egészségügyi hátrány",
  "text930": "Hátrányos helyzetbe került a munkahelyén?",
  "text931": "Állásajánlatok e-mailben?",
  "text932": "Szeretné, ha e-mailben küldenénk Önnek megfelelő állásajánlatokat?",
  "text933": "Város/Megye",
  "text934": "Azonnal",
  "text935": "Megállapodás alapján",
  "text936": "A következő összeg (EUR)",
  "text937": "Olyan munka is érdekel, ahol hétvégén is dolgoznék",
  "text938": "Éjszakai munka is érdekel",
  "text939": "Munkával kapcsolatos fogyatékosságom van",
  "text940": "41% - 70%",
  "text941": "Több mint 70%",
  "text942": "További információk",
  "text943": "Szeretnék e-mailben állásajánlatokat kapni",
  "text944": "Személyes összefoglaló",
  "text945": "Írj magadról egy rövid összefoglalót 2-3 mondatban.",
  "text946": "További információk",
  "text947": "Szeretne még valamit hozzátenni? Írja ide.",
  "text948": "Fájlok beillesztése vagy áthelyezése ide",
  "text949": "PNG, JPG, GIF",
  "text950": "Fájl kiválasztása",
  "text951": "Munkahely hozzáadása",
  "text952": "Időzítés",
  "text953": "Job Description",
  "text954": "Röviden és tömören írja le a munkaköri leírását.",
  "text955": "Munkahely hozzáadása",
  "text956": "Munkakör",
  "text957": "Munkáltató",
  "text958": "Város/község",
  "text959": "Tájkép",
  "text960": "Időszak",
  "text961": "Jelenleg itt dolgozom",
  "text962": "A hónapból",
  "text963": "Mivel",
  "text964": "Egy hónapon belül",
  "text965": "Évenként",
  "text966": "Job Description",
  "text967": "Röviden és tömören írja le a munkaköri leírását.",
  "text968": "Főiskola",
  "text969": "Kar",
  "text970": "Részleg",
  "text971": "Középiskola",
  "text972": "Tanfolyam neve",
  "text973": "A vizsgálat leírása",
  "text974": "Röviden és tömören írja le tanulmányait",
  "text975": "Teljesen kezdő",
  "text976": "Az alapok",
  "text977": "Középszintű",
  "text978": "Haladó",
  "text979": "Szakértő",
  "text980": "Nyelv hozzáadása",
  "text981": "Tudás hozzáadása",
  "text982": "Teljesen kezdő (A1)",
  "text983": "Kezdő (A2)",
  "text984": "Középhaladó (B1)",
  "text985": "Középhaladó (B2)",
  "text986": "Haladó (C1)",
  "text987": "Szakértő (C2)",
  "text988": "Nyelv hozzáadása",
  "text989": "Nyelv",
  "text990": "Nyelvi szint",
  "text991": "Nincs hozzáadott oktatásod",
  "text992": "Ma",
  "text993": "Tanfolyam vagy tanúsítvány",
  "text994": "Ez a weboldal cookie-kat használ",
  "text995": "Sütiket használunk a tartalom és a hirdetések személyre szabásához, a közösségi médiafunkciók biztosításához és a forgalom elemzéséhez. A weboldalunk használatára vonatkozó információkat közösségi média-, hirdetési és elemző partnereinknek is továbbítjuk. Ezek a partnerek kombinálhatják a vonatkozó információkat más olyan információkkal, amelyeket Ön megadott nekik, vagy amelyeket Öntől gyűjtöttek, amikor Ön igénybe vette a szolgáltatásaikat.",
  "text996": "Engedélyezzen mindent",
  "text997": "Visszautasítani",
  "text998": "Testreszabás",
  "text999": "Sütik beállításai",
  "text1000": "Szolgáltatások",
  "text1001": "Az Ön adatvédelmi beállításai",
  "text1002": "Ebben a részben kifejezhet néhány preferenciát a személyes adatainak feldolgozásával kapcsolatban. A kifejezett preferenciákat bármikor felülvizsgálhatja és megváltoztathatja, ha a megadott linken keresztül újra meglátogatja ezt a panelt. Ha vissza kívánja utasítani a hozzájárulását az alább leírt konkrét feldolgozási tevékenységekhez, kapcsolja ki a kapcsolót, vagy használja az \"Összes elutasítása\" gombot, hogy megerősítse, hogy el kívánja menteni a választásait.",
  "text1003": "Szükséges",
  "text1004": "A szükséges sütik segítenek használható weboldalak létrehozásában azáltal, hogy lehetővé teszik az olyan alapvető funkciókat, mint a webhelyen való navigáció és a weboldal védett területeinek elérése. A weboldal e sütik nélkül nem tud megfelelően működni.",
  "text1005": "Statisztika és elemzés",
  "text1006": "A statisztikai sütik segítenek a weboldal tulajdonosainak megérteni, hogy a weboldal látogatóival való interakciót azáltal, hogy névtelenül gyűjtik és jelentik az információkat.",
  "text1007": "Cookie táblázat",
  "text1008": "Cookie",
  "text1009": "Domain",
  "text1010": "Marketing",
  "text1011": "A marketing sütiket a weboldal látogatóinak nyomon követésére használják. A cél az, hogy az egyes felhasználók számára releváns és vonzó hirdetések jelenjenek meg, és így értékesebbek legyenek a kiadók és a harmadik fél hirdetők számára.",
  "text1012": "Többet akarok tudni",
  "text1013": "A személyes adatok feldolgozásáról és a személyes adatok védelmével kapcsolatos jogairól a következő elérhetőségeken kaphat tájékoztatást",
  "text1014": "itt.",
  "text1015": "Funkcionális",
  "text1016": "A funkcionális sütik segítenek bizonyos funkciók végrehajtásában, mint például a weboldal tartalmának megosztása a közösségi média platformokon, visszajelzések gyűjtése és egyéb harmadik féltől származó funkciók.",
  "text1017": "Beállítások mentése",
  "text1018": "Nincs hozzáadott munkatapasztalata",
  "text1019": "Nincs hozzáadott tudásod",
  "text1020": "A készségek és ismeretek típusa",
  "text1021": "Képzettségi és tudásszint",
  "text1022": "Ismeretek és készségek bővítése",
  "text1023": "Milyen nyelveket beszél?",
  "text1024": "Adja meg az Ön által beszélt nyelveket és azok szintjét",
  "text1025": "Nincs hozzáadott nyelv",
  "text1026": "Vissza a",
  "text1027": "Folytatás",
  "text1028": "Mentés",
  "text1029": "Az értéknek a következő tartományban kell lennie",
  "text1030": "Oktatás hozzáadása",
  "text1031": "Még mindig tanulok",
  "text1032": "A vizsgálat leírása",
  "text1033": "Cím",
  "text1034": "Műszaki információk",
  "text1035": "Műszaki jellemzők",
  "text1036": "Kérdése van a termékkel kapcsolatban? Küldje el nekünk, és mi szívesen válaszolunk rá.",
  "text1037": "Termék neve",
  "text1038": "Érdeklődés küldése",
  "text1039": "Hozzájárulok a személyes adatok feldolgozásához",
  "text1040": "Az Ön kérdése",
  "text1041": "Küldje el a következő címre",
  "text1042": "A kérdését sikeresen elküldtük",
  "text1043": "A kérdést nem lehetett elküldeni",
  "text1044": "Az Ön neve",
  "text1045": "Reza",
  "text1046": "Ez a termék többféle változatban kapható",
  "text1047": "Megosztás Facebookon",
  "text1048": "Minimális magasság",
  "text1049": "Minimális szélesség",
  "text1050": "Maximális magasság",
  "text1051": "Maximális szélesség",
  "text1052": "Színes design",
  "text1053": "Január",
  "text1054": "Február",
  "text1055": "Március",
  "text1056": "Április",
  "text1057": "Május",
  "text1058": "Június",
  "text1059": "Július",
  "text1060": "Augusztus",
  "text1061": "Szeptember",
  "text1062": "Október",
  "text1063": "November",
  "text1064": "December",
  "text1065": "Tanfolyam hossza",
  "text1066": "Fejezetek száma",
  "text1067": "Adja meg a pótalkatrész eredeti nevét",
  "text1068": "A fizetés módja",
  "text1069": "Használja fiókját a megrendelések nyomon követésére és a számlák kezelésére.",
  "text1070": "Csak új",
  "text1071": "Csak használt",
  "text1072": "Használt alkatrészek",
  "text1073": "Blogcikkek, tippek és tanácsok",
  "text1074": "Maradjon képben",
  "text1075": "Bővebben a projektről",
  "text1076": "Művelet részlete",
  "text1077": "A rendezvény végéig",
  "text1078": "A rendezvény kezdetéig",
  "text1079": "Előző lecke",
  "text1080": "Befejeződött",
  "text1081": "Krokov",
  "text1082": "Tanfolyam sikerességi aránya",
  "text1083": "Nyissa meg a teljes vitát",
  "text1084": "Csatlakozzon a vitához",
  "text1085": "Tanfolyam hossza",
  "text1086": "A fejezetek listája",
  "text1087": "Tanfolyam leírása",
  "text1088": "Gyakran ismételt kérdések",
  "text1089": "Megbeszélés",
  "text1090": "Vásároljon tanfolyamot",
  "text1091": "Hivatkozások",
  "text1092": "Megfeleltként jelölje meg",
  "text1093": "A tanfolyam megkezdése",
  "text1094": "Kilépés a tanfolyamból",
  "text1095": "Egy másik lecke",
  "text1096": "Gratulálunk",
  "text1097": "Ön sikeresen elvégezte a tanfolyamot",
  "text1098": "nélkül",
  "text1099": "A rés",
  "text1100": "Dot",
  "text1101": "Vonal",
  "text1102": "Ismeretlen",
  "text1103": "Az új jelszónak különböznie kell a régitől.",
  "text1104": "Számla",
  "text1105": "Létrehozta a",
  "text1106": "Részösszeg",
  "text1107": "Az ügyfélszámla nem érvényes.",
  "text1108": "Jelszó megerősítése",
  "text1109": "Vásárolt képzés",
  "text1110": "Nyissa meg a  címet.",
  "text1111": "Edző",
  "text1112": "Tetszeni fog",
  "text1113": "Magánszemély",
  "text1114": "Cím hozzáadása",
  "text1115": "Hozzáadás a kosárhoz",
  "text1116": "Vissza a videó oktatóvideókhoz",
  "text1117": "Árajánlat",
  "text1118": "Kérés küldése",
  "text1119": "Teljesen szállítsd le",
  "text1120": "Külső rendelési szám",
  "text1121": "A termékek kivitele befejeződött",
  "text1122": "HÉA-val",
  "text1123": "Új felhasználó",
  "text1124": "Új rendelés",
  "text1125": "Új megjegyzés a feladathoz",
  "text1126": "Egy feladat állapotának megváltoztatása",
  "text1127": "Ingyenes szállítás",
  "text1128": "Árgarancia",
  "text1129": "Ingyenes konzultáció",
  "text1130": "Ügyfélszolgálat",
  "text1131": "2000+ termék raktáron",
  "text1132": "Szállítás 4 napon belül",
  "text1133": "Címkék",
  "text1134": "Profilom",
  "text1135": "Adja meg a vállalat nevét",
  "text1136": "Kérjük, adja meg a regisztrációs számot",
  "text1137": "Adja meg a cég címét",
  "text1138": "A megvalósítás helye",
  "text1139": "Érdekel",
  "text1140": "A patak közelében",
  "text1141": "Hányan fogják használni a tisztítóművet?",
  "text1142": "Van lejtős telkem?",
  "text1143": "",
  "text1144": "Tervezze meg termékét pontosan az Ön ízlése szerint. Konfigurátorunkkal gyorsan és egyszerűen elkészítheti a tökéletes terméket.",
  "text1145": "Ideális konfiguráció létrehozása",
  "text1146": "Minden alkategória megtekintése",
  "text1147": "Fotókalauz",
  "text1148": "Olvassa el a cikket",
  "text1149": "Legtöbbet olvasott cikkek",
  "text1150": "Címkék",
  "text1151": "Tervez egy projektet?\nTalálkozunk és tanácsot adunk Önnek.",
  "text1152": "Ingyenes",
  "text1153": "Kapcsolat",
  "text1154": "Retrieved from",
  "text1155": "Cikk megosztása",
  "text1156": "A linket a vágólapra másoltuk",
  "text1157": "Költségvetés",
  "text1158": "A hűségpontokat nem lehetett felhasználni",
  "text1159": "Az Ön hűségpontjai",
  "text1160": "Minden hűségnek értéke van",
  "text1161": ", így teljes kedvezményt kap",
  "text1162": "a vásárláskor.",
  "text1163": "Nincsenek hűségpontjai",
  "text1164": "Hűségpontok beváltása",
  "text1165": "Az alkalmazandó pontok száma",
  "text1166": "Beváltott hűségpontok száma",
  "text1167": "Alkalmazott kedvezmény",
  "text1168": "A maximálisan beváltható pontok száma rendelésenként a következő",
  "text1169": "Székhely",
  "text1170": "Több információ erről a szolgáltatásról",
  "text1171": "Kapcsolatfelvétel",
  "text1172": "Iroda",
  "text1173": "A vállalat székhelye",
  "text1174": "Folytassa tovább",
  "text1175": "Végrehajtási folyamat és eljárás",
  "text1176": "Univerzális webáruház képernyők előnézete",
  "text1177": "A kiválasztott időpont nem foglalható",
  "text1178": "Kiválasztott opció",
  "text1179": "Szobák",
  "text1180": "Terület",
  "text1181": "Bútorrajzok rajzolása",
  "text1182": "A berendezési elemek listája",
  "text1183": "Az ügyfél teljes neve",
  "text1184": "A panasz státuszának neve",
  "text1185": "A foglalást kezelő személy neve",
  "text1186": "Foglalt a napra",
  "text1187": "Ha már rendelkezik fiókkal nálunk, kérjük, hogy",
  "text1188": "Cégnév",
  "text1189": "A társaság bejegyzett székhelyének címe",
  "text1190": "Válasszon egy országot",
  "text1191": "A hozzárendelt lapok nem tartoznak ebbe a szakaszba",
  "text1192": "Vízszintes",
  "text1193": "Függőlegesen",
  "text1194": "Belső",
  "text1195": "Kültéri",
  "text1196": "Munka, foglalkoztatás és karrierlehetőségek",
  "text1197": "Népszerű pozíciók",
  "text1198": "Kosár frissítése",
  "text1199": "Elem szerkesztése",
  "text1200": "Szerződés száma",
  "text1201": "Garancia utáni szolgáltatás",
  "text1202": "Bejelentkezési űrlap",
  "text1203": "Bejelentkezési név (email)",
  "text1204": "Bejelentkezés",
  "text1205": "Helytelen jelszó",
  "text1206": "Adja meg a virtuális termék jelszavát, amelyet a megrendelés kifizetése után kapott.",
  "text1207": "A jelszót az e-mail címén találja.",
  "text1208": "A kosárban lévő terméket módosították.",
  "text1209": "Az API-kulcs nem helyes",
  "text1210": "A szerződés aláírása és a számla kifizetése",
  "text1211": "Elérhetőségek és munkaköri leírás",
  "text1212": "Adatok és hozzáférés-ellenőrzés",
  "text1213": "Grafikai tervezés",
  "text1214": "Az átvételi jegyzőkönyv aláírása - Tervezés",
  "text1215": "A rendszer telepítése a domain - szerverre",
  "text1216": "Vizuális megvalósítás és csatlakozás a rendszerhez",
  "text1217": "Átvételi jegyzőkönyv - Tervezési megvalósítás és csatlakozás a rendszerhez",
  "text1218": "A projekt tartalma",
  "text1219": "Átállás a termelésre",
  "text1220": "Végleges projekt megerősítése",
  "text1221": "Az építési szerződést még nem írták alá.",
  "text1222": "A számlát nem fizették ki.",
  "text1223": "A szerződést sikeresen aláírták.",
  "text1224": "A számla kifizetésre került.",
  "text1225": "Letöltések",
  "text1226": "A boltba",
  "text1227": "A dokumentum letöltése",
  "text1228": "Számláim",
  "text1229": "Dokumentum",
  "text1230": "Számlázott összeg",
  "text1231": "Kifizetett összeg",
  "text1232": "Kifizetendő maradványok",
  "text1233": "Pénznem",
  "text1234": "A kiadás dátuma",
  "text1235": "Jóváhagyta",
  "text1236": "Az ügyfél által felszerelt",
  "text1237": "Dokumentum típusa",
  "text1238": "Az adóköteles értékesítés időpontja",
  "text1239": "Az én megkeresésem",
  "text1240": "Adja meg az e-mail címét, amelyen keresztül kommunikálni fogunk",
  "text1241": "Az elfogadás időpontja",
  "text1242": "Több rólunk",
  "text1243": "Érdekel",
  "text1244": "Szigetelés",
  "text1245": "Használattal",
  "text1246": "Az anyag szerint",
  "text1247": "Minden hivatkozás",
  "text1248": "Kiválasztott projektek",
  "text1249": "Érdekli egy projekt megvalósítása vagy kérdése van? Vegye fel velünk a kapcsolatot",
  "text1250": "Név és vezetéknév",
  "text1251": "Az Európai Unió által támogatott projekt",
  "text1252": "Adatvédelmi irányelvek",
  "text1253": "Termék áttekintés",
  "text1254": "Termék megtekintése",
  "text1255": "Műszaki adatok",
  "text1256": "Konzultáljon a  címen.",
  "text1257": "Számlaszám",
  "text1258": "Telefonszám",
  "text1259": "Az ügyféllel való kommunikációnk során a \"Whatsapp\" alkalmazáson keresztül a projektcsoporton keresztül kommunikálunk. Adja meg a számot, amelyen keresztül felvesszük Önt a projektcsoportba.",
  "text1260": "Whatsapp telefonszám (+421 ... ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Munkaköri leírás",
  "text1263": "A munka típusa (megállapodás és szerződés szerint)",
  "text1264": "Eshop",
  "text1265": "Bemutató weboldal",
  "text1266": "Webes alkalmazás",
  "text1267": "Mobil alkalmazás",
  "text1268": "CRM rendszer",
  "text1269": "PPC kampányok (Google, Facebook)",
  "text1270": "SEO optimalizálás",
  "text1271": "A formatervezési minta típusa",
  "text1272": "E-shop design - Eliadmin univerzális",
  "text1273": "E-shop design - egyedi tervezés",
  "text1274": "Web design / alkalmazás design / rendszer design",
  "text1275": "Kedvelt színkód (HEX formátumban)",
  "text1276": "Ezen a linken keverheti össze.",
  "text1277": "Grafikai és tartalmi dokumentumok",
  "text1278": "Grafikai dokumentumok",
  "text1279": "Van (pl. tervezési kézikönyv, logó, banner...)",
  "text1280": "Nekem nincs",
  "text1281": "Háttértartalom a weboldalhoz (leírások, kategóriák nevei, fotók stb...)",
  "text1282": "Csatolja a támogató fájlokat (tervezési kézikönyv, logó, bannerek, ...)",
  "text1283": "A logó vektoros megjelenítéséhez használja az svg, ai vagy pdf vektoros formátumot.",
  "text1284": "Legfeljebb 10 támogatott fájl feltöltése. Maximális méret 100 MB/fájl.",
  "text1285": "FÁJL KERESÉSE",
  "text1286": "Domain és tárhely",
  "text1287": "Vásároltam",
  "text1288": "Domain név (www.vasadomena.sk)",
  "text1289": "Domain név",
  "text1290": "Domainszolgáltató neve",
  "text1291": "Szolgáltató neve",
  "text1292": "Az Ön bejelentkezési neve",
  "text1293": "Az Ön bejelentkezési jelszava",
  "text1294": "A rendszer telepítéséhez szükséges jegyzet (felgyorsítja a munkát és a termék tényleges átadását, ha nem rendelkezik vele, el tudjuk intézni).",
  "text1295": "Foglalási űrlap",
  "text1296": "A szolgáltatás kiválasztása",
  "text1297": "Válasszon borbélyt",
  "text1298": "Válassza ki a kifejezést",
  "text1299": "Adja meg elérhetőségét",
  "text1300": "Aktuális szabad időpontok",
  "text1301": "Határozatlan",
  "text1302": "Hétfő",
  "text1303": "Kedd",
  "text1304": "Szerda",
  "text1305": "Csütörtök",
  "text1306": "Péntek",
  "text1307": "Szombat",
  "text1308": "Vasárnap",
  "text1309": "A Hét",
  "text1310": "Nincsenek elérhető dátumok",
  "text1311": "Összefoglaló",
  "text1312": "A fodrász neve",
  "text1313": "Szolgáltatás",
  "text1314": "Időtartam",
  "text1315": "percek",
  "text1316": "Foglalás elküldése",
  "text1317": "A foglalás sikeres volt",
  "text1318": "Ki kell választani a dátumot",
  "text1319": "A fenntartást nem sikerült megállapítani. Kérjük, ellenőrizze, hogy az űrlapot helyesen töltötte-e ki, és próbálja meg újra létrehozni a foglalást.",
  "text1320": "Volt egy váratlan hiba.",
  "text1321": "További információ",
  "text1322": "További projektek megtekintése",
  "text1323": "A projekt részletei",
  "text1324": "Lépjen kapcsolatba velünk, ha érdekli\naz Ön szakterületének szakemberei számára!",
  "text1325": "Projektek",
  "text1326": "Projektek megtekintése",
  "text1327": "A projekt neve",
  "text1328": "A végrehajtás éve",
  "text1329": "Helyszín",
  "text1330": "Referencia levél",
  "text1331": "Vállalati adatok",
  "text1332": "Bank",
  "text1333": "Hívja a  címet.",
  "text1334": "Token beillesztése",
  "text1335": "Foglalás",
  "text1336": "Tovább a kategóriához",
  "text1337": "Navigálás",
  "text1338": "Maradjon képben, ha feliratkozik hírlevelünkre!",
  "text1339": "E-mail címének megadásával Ön megerősíti hozzájárulását személyes adatainak feldolgozásához, és feliratkozik a Spaceplan hírlevelére.",
  "text1340": "Foglaljon most",
  "text1341": "Hűségkártyám van",
  "text1342": "Hiba a foglalás rögzítésekor",
  "text1343": "Kiválasztott termékek foglalása",
  "text1344": "Többet cégünkről",
  "text1345": "Szolgáltatásaink",
  "text1346": "Csatlakozzon hozzánk",
  "text1347": "Sikeresen leiratkozott a hírlevélről",
  "text1348": "Hozzon létre egy új",
  "text1349": "Törölje és dobja el",
  "text1350": "Le kívánja mondani az önéletrajz létrehozását? Minden adat elveszik.",
  "text1351": "Dobja be önéletrajzát",
  "text1352": "Folytassa a létrehozást",
  "text1353": "Attribútum kiválasztási hiba.",
  "text1354": "Kapcsolat legkésőbb",
  "text1355": "Online árkalkuláció",
  "text1356": "Válassza ki az árképzésben érdekelt termékeket:",
  "text1357": "Idézet megtekintése",
  "text1358": "Kiválasztott termékek a számításhoz:",
  "text1359": "Termék hozzáadása",
  "text1360": "Bővebben",
  "text1361": "Érdekel a termék",
  "text1362": "Érdekli ez a termék? Töltse ki az űrlapot, és mi a lehető leghamarabb felvesszük Önnel a kapcsolatot egy árajánlattal.",
  "text1363": "Az előző lépésben ki kell választani a terméket.",
  "text1364": "Konfiguráció nélkül",
  "text1365": "Töltse ki a mellékelt űrlapot, és mi a lehető leghamarabb válaszolunk Önnek. Még ebben a lépésben is egy nem kötelező érvényű árajánlat az Ön számára.",
  "text1366": "Projekt",
  "text1367": "Kapcsolat legkésőbb",
  "text1368": "Küldjön nem kötelező érvényű ajánlatkérést egyedi ajánlatra vonatkozóan",
  "text1369": "Az idézet letöltése",
  "text1370": "Böngésszen a  oldalon.",
  "text1371": "Ez a termék nem rendelkezik beállításokkal.",
  "text1372": "Az egyéni ajánlatra vonatkozó nem kötelező érvényű ajánlatkérés sikeresen elküldésre került.",
  "text1373": "Ügyvezető igazgató",
  "text1374": "Kereskedelem és szolgáltatások",
  "text1375": "Kérdése van? Írjon nekünk",
  "text1376": "Ha kérdése van, és kapcsolatba szeretne lépni velünk, próbáljon meg telefonon vagy e-mailben kapcsolatba lépni velünk, vagy töltse ki a kapcsolatfelvételi űrlapot.",
  "text1377": "A projekt megtekintése",
  "text1378": "Érdeklődik a termékek és szolgáltatások iránt?",
  "text1379": "Tervező",
  "text1380": "Szűrő alkalmazása",
  "text1381": "Nincsenek kedvenc termékei",
  "text1382": "Kívánságlista törlése",
  "text1383": "Tényleg törölni szeretné a kívánságlistáját?",
  "text1384": "Igen, törölni",
  "text1385": "Nem, ne törölje",
  "text1386": "Érvénytelen telefonszám",
  "text1387": "Érvénytelen telefonos körzetszám",
  "text1388": "Minden ingatlan",
  "text1389": "Értékesítés",
  "text1390": "Bérlés",
  "text1391": "Vásároljon",
  "text1392": "Ajánlat megtekintése",
  "text1393": "Művészek",
  "text1394": "Megrendelés elküldése fizetési kötelezettséggel",
  "text1395": "El akarom adni",
  "text1396": "Szeretnék vásárolni",
  "text1397": "Bérelni szeretnék",
  "text1398": "Nincs rendelkezésre álló szállítási hely",
  "text1399": "Berendezések",
  "text1400": "Vissza az ingatlanokhoz",
  "text1401": "Minden fotó megtekintése",
  "text1402": "Látjuk, hogy Ön termékeket adott hozzá a kedvenceihez, amikor nem volt bejelentkezve. Szeretne termékeket hozzáadni a kedvenceihez?",
  "text1403": "Add",
  "text1404": "Ne fogadják el",
  "text1405": "Az ügyfél nem rendelhető hozzá.",
  "text1406": "Termék keresése",
  "text1407": "Helyszín",
  "text1408": "Az ingatlan elhelyezkedése",
  "text1409": "Az ingatlan típusa",
  "text1410": "Válassza ki a  címet.",
  "text1411": "Adja meg a kulcsszót",
  "text1412": "Válasszon egy árkategóriát",
  "text1413": "Ingatlanok",
  "text1414": "Költségvetések",
  "text1415": "A vállalat székhelye",
  "text1416": "Érdekel",
  "text1417": "Igen",
  "text1418": "Csak új épületek",
  "text1419": "Nincs ingatlan",
  "text1420": "kínált ingatlanok",
  "text1421": "Rendezés",
  "text1422": "El akarom adni",
  "text1423": "Ingatlan",
  "text1424": "Ingatlanok",
  "text1425": "kínált ingatlan",
  "text1426": "kínált ingatlanok",
  "text1427": "A  címről",
  "text1428": "Kapcsolat",
  "text1429": "Válassza ki, hogy milyen típusú számlát kíván létrehozni nálunk",
  "text1430": "Felhasználó",
  "text1431": "Diák",
  "text1432": "Cég",
  "text1433": "Iskola",
  "text1434": "a vállalat honlapja",
  "text1435": "A társaság bejegyzett székhelyének címe",
  "text1436": "Cégbejegyzés",
  "text1437": "Ha már rendelkezik fiókkal nálunk, kérjük, hogy",
  "text1438": "bejelentkezés.",
  "text1439": "A vállalat működése különbözik a vállalat székhelyétől",
  "text1440": "A felelős személy elérhetőségei",
  "text1441": "A jelszónak legalább 8 karakterből kell állnia.",
  "text1442": "a fiók létrehozása és az Önnel való kapcsolatfelvétel céljából.",
  "text1443": "Minden projekt",
  "text1444": "Új",
  "text1445": "Tudjon meg többet a termékről",
  "text1446": "Termék megvásárlása",
  "text1447": "Letölthető mellékletek",
  "text1448": "Teljes ár ÁFA nélkül",
  "text1449": "Ár darabonként ÁFA nélkül",
  "text1450": "Termék ára ÁFA nélkül",
  "text1451": "Összesen HÉA nélkül",
  "text1452": "Konfigurációs előnézet",
  "text1453": "Mindent kibontani",
  "text1454": "Termékkonfiguráció",
  "text1455": "Felületi felületek",
  "text1456": "A hátoldal felületkezelése",
  "text1457": "Ajtó kialakítása",
  "text1458": "Élek",
  "text1459": "Fogantyúk",
  "text1460": "Csuklópántok",
  "text1461": "Díszek",
  "text1462": "Méretek",
  "text1463": "További adatok",
  "text1464": "Adja meg a darabszámot",
  "text1465": "Darabszám",
  "text1466": "Tiszta konfiguráció",
  "text1467": "Konfigurátor bezárása",
  "text1468": "Konfigurátor",
  "text1469": "Előnézet",
  "text1470": "A  beállítása",
  "text1471": "Érvénytelen konfiguráció",
  "text1472": "Azt hiszem, itt az ideje",
  "text1473": "Állítsa be a darabszámot",
  "text1474": "A kosárba helyezéshez be kell állítania a darabszámot.",
  "text1475": "A címeim",
  "text1476": "Felhasználói regisztráció",
  "text1477": "Diákregisztráció",
  "text1478": "Iskolai regisztráció",
  "text1479": "Az iskola neve",
  "text1480": "az iskola honlapja",
  "text1481": "Iskola címe",
  "text1482": "Tanulmányi területek az iskolában",
  "text1483": "Iskolai alkalmazott e-mail címe",
  "text1484": "Hivatalos iskolai e-mail cím",
  "text1485": "Osztály hozzáadása",
  "text1486": "Töltse ki a mezőt",
  "text1487": "A Google Analytics API konfigurációja nincs kitöltve.",
  "text1488": "Az exportgenerálás megkezdődött",
  "text1489": "Exportgenerálás befejeződött",
  "text1490": "Állást keres? Töltse ki a kapcsolatfelvételi űrlapot",
  "text1491": "Nem talált ajánlatot a jelenleg elérhető állások között? Semmi gond, töltse ki a kapcsolatfelvételi űrlapot, töltse fel önéletrajzát, és amennyiben van üres állás, jelentkezünk.",
  "text1492": "Karrier",
  "text1493": "Röviden írja le a pozíciót, amely érdekelné...",
  "text1494": "Fontos kapcsolatok",
  "text1495": "Népszerű ajánlatok",
  "text1496": "Tevékenységi terület",
  "text1497": "A vállalkozás mérete",
  "text1498": "Érdekességek a vállalatról",
  "text1499": "A vállalat leírása",
  "text1500": "Az ajánlatok áttekintése",
  "text1501": "Az iskola leírása",
  "text1502": "A tanulmányi területek áttekintése",
  "text1503": "A felvételi vizsga időpontja",
  "text1504": "Nyílt nap",
  "text1505": "Együttműködés / Szakmai gyakorlat",
  "text1506": "Nincs feljegyzés.",
  "text1507": "Tanfolyamok",
  "text1508": "Profil szerkesztése",
  "text1509": "Korábbi munkatapasztalat",
  "text1510": "Oktatás és képesítések",
  "text1511": "Személyes készségek",
  "text1512": "Egyéb készségek",
  "text1513": "Állampolgárság",
  "text1514": "Munkahely",
  "text1515": "Milyen iskolában tanulsz?",
  "text1516": "Milyen típusú munkát keres?",
  "text1517": "Nincs kitöltve",
  "text1518": "Vállalati profil",
  "text1519": "Távolítson el mindent",
  "text1520": "Hirdetések",
  "text1521": "Iskola profilja",
  "text1522": "Keresett cégek",
  "text1523": "Profil megtekintése",
  "text1524": "Állásajánlatok",
  "text1525": "Tisztítsa meg a szűrőt",
  "text1526": "Állásajánlat információ",
  "text1527": "Fizetés",
  "text1528": "Részleg",
  "text1529": "Pozíció",
  "text1530": "Az üres álláshelyek száma",
  "text1531": "Az állásajánlat érvényessége",
  "text1532": "Szükséges készségek",
  "text1533": "Egyéb információk",
  "text1534": "Profil létrehozása",
  "text1535": "Korábbi munkatapasztalat",
  "text1536": "Oktatás és képesítések",
  "text1537": "Mentés és folytatás később",
  "text1538": "Válassza ki a nemet",
  "text1539": "Mi az Ön szakterülete?",
  "text1540": "A vállalat alapvető adatai",
  "text1541": "Logó",
  "text1542": "Érdekességek a vállalatról",
  "text1543": "A vállalat szlogenje",
  "text1544": "Röviden írja le a vállalatát és azt, hogy mivel foglalkozik...",
  "text1545": "Írjon ide egy érdekes tényt a vállalatáról...",
  "text1546": "Írja meg a cég szlogenjét...",
  "text1547": "A vállalat elérhetőségei",
  "text1548": "Biztosítanak szakmai gyakorlatot a diákoknak?",
  "text1549": "Örülne az iskolákkal való együttműködésnek?",
  "text1550": "Igen",
  "text1551": "Nem",
  "text1552": "Facebook-link",
  "text1553": "Instagram link",
  "text1554": "Linkedin link",
  "text1555": "Tevékenységi terület",
  "text1556": "Vállalat mérete",
  "text1557": "Válassza ki a vállalat méretét",
  "text1558": "Hivatkozások listája",
  "text1559": "Iskola profilja",
  "text1560": "Iskolai alapadatok",
  "text1561": "Iskolai projektek",
  "text1562": "A cím rossz formátumú",
  "text1563": "A cégprofil létrehozása az Ön névjegykártyájaként szolgál.",
  "text1564": "Tanulmányi területek az iskolában",
  "text1565": "Iskolák",
  "text1566": "Vállalatok",
  "text1567": "Próbálja ki a hatékony jelöltkeresést",
  "text1568": "A Jobiis Matching megfelelő jelöltet fog ajánlani.",
  "text1569": "Ajánlat hozzáadása",
  "text1570": "Az iskola elérhetőségei",
  "text1571": "Tanulmányi területek az iskolában",
  "text1572": "Az iskola rövid leírása",
  "text1573": "Érdekességek az iskoláról",
  "text1574": "Ismertesse röviden az iskoláját...",
  "text1575": "Tegye közzé állásajánlatát és találja meg a megfelelő jelöltet",
  "text1576": "Használja portálunkat állásajánlatok közzétételére, és találja meg rövid időn belül a munkakritériumoknak megfelelő jelöltet.",
  "text1577": "Lépjen kapcsolatba vállalatokkal, és találjon partnert diákjai számára tanulószerződéses vagy szakmai gyakorlatra.",
  "text1578": "A Jobiis segítségével könnyedén hozzáférhet diákjai számára munkatapasztalat- vagy gyakornoki lehetőségekhez.",
  "text1579": "Érdekelné Önt egy szakértő előadás szervezése az iskolájában?",
  "text1580": "Segítünk megszervezni egy előadást a szakterületed szakértőjével, ingyenesen!",
  "text1581": "Találja meg a párját.",
  "text1582": "Osztály hozzáadása",
  "text1583": "Megrendelés",
  "text1584": "Logó feltöltése",
  "text1585": "Iskolai együttműködés",
  "text1586": "Projektek, amelyekben az iskola részt vesz",
  "text1587": "Nyitott ajtók Dátum",
  "text1588": "A felvételi vizsga időpontja",
  "text1589": "Válassza ki a dátumot",
  "text1590": "Válassza ki a tagság típusát",
  "text1591": "Ha más országba szeretne tőlünk rendelni, kérjük, írjon nekünk a következő címre",
  "text1592": "és mi egyénileg fogjuk feldolgozni a megrendelését.",
  "text1593": "Projekt hozzáadása",
  "text1594": "Együttműködés hozzáadása",
  "text1595": "A vállalat leírása",
  "text1596": "Az Ön tevékenységi területe",
  "text1597": "Szociális hálózatok",
  "text1598": "Melyik körben szeretne dolgozni",
  "text1599": "Mi az Ön szakterülete?",
  "text1600": "Milyen típusú munkát keres?",
  "text1601": "Várható fizetés euróban (havonta)",
  "text1602": "Azonnali kezdés",
  "text1603": "Munkaidő",
  "text1604": "Pozíció megnevezése",
  "text1605": "Még mindig fennáll",
  "text1606": "Még több",
  "text1607": "Cím Képesítés",
  "text1608": "Oktatási szervezet",
  "text1609": "Állandó oktatás",
  "text1610": "szervezet weboldala",
  "text1611": "Törölje a  címet.",
  "text1612": "Nyelvtudás",
  "text1613": "Anyanyelv",
  "text1614": "Egyéb nyelvek",
  "text1615": "Digitális készségek",
  "text1616": "Milyen digitális készségekkel rendelkezik?",
  "text1617": "Milyen kategóriájú engedéllyel rendelkezik?",
  "text1618": "Munkahely típusa",
  "text1619": "Munkaköri leírás",
  "text1620": "Pozíció alkalmas",
  "text1621": "Alacsonyabb bérküszöb euróban",
  "text1622": "Felső fizetési határ euróban",
  "text1623": "Iparág",
  "text1624": "Munkavállalói juttatások",
  "text1625": "Munkaidő",
  "text1626": "Előírt minimális életkor",
  "text1627": "Befejezett oktatás",
  "text1628": "A szakterületen szükséges végzettség",
  "text1629": "Nyelvtudás",
  "text1630": "Előzetes tapasztalat szükséges",
  "text1631": "Szükséges képesítések",
  "text1632": "Személyiségbeli előfeltételek",
  "text1633": "Információk a pályázók számára",
  "text1634": "Diploma",
  "text1635": "Válassza ki a munka típusát",
  "text1636": "Milyen iskolában tanulsz",
  "text1637": "Válasszon kényelmes munkaidőt",
  "text1638": "Képesség hozzáadása",
  "text1639": "Válassza ki a részlegeket",
  "text1640": "Válassza ki a munka típusát",
  "text1641": "Kreatív munkák",
  "text1642": "Konferenciák és szemináriumok",
  "text1643": "Hobbi és érdeklődési kör",
  "text1644": "Kitüntetések és díjak",
  "text1645": "Hálózatok és tagságok",
  "text1646": "Projektek",
  "text1647": "Kiadványok",
  "text1648": "Hivatkozások",
  "text1649": "Önkéntes tevékenységek",
  "text1650": "Válasszon ki egy készségtípust",
  "text1651": "Képzettségi szint",
  "text1652": "Az alkotás neve",
  "text1653": "A kreatív munka leírása",
  "text1654": "Fájl feltöltése",
  "text1655": "A konferencia neve",
  "text1656": "Link a szemináriumhoz/konferenciához",
  "text1657": "A szeminárium/konferencia leírása",
  "text1658": "A hobbi/érdeklődés neve",
  "text1659": "Hobbik/érdeklődések leírása",
  "text1660": "A díj/díj neve",
  "text1661": "A kitüntetés/jutalom leírása",
  "text1662": "Átadó intézmény",
  "text1663": "Az átadás időpontja",
  "text1664": "A tagság neve",
  "text1665": "Tagság leírása",
  "text1666": "A projekt neve",
  "text1667": "A projekt leírása",
  "text1668": "A kiadvány címe",
  "text1669": "A közzététel dátuma",
  "text1670": "A kiadvány leírása",
  "text1671": "A referencia neve",
  "text1672": "Referencia lap feltöltése",
  "text1673": "Álláspont (népszavazás)",
  "text1674": "E-mail (népszavazás)",
  "text1675": "Telefonszám (népszavazás)",
  "text1676": "Helyszín",
  "text1677": "Az önkéntes tevékenység neve",
  "text1678": "Az önkéntes tevékenység leírása",
  "text1679": "Link a fájlhoz/videóhoz",
  "text1680": "Egyéb",
  "text1681": "Nincsenek hozzáadott képességeid",
  "text1682": "Az Ön profilja sikeresen frissült",
  "text1683": "Profilkép feltöltése",
  "text1684": "Hirdetés hozzáadása",
  "text1685": "Hirdetés létrehozása",
  "text1686": "Bér típusa",
  "text1687": "Helyszín",
  "text1688": "Üzeneteim",
  "text1689": "Hibás token, próbálja újra",
  "text1690": "Keresés ajánlat neve, iparág, helyszín szerint",
  "text1691": "Ma ez",
  "text1692": "Kapcsolatok",
  "text1693": "Beszéd",
  "text1694": "Hogyan válasszunk aktív ülést?",
  "text1695": "A letölthető dokumentum és a hozzáférési jelszó csak a fizetés visszaigazolása után lesz elérhető.",
  "text1696": "Jelszó visszaállítása",
  "text1697": "Megvalósítási részletek megjelenítése",
  "text1698": "Végrehajtás",
  "text1699": "Elhelyezkedés",
  "text1700": "A megvalósítás összes vizualizációja",
  "text1701": "Vissza az összes projekthez",
  "text1702": "Termékadatok",
  "text1703": "Nincsenek felhasználók",
  "text1704": "Felhasználók keresése",
  "text1705": "Jött",
  "text1706": "Kapcsolatfelvételi űrlap a weboldalról",
  "text1707": "Hallgatói regisztráció",
  "text1708": "Navigálás az üzlethez",
  "text1709": "Ha szeretnél értesülni a legfrissebb hírekről, a teljesítési határidőkről és a lehetőségekről, iratkozz fel hírlevelünkre, és kapd meg a legfrissebb információkat közvetlenül a postaládádba.",
  "text1710": "Hétfő - Szombat: 8:00 - 19:00",
  "text1711": "Munkaidőben 24 órán belül válaszolunk.",
  "text1712": "Mintabolt",
  "text1713": "Személyes találkozót előre kell egyeztetni.",
  "text1714": "Töltse ki az űrlapot, és amint lehetséges, válaszolunk kérdésére.",
  "text1715": "Mutass többet",
  "text1716": "Osztályozás",
  "text1717": "Szakmai gyakorlat diákoknak",
  "text1718": "Együttműködés iskolákkal",
  "text1719": "Minden",
  "text1720": "Csevegés törlése",
  "text1721": "Nincsenek hírek",
  "text1722": "Ezt a terméket elkészítjük Önnek.",
  "text1723": "Cég címe",
  "text1724": "Kapcsolattartó személy",
  "text1725": "www-cím",
  "text1726": "Cím a név előtt",
  "text1727": "Cégjellemzők",
  "text1728": "Válasszon egy területet",
  "text1729": "Teljesítsd az ajánlatot",
  "text1730": "Szükséges nyelvi készségek",
  "text1731": "Kötelező végzettség",
  "text1732": "Szükséges munkatapasztalat",
  "text1733": "Állásajánlat típusa",
  "text1734": "Fiókom",
  "text1735": "Az életrajzom",
  "text1736": "Az állásajánlataim",
  "text1737": "Tanfolyamaim",
  "text1738": "A cégem",
  "text1739": "Életrajzok",
  "text1740": "Önéletrajz és bizonyítványok",
  "text1741": "Fotózás és videózás",
  "text1742": "Készségek és ismeretek",
  "text1743": "Iparági kategóriák",
  "text1744": "Töltsd fel az önéletrajzodat, hogy a munkaadók letölthessék.",
  "text1745": "Bizonyítvány",
  "text1746": "Töltse fel a rendelkezésre álló tanúsítványokat.",
  "text1747": "Kísérőlevél",
  "text1748": "Töltsön fel egy motivációs levelet.",
  "text1749": "A fénykép nem kötelező, de egy fényképes önéletrajz személyesebbnek tűnik, és vonzóbb lesz a HR-es számára.",
  "text1750": "Töltsd fel videós önéletrajzodat, amely egy lépéssel közelebb visz a kívánt munkakörhöz.",
  "text1751": "Tudtad, hogy egy átlagos toborzónak 7 másodpercbe telik először átfutnia egy önéletrajzot? Tehát csak a releváns tapasztalatokat említsd, és írd le felsorolásokkal vagy rövid bekezdésekkel.",
  "text1752": "Tájékoztasd a munkaadókat arról, hogy milyen végzettséggel rendelkezel.",
  "text1753": "Kérlek, jelöld meg, milyen készségekkel és ismeretekkel rendelkezel, és milyen szinten.",
  "text1754": "Bővítsd az önéletrajzodban azokat a részeket, amelyek fontosak számodra.",
  "text1755": "Cím név után",
  "text1756": "Válaszd ki a listából azokat az iparági kategóriákat, amelyekre jelentkezni szeretnél.",
  "text1757": "Közösségi hálózataink",
  "text1758": "Referenciáink",
  "text1759": "Egyéb hivatkozások",
  "text1760": "Csapatunk",
  "text1761": "Aktuális ajánlat",
  "text1762": "Érvénytelen kulcs",
  "text1763": "Megvalósítottuk",
  "text1764": "Környezetbarát ipari vegyszerek",
  "text1765": "Hogyan készítünk termékeket?",
  "text1766": "Lehetőség otthonról dolgozni?",
  "text1767": "Érkezés napja",
  "text1768": "Állásajánlat leírása",
  "text1769": "Elérhetőségek az ajánlat megválaszolásához",
  "text1770": "Add meg a jelentkezőtől elvárt munkatapasztalatot és annak szintjét.",
  "text1771": "Add meg a jelentkezőtől elvárt végzettséget.",
  "text1772": "Add meg a munkakör betöltéséhez szükséges nyelvi készségeket",
  "text1773": "Adjon hozzá további részeket az ajánlatához, amelyeket a jelölttől megkövetelnek.",
  "text1774": "Munkatapasztalat megnevezése",
  "text1775": "Munkatapasztalat szintje",
  "text1776": "Új hozzáadása",
  "text1777": "Középfokú oktatás",
  "text1778": "Elsőfokú felsőfokú végzettség",
  "text1779": "Felsőoktatás, második szint",
  "text1780": "Felsőfokú végzettség, 3. fokozat",
  "text1781": "Szint",
  "text1782": "Válassza ki a kérelmezőtől kért jogosítványkategóriákat.",
  "text1783": "Az önéletrajzod frissítése sikeresen megtörtént.",
  "text1784": "Töltse ki az önéletrajzát",
  "text1785": "Új válasz a helpdeskben",
  "text1786": "Új válasz került fel a súgópultra.",
  "text1787": "A kérdés sikeresen hozzáadva",
  "text1788": "Hozzáadva",
  "text1789": "Reakciók a hirdetésre",
  "text1790": "Évek",
  "text1791": "Önéletrajz letöltése",
  "text1792": "Csomagolás",
  "text1793": "Keresse meg a helyi üzletet",
  "text1794": "Katalógusszám",
  "text1795": "Szállítás 7-10 nap",
  "text1796": "Nyilvántartás",
  "text1797": "Nincsenek állásajánlataid.",
  "text1798": "Önéletrajzok keresése",
  "text1799": "Nem számít.",
  "text1800": "Keresés gyártó, név, sorozat, termékkód... szerint",
  "text1801": "Válaszd a minőséget és a szépséget – vásárolj nálunk!",
  "text1802": "Ezen gyártók közvetlen importőrei vagyunk.",
  "text1803": "Normál ár",
  "text1804": "Az árunk",
  "text1805": "1 csomag ára",
  "text1806": "Adja meg a területet a csomagok számának kiszámításához",
  "text1807": "Adja meg a terület tartalmát",
  "text1808": "csomagolás",
  "text1809": "Válasszon egy soft skillet",
  "text1810": "Szint kiválasztása",
  "text1811": "Videó megtekintése",
  "text1812": "Nincsenek új értesítések",
  "text1813": "Értékesítsen velünk",
  "text1814": "Ezekkel a szállítókkal dolgozunk együtt",
  "text1815": "Hirdetés szerkesztése",
  "text1816": "Ajánlott munkakörök",
  "text1817": "Nyitott pozíció",
  "text1818": "Kapcsolat",
  "text1819": "Hasonló pozíciók",
  "text1820": "Fenntartjuk a jogot, hogy ne válaszoljunk azoknak a jelentkezőknek, akik nem felelnek meg a fenti követelményeknek.",
  "text1821": "Egy cég",
  "text1822": "Cégportfólió",
  "text1823": "Összes elutasítása",
  "text1824": "Weboldal",
  "text1825": "Hány tárgyad van?",
  "text1826": "Hány rendelésed van havonta?",
  "text1827": "konformitás",
  "text1828": "Elfogadott",
  "text1829": "Igen, szeretnék időnként híreket és tippeket kapni az e-kereskedelmi szolgáltatásokról.",
  "text1830": "Elutasítva",
  "text1831": "Várakozás",
  "text1832": "Válaszolt",
  "text1833": "Soft skillek",
  "text1834": "Válasszon több mint 60 márka közül portfóliónkban, és találja meg pontosan, amit keres! Minden teljesen testreszabható – a kárpitozástól a színekig. Lépjen kapcsolatba velünk, és együtt elkészítjük az Ön kívánságainak megfelelő egyedi dizájnt.",
  "text1835": "Termékek megjelenítése",
  "text1836": "Hová fog menni?",
  "text1837": "gyermek",
  "text1838": "gyermekek",
  "text1839": "gyermekek",
  "text1840": "felnőtt",
  "text1841": "felnőttek",
  "text1842": "felnőttek",
  "text1843": "1-3 éjszaka",
  "text1844": "4-6 éjszaka",
  "text1845": "7-15 éjszaka",
  "text1846": "16+ éjszaka",
  "text1847": "Éjszakák számának kiválasztása",
  "text1848": "További lehetőségek",
  "text1849": "Új kérdés",
  "text1850": "Helyszín, elhelyezkedés, szálloda",
  "text1851": "Dátum -tól -ig",
  "text1852": "Utasok száma",
  "text1853": "Tartózkodás hossza",
  "text1854": "Strava",
  "text1855": "Közeli",
  "text1856": "További lehetőségek megjelenítése",
  "text1857": "Maximális ár személyenként",
  "text1858": "Több",
  "text1859": "Képzettség típusa",
  "text1860": "Egyik túra sem felel meg a megadott kritériumoknak.",
  "text1861": "Tudj meg többet",
  "text1862": "További cikkek a múlt hétről",
  "text1863": "Eladó",
  "text1864": "Önéletrajz árlista",
  "text1865": "Új nagykereskedelmi regisztráció",
  "text1866": "Egyáltalán nem",
  "text1867": "Kis",
  "text1868": "Semleges",
  "text1869": "Egy kicsit több",
  "text1870": "Nagyon",
  "text1871": "Érdekesnek hangzik ez számodra?",
  "text1872": "Sikeresen teljesítetted a tesztet.",
  "text1873": "Kész",
  "text1874": "Te vagy a legalkalmasabb arra,",
  "text1875": "Elérhető pozíciók megjelenítése",
  "text1876": "Nem vagyok ÁFA-fizető.",
  "text1877": "Az összes értesítés megjelenítése",
  "text1878": "Értesítések",
  "text1879": "Nem olvasott",
  "text1880": "Összes megjelölése olvasottként",
  "text1881": "Nincsenek értesítések",
  "text1882": "Megjelenítendő rekordok száma",
  "text1883": "Önnek van",
  "text1884": "új üzenet",
  "text1885": "új üzenetek",
  "text1886": "új üzenetek",
  "text1887": "Válasz a hirdetésre benyújtott pályázatra",
  "text1888": "Válasz a hirdetésre",
  "text1889": "Töltsd ki a profilodat",
  "text1890": "Új állásajánlat",
  "text1891": "Az ajánlat hamarosan lejár",
  "text1892": "A cég érdeklődést mutatott",
  "text1893": "Új érdeklődő",
  "text1894": "Frissítse profilját",
  "text1895": "Rendszerértesítés",
  "text1896": "Új jelöltje van egy állásajánlatra.",
  "text1897": "új állásajánlatot adott hozzá",
  "text1898": "Érdeklődést mutatott irántad.",
  "text1899": "balra",
  "text1900": "Legújabb blogok",
  "text1901": "Ajánlott termékek",
  "text1902": "Hírek és kedvezmények",
  "text1903": "Kategória részletei",
  "text1904": "Kérjük, válaszoljon az összes kérdésre a folytatáshoz.",
  "text1905": "Teszt beküldése",
  "text1906": "Különleges ajánlat",
  "text1907": "A Loft.cz-n keresztül szeretnék eladni",
  "text1908": "Add meg az e-mail címed, és ne maradj le az egyedi ajánlatokról",
  "text1909": "Szolgáltatás",
  "text1910": "Infolink",
  "text1911": "Megfelelő munkaterületek",
  "text1912": "Megfelelő munkakörnyezet",
  "text1913": "Csatlakozz hozzánk",
  "text1914": "Várható fizetés",
  "text1915": "Népszerű cégek",
  "text1916": "Menj el minden iskolába",
  "text1917": "Előfizetés",
  "text1918": "Utoljára látva",
  "text1919": "Eseményeim",
  "text1920": "Következő cikk",
  "text1921": "Előző cikk",
  "text1922": "Folytassa az előfizetés megvásárlásával.",
  "text1923": "Szállítási ország",
  "text1924": "Kapcsolatba szeretne lépni velünk? Írjon nekünk a következő címre:",
  "text1925": "NKA",
  "text1926": "KKA",
  "text1927": "Aktív előfizetés",
  "text1928": "Előfizetése lemondása esetén az előfizetése az előfizetési időszak végéig aktív marad.",
  "text1929": "Előfizetési előzmények",
  "text1930": "Számla letöltése",
  "text1931": "Előfizetés aktiválva",
  "text1932": "Készségek",
  "text1933": "Már vásároltál előfizetést?",
  "text1934": "Jelentkezzen be fiókjába.",
  "text1935": "Az előfizetés tartalmazza a hozzáférést minden online órához, edzéshez és egyéb információhoz, valamint 10% kedvezményt minden Danceana OZ eseményre a regisztrált tagoknak.",
  "text1936": "Hozd létre a bejelentkezési adataidat.",
  "text1937": "Kezdet",
  "text1938": "Vége",
  "text1939": "Partnerek",
  "text1940": "Előfizetés vásárlása",
  "text1941": "Minden esemény",
  "text1942": "Kevesebb",
  "text1943": "Minden album",
  "text1944": "Galéria megtekintése",
  "text1945": "Mit kapsz?",
  "text1946": "Partner szeretnék lenni",
  "text1947": "Minden",
  "text1948": "Előadók",
  "text1949": "További kurzusok, amelyek érdekelhetik Önt",
  "text1950": "Felhasználási feltételek",
  "text1951": "Nincsenek elérhető kurzusaink ebben a kategóriában.",
  "text1952": "Adatmódosítás mentése",
  "text1953": "Kérjük, ellenőrizze az e-mail címét.",
  "text1954": "Ellenőrzés",
  "text1955": "Rólam",
  "text1956": "Eddig",
  "text1957": "Értékek",
  "text1958": "A regisztráció befejezéséhez meg kell erősítenie az e-mail címét.",
  "text1959": "Megerősítő e-mail újraküldése",
  "text1960": "A megerősítő e-mailt újra elküldtük.",
  "text1961": "Hiba történt a visszaigazoló e-mail küldése közben.",
  "text1962": "Az e-mail cím sikeresen ellenőrizve",
  "text1963": "Iskolák keresése",
  "text1964": "Nincsenek iskolák",
  "text1965": "Helyszín kiválasztása",
  "text1966": "Iratkozzon fel hírlevelünkre, és mindig értesüljön a legfrissebb információkról ajánlatainkról.",
  "text1967": "Ügyfeleink mondták rólunk",
  "text1968": "Egyik tulajdonság sem felel meg a kiválasztott szűrőnek.",
  "text1969": "Te lennél a legalkalmasabb a pozíciókra",
  "text1970": "Megfelelő munkapozíciók",
  "text1971": "Munkahelyi juttatások",
  "text1972": "Képzettségek",
  "text1973": "Az e-mail cím nem ellenőrizhető.",
  "text1974": "Futtassa a tesztet",
  "text1975": "Biztosan törölni szeretnéd a hirdetést?",
  "text1976": "nap",
  "text1977": "napok",
  "text1978": "napok",
  "text1979": "Beszállítói lista elrejtése",
  "text1980": "Beszállítói lista megtekintése",
  "text1981": "Ellenőrizd az elérhetőséget az eladóval",
  "text1982": "Válasszon eladót",
  "text1983": "Válasszon egy eladót",
  "text1984": "Eladói lista elrejtése",
  "text1985": "Tekintse meg a szállítók listáját",
  "text1986": "Köszönjük, regisztráltuk a megkeresését, néhány órán belül felvesszük Önnel a kapcsolatot.",
  "text1987": "Népszerű iskolák",
  "text1988": "Ha még nincs fiókod nálunk",
  "text1989": "Ennek az iskolának még nincs ellenőrzött profilja",
  "text1990": "Önéletrajz mentése PDF formátumban",
  "text1991": "Lépjen kapcsolatba az érdeklődővel",
  "text1992": "Vezetői engedélyek",
  "text1993": "Termékek megtekintése",
  "text1994": "Az értéknek az intervallumból kell származnia",
  "text1995": "Belépés",
  "text1996": "Alapszint",
  "text1997": "Válassza ki a tagság időtartamát",
  "text1998": "1 hónapos előfizetés ára",
  "text1999": "Válassza ki az önéletrajzok számát",
  "text2000": "Minden cikk",
  "text2001": "Iratkozzon fel hírlevelünkre, és elsőként értesüljön a legfrissebb hírekről, akciókról és akciókról.",
  "text2002": "A hírlevél-feliratkozás elküldésével Ön elfogadja, hogy",
  "text2003": "Nem találta a választ a kérdésére?",
  "text2004": "Lépjen kapcsolatba velünk és kérdezzen",
  "text2005": "Kölcsönzőnk",
  "text2006": "Kölcsönzés",
  "text2007": "Tanácsra van szüksége, vagy kérdése van egy termékkel kapcsolatban? Lépjen kapcsolatba velünk, és mi válaszolunk Önnek.",
  "text2008": "Írjon nekünk",
  "text2009": "Szükséges végzettség/tapasztalat a területen",
  "text2010": "Állásajánlat kérés beküldése",
  "text2011": "Az álláspályázatát elküldtük.",
  "text2012": "Cégek megtekintése",
  "text2013": "Tanácsra van szüksége? Lépjen kapcsolatba velünk",
  "text2014": "Összes megjelenítése",
  "text2015": "Nem járulok hozzá, hogy elégedettségi kérdőívet küldjenek a Heureka Verified by Customers program részeként.",
  "text2016": "Közösségi hálózatok hozzáadása",
  "text2017": "Az ár tartalmazza a 23% ÁFA-t",
  "text2018": "Bérleti feltételek ITT",
  "text2019": "Regisztráljon",
  "text2020": "Már van fiókod?",
  "text2021": "Válasszon egy motorkerékpárt",
  "text2022": "Keresés motorkerékpár neve alapján...",
  "text2023": "Nem található termék a következőhöz:",
  "text2024": "Ebben a kategóriában nincsenek elérhető termékek.",
  "text2025": "Összes törlése",
  "text2026": "Csak számokat tartalmazhat",
  "text2027": "Iskolatípus",
  "text2028": "Vissza a motorkerékpár-választékhoz",
  "text2029": "Köszönjük, a tesztvezetés iránti érdeklődését elküldtük.",
  "text2030": "Amint lehetséges, felvesszük Önnel a kapcsolatot, és egyeztetünk egy időpontot a tesztvezetésre.",
  "text2031": "Vissza a főoldalra",
  "text2032": "Szakmai fókusz",
  "text2033": "Legmagasabb befejezett iskolai végzettség",
  "text2034": "Munkahely címe",
  "text2035": "Megvan a saját mintám.",
  "text2036": "Küldje el nekünk saját tervét/szabásmintáját ezen az űrlapon keresztül, és mi árajánlatot adunk a gyártásra.",
  "text2037": "Tanfolyam dátumai",
  "text2038": "Soft skill hozzáadása",
  "text2039": "A kamat sikeresen elküldve.",
  "text2040": "Az állásajánlat iránti érdeklődés már megvalósult.",
  "text2041": "Biztosan jelentkezni szeretne erre az állásra?",
  "text2042": "Érdeklődés megerősítése",
  "text2043": "Vásárlás megerősítése",
  "text2044": "Biztosan előfizetést szeretne vásárolni?",
  "text2045": "Időszak",
  "text2046": "hónapok",
  "text2047": "Értesítések bekapcsolása",
  "text2048": "Új ajánlat a munkáltatótól",
  "text2049": "Új válasz az ajánlat iránti érdeklődésre",
  "text2050": "Kedvenc hirdetés lejárati értesítése",
  "text2051": "Új cégérdeklődés",
  "text2052": "iskolák",
  "text2053": "Megtekintve",
  "text2054": "Szakszervezetek",
  "text2055": "Az álláskeresés helyszíne",
  "text2056": "Várható fizetés",
  "text2057": "Munkahelytől való távolság",
  "text2058": "Munkaidő",
  "text2059": "Profil létrehozásának dátuma",
  "text2060": "Ajánlott felbontások",
  "text2061": "A termék a rendelés kifizetése után letölthető.",
  "text2062": "Nincs teljesen kitöltött profilod.",
  "text2063": "Meg kell adni a keresztnevet, a vezetéknevet és legalább 1 soft skillet.",
  "text2064": "Legalább 1 soft skill",
  "text2065": "A profil létrehozása egyben az önéletrajzod is. Kérjük, végezd el a lépéseket és válaszolj a következő kérdésekre.",
  "text2066": "Jelölt elfogadásának visszavonása",
  "text2067": "Szeretnéd megerősíteni a jelölt érdeklődését",
  "text2068": "Fogadja el a jelentkezőt",
  "text2069": "A jelöltek érdeklődésének megerősítése folyamatban van.",
  "text2070": "Megerősítés",
  "text2071": "Érdeklődés elfogadása",
  "text2072": "Elutasítja az érdeklődést",
  "text2073": "A jelölt üzenetet fog kapni arról, hogy elfogadtad.",
  "text2074": "Szakmai gyakorlat diákoknak",
  "text2075": "Nincsenek ajánlatok",
  "text2076": "Megmutat",
  "text2077": "ajánlat",
  "text2078": "ajánlatok",
  "text2079": "Összes elfogadása",
  "text2080": "Minden ajánlat megerősítése",
  "text2081": "Ez a művelet megerősíti az állás iránti érdeklődést minden olyan jelölt számára, akinek a jelentkezése „Függőben” státuszú.",
  "text2082": "A jelöltek üzenetet kapnak arról, hogy elfogadtad őket.",
  "text2083": "Minden ajánlat megerősítés alatt áll...",
  "text2084": "Koncepció",
  "text2085": "Aktív",
  "text2086": "Archivált",
  "text2087": "Vázlat mentése",
  "text2088": "Soft skillek hozzáadása",
  "text2089": "A fiók törlődik a következő időpontban:",
  "text2090": "Biztosan törölni szeretnéd a fiókodat?",
  "text2091": "Önéletrajzom megtekintése az önéletrajz-adatbázisban",
  "text2092": "az önéletrajz feloldása",
  "text2093": "Nem ste Jobiis Partner",
  "text2094": "Ha kedvezményes áron szeretnél CV feloldásokat vásárolni, először aktiválnod kell egy &quot;Jobiis Partner&quot; előfizetést.",
  "text2095": "Az űrlap nincs kitöltve.",
  "text2096": "Reakciók megjelenítése",
  "text2097": "Hirdetés törlése",
  "text2098": "Archívum",
  "text2099": "Aktiválás",
  "text2100": "Archivált",
  "text2101": "Aktív",
  "text2102": "Helytelenül kitöltött űrlap",
  "text2103": "Az űrlap nincs megfelelően kitöltve. Kérjük, ellenőrizze az űrlapot, és küldje el újra.",
  "text2104": "Nincs feloldva ez az önéletrajz.",
  "text2105": "Önéletrajz feloldása",
  "text2106": "Az önéletrajzban található információk eléréséhez fel kell oldania az önéletrajz zárolását.",
  "text2107": "Kinyit",
  "text2108": "Hátralévő ingyenes feloldások",
  "text2109": "Fennmaradó megvásárolt feloldások",
  "text2110": "Életrajz feloldva",
  "text2111": "Önéletrajz megtekintése",
  "text2112": "Kifizetetlen",
  "text2113": "Fizetés",
  "text2114": "Feltét",
  "text2115": "Nincsenek termékek a kosárban",
  "text2116": "Nincs elég hitelképességed.",
  "text2117": "Vállalati juttatások",
  "text2118": "Külföldieknek megfelelő ajánlat",
  "text2119": "Ajánlat frissdiplomásoknak",
  "text2120": "Oktatási tanfolyamok",
  "text2121": "Kapcsolatot teremts a jövőbeli munkáddal",
  "text2122": "Munkáltató vagyok",
  "text2123": "Jelölt vagyok",
  "text2124": "Fizesd be az ajánlatot",
  "text2125": "Oldd fel az ingyenes ajánlatot",
  "text2126": "Ingyenes ajánlatok",
  "text2127": "menü feloldása",
  "text2128": "Tag",
  "text2129": "Partner",
  "text2130": "Használja ki az ingyenes ajánlatot",
  "text2131": "maradványok",
  "text2132": "Használd ki az ingyenes feltéteket",
  "text2133": "Az önéletrajzaim",
  "text2134": "Tetején",
  "text2135": "Fizetendő összeg",
  "text2136": "Rendelés összefoglalója",
  "text2137": "Tovább az összefoglalóhoz",
  "text2138": "Vásárolható termékek",
  "text2139": "Szállítási cím",
  "text2140": "Vissza a szállítási és számlázási információkhoz",
  "text2141": "megrendelések feldolgozása és marketing célokra.",
  "text2142": "Hozzájárulok, hogy hírekről, kedvezményekről és promóciókról tájékoztassak.",
  "text2143": "maximum 600 karakter",
  "text2144": "Cégadatok hozzáadása a cégazonosító szerint",
  "text2145": "Adatok hozzáadása",
  "text2146": "Nem töltötted ki az adataidat.",
  "text2147": "A profilodban nincsenek teljesen kitöltve a számlázási adatok.",
  "text2148": "Érvényes eddig:",
  "text2149": "maximum 600 karakter",
  "text2150": "Kötelező",
  "text2151": "Szeretnéd menteni a módosításokat?",
  "text2152": "Ne mentse el",
  "text2153": "Feltöltve",
  "text2154": "Nincsenek válaszok az ajánlatra",
  "text2155": "Önéletrajzok vásárlása",
  "text2156": "Keresés város szerint",
  "text2157": "hónapok",
  "text2158": "Szakmai gyakorlat diákoknak",
  "text2159": "Végzettség/iskolai végzettség",
  "text2160": "Elért oktatás",
  "text2161": "Oktatást/képesítést nyújtó szervezet",
  "text2162": "A megadott e-mail cím már létezik.",
  "text2163": "Vállalkozás mérete",
  "text2164": "Vállalkozásméret kiválasztása",
  "text2165": "Előnyök megjelenítése",
  "text2166": "Alapvető",
  "text2167": "A tartalom nem érvényes XML.",
  "text2168": "A tartalom nem érvényes JSON.",
  "text2169": "Részletfizetéses vásárlás",
  "text2170": "Hold",
  "text2171": "Nincs hozzáadott végzettséged/képzettséged.",
  "text2172": "Hiba jelentése",
  "text2173": "Feloldások folytatása",
  "text2174": "Ajánlatok feloldása",
  "text2175": "Feltét",
  "text2176": "Hiba leírása",
  "text2177": "Hiba jelentve",
  "text2178": "Jelentsen egy másik hibát",
  "text2179": "Hiba küldés közben",
  "text2180": "A vázlatként mentett ajánlatnak nevet kell adnia.",
  "text2181": "Az áruk elérhetőségének ellenőrzése",
  "text2182": "Eladó címe",
  "text2183": "Üdvözlöm, az e-boltban",
  "text2184": "A következő termékekre vonatkozó ügyféligénylést regisztráltunk:",
  "text2185": "Kérjük, jelezze, hogy van-e raktáron a kért termék, hogy értesíthessük az ügyfelet.",
  "text2186": "Üdvözlettel, értékesítési osztály",
  "text2187": "A profilod még nem teljes.",
  "text2188": "Ahhoz, hogy a cégek láthassák a profilodat, a következő információkat is ki kell töltened:",
  "text2189": "Töltsd ki a profilt",
  "text2190": "Ha azt szeretné, hogy a cégek lássák a profilját az önéletrajz-adatbázisban, a következő információkat kell kitöltenie:",
  "text2191": "Teljes profil",
  "text2192": "Adminisztrátor",
  "text2193": "Frissítés",
  "text2194": "Jelölt profilja",
  "text2195": "Válasszon egy oktatót",
  "text2196": "Az előadó egyéb órái",
  "text2197": "Tábori előrehaladás",
  "text2198": "Előadói csapat",
  "text2199": "Egyéni kurzusok",
  "text2200": "Bejelentkezés",
  "text2201": "Minden csarnok",
  "text2202": "Teljes menetrend",
  "text2203": "Eseménygaléria",
  "text2204": "Átlagos",
  "text2205": "Nem találta a választ a kérdésére? Lépjen kapcsolatba velünk.",
  "text2206": "Oktató",
  "text2207": "Az előadóról",
  "text2208": "Milyen táncokat tanítsak?",
  "text2209": "Jelenlegi tapasztalati szintek",
  "text2210": "Előadói galéria",
  "text2211": "Táncos",
  "text2212": "Pedagógus",
  "text2213": "Besorolás (válasszon a lehetőségek közül) *",
  "text2214": "Add meg a tánccsoport / művészeti iskola nevét és működési helyét",
  "text2215": "Válassz egy iskolát",
  "text2216": "Probléma esetén vegye fel velünk a kapcsolatot.",
  "text2217": "Ez az e-mail cím fog szolgálni bejelentkezési neveként.",
  "text2218": "A regisztráció után kapni fogsz egy visszaigazoló e-mailt.",
  "text2219": "előfizetési feltételek",
  "text2220": "Előfizetési feltételek",
  "text2221": "Az ajánlat nincs teljesen kitöltve. Az ajánlat közzétételéhez szerkessze az ajánlatot úgy, hogy minden kötelező mező kitöltve legyen.",
  "text2222": "Az ajánlat vázlatként való mentéséhez meg kell adnia az ajánlat nevét.",
  "text2223": "Az ajánlat kifizetése",
  "text2224": "Az ajánlat csak a fizetést követően kerül közzétételre.",
  "text2225": "Az ajánlatért fizethetsz a profilodban található részben.",
  "text2226": "Állásajánlat",
  "text2227": "Elfogadom az ismétlődő fizetéseket",
  "text2228": "Árlista",
  "text2229": "Az iskolai profil létrehozása az iskola névjegykártyájaként szolgál majd.",
  "text2230": "Gratulálunk! Hirdetési kérelmét jóváhagytuk. Kattintson ide a céggel folytatott csevegés megnyitásához.",
  "text2231": "Sajnos a hirdetési kérelmét elutasították.",
  "text2232": "A kurzus sikeresen hozzáadva a kosárhoz",
  "text2233": "Kosárban lévő tételek",
  "text2234": "Természetes személy",
  "text2235": "Jogi személy (cég)",
  "text2236": "Befogadás",
  "text2237": "Válasszon a lehetőségek közül",
  "text2238": "Írja be az e-mail címet",
  "text2239": "Adja meg a telefonszámot",
  "text2240": "Adjon meg egy nevet",
  "text2241": "Vezetéknév megadása",
  "text2242": "Szerkesztés menü",
  "text2243": "Előfizetés vásárlása előtt be kell jelentkezned.",
  "text2244": "Még nincs fiókod?",
  "text2245": "Hozd létre itt",
  "text2246": "Galéria",
  "text2247": "Érdeklődjön",
  "text2248": "szakemberrel",
  "text2249": "videós önéletrajz",
  "text2250": "Recept",
  "text2251": "Készítsen professzionális önéletrajzot",
  "text2252": "Kártyaszám",
  "text2253": "Kártya érvényessége",
  "text2254": "CVC",
  "text2255": "HH / ÉÉ",
  "text2256": "docens",
  "text2257": "Hozzáférés a kurzus tartalmához a következőn keresztül:",
  "text2258": "előfizetés.",
  "text2259": "Ha előfizetést vásárolt,",
  "text2260": "jelentkezz be.",
  "text2261": "Nincsenek kedvenc kurzusaid.",
  "text2262": "Kártya eltávolítása",
  "text2263": "Kerékpárszerviz",
  "text2264": "Fizess és publikálj",
  "text2265": "Fizessen később",
  "text2266": "Link az ajánlatra való válaszadáshoz",
  "text2267": "Hagyja üresen a mezőt, ha a rendszerünkben szeretné kezelni az ajánlati válaszokat.",
  "text2268": "Küldjön közvetlenül érdeklődést",
  "text2269": "Fizetett",
  "text2270": "Előfizetés lemondása",
  "text2271": "Ha nem szeretne e-maileket kapni, kattintson a linkre",
  "text2272": "Címünk",
  "text2273": "Látogasson el hozzánk",
  "text2274": "Kártyatulajdonos neve",
  "text2275": "Helytelen privát kulcs formátuma",
  "text2276": "Javasoljuk a rendelést",
  "text2277": "Adj hozzá egy DXF fájlt az üzenethez. Ha több fájl is van, csomagold be őket .rar vagy .zip formátumba.",
  "text2278": "Ár kérése",
  "text2279": "Mennyiség megadása",
  "text2280": "Árajánlatkérését elküldtük. A megadott e-mail címen felvesszük Önnel a kapcsolatot.",
  "text2281": "Nem érdekel.",
  "text2282": "Vásároltak tőlünk",
  "text2283": "Több mint 2789 elégedett ügyfél",
  "text2284": "Kiválasztott kategóriák",
  "text2285": "300 m2-es üzlethelyiség",
  "text2286": "Hétfő-Péntek: 8:30 - 17:00",
  "text2287": "Bónusz klub",
  "text2288": "Biztosan kijelentkezni szeretne?",
  "text2289": "Igen, jelentkezz ki",
  "text2290": "Módosítások mentése",
  "text2291": "hozza létre itt.",
  "text2292": "Ha még nincs fiókod,",
  "text2293": "Nem, mégsem",
  "text2294": "Elégedett ügyfél",
  "text2295": "Egy személy",
  "text2296": "Vállalat",
  "text2297": "Raktáron",
  "text2298": "az Ön címén",
  "text2299": "Fedezze fel",
  "text2300": "Legkeresettebb termékek",
  "text2301": "Töltsön be többet",
  "text2302": "Fajta",
  "text2303": "Azonnal szállítjuk",
  "text2304": "Hasonlítsa össze",
  "text2305": "Műszaki paraméterek",
  "text2306": "Vélemény hozzáadása",
  "text2307": "Hiba történt a profilod frissítésekor.",
  "text2308": "Általános rendelkezések",
  "text2309": "A fő ajánlat",
  "text2310": "Információk a rendelésével kapcsolatban",
  "text2311": "A megrendelést kifizették.",
  "text2312": "A megrendelést még nem fizették ki.",
  "text2313": "Folytassa lefelé",
  "text2314": "TOP válogatás",
  "text2315": "Fedezze fel a TOP ajánlatokat minden kertbe",
  "text2316": "A lakástulajdonosok kedvence Szlovákia-szerte",
  "text2317": "A legnépszerűbb fa szerkezetek és kiegészítők a kertedbe",
  "text2318": "Fedezze fel legkelendőbb fa pavilonjainkat, házainkat, fészereinket és kiegészítőinket. Minőség és gyors szállítás egész Szlovákiában.",
  "text2319": "Minden kategória",
  "text2320": "Mi teszi termékeinket különlegessé?",
  "text2321": "Műszaki részletek",
  "text2322": "Legújabb referenciáink",
  "text2323": "Képesítés",
  "text2324": "Miért válasszon fából készült pavilonokat és házakat?",
  "text2325": "Te is szeretnéd álmai kerti házát vagy pavilonját?",
  "text2326": "Fedezze fel az ajánlatot",
  "text2327": "Előnyök",
  "text2328": "Mit kapsz a termékeinkkel?",
  "text2329": "Érdeklődöm egy konzultáció iránt.",
  "text2330": "Megvalósítások",
  "text2331": "Elégedett ügyféltörténetek",
  "text2332": "További felismerések",
  "text2333": "Érdekes cikkek olvasni",
  "text2334": "Nem találta a választ a kérdésére? Forduljon hozzánk bizalommal!",
  "text2335": "Videó lejátszása",
  "text2336": "Készen állsz átalakítani a kertedet?",
  "text2337": "Tanácsra van szüksége? Forduljon hozzánk bizalommal a kapcsolatfelvételi űrlapon keresztül, vagy közvetlenül az alábbi elérhetőségeken keresztül.",
  "text2338": "Töltsd ki az űrlapot.",
  "text2339": "Mi érdekel?",
  "text2340": "Az Ön üzenete",
  "text2341": "Az űrlap beküldésével Ön elfogadja",
  "text2342": "személyes adatok feldolgozása.",
  "text2343": "Üzenet küldése",
  "text2344": "Iratkozzon fel hírlevelünkre, és értesüljön a legfrissebb ajánlatainkról.",
  "text2345": "Nem emlékszel a jelszavadra?",
  "text2346": "Kérjük, töltse ki a rendelési számát és az e-mail címét.",
  "text2347": "A megadott rendelési szám és e-mail kombinációhoz nem létezik rendelés.",
  "text2348": "Bejelentkeztél. Az összes rendelésedet a profilodban találod.",
  "text2349": "A jelszónak legalább 6 és 64 karakter között kell lennie, egy nagybetűből és egy számból.",
  "text2350": "Személyes / céges adatok",
  "text2351": "Leltári szám",
  "text2352": "A regisztrációd sikeres volt. Elküldtünk egy megerősítő linket az e-mail fiókod aktiválásához.",
  "text2353": "Válasszon egy kategóriát az Ön preferenciái szerint, és keresse meg a keresett terméket.",
  "text2354": "További kategóriák megjelenítése",
  "text2355": "Rendezés",
  "text2356": "A kategóriáról",
  "text2357": "Számológép",
  "text2358": "Lépjen kapcsolatba velünk, és örömmel segítünk Önnek.",
  "text2359": "Ehhez a termékhez még nem érkezett értékelés. Légy az első, aki megosztja velünk a tapasztalatait!",
  "text2360": "vélemény",
  "text2361": "Rendelési előzmények",
  "text2362": "Egy cégnek vásárolok.",
  "text2363": "Erősítse meg a jelszó módosítását",
  "text2364": "Hiba történt.",
  "text2365": "Referencia helye",
  "text2366": "A projektről",
  "text2367": "A projekt galériája",
  "text2368": "Ügyfél tapasztalat",
  "text2369": "Hasonló felismerések",
  "text2370": "Tovább a cikkhez",
  "text2371": "A cikk tartalma",
  "text2372": "H-P",
  "text2373": "Szo - V",
  "text2374": "Zárva",
  "text2375": "Navigáljon a forgalomhoz",
  "text2376": "Nem találtunk a keresési feltételeknek megfelelő tartalmat.",
  "text2377": "Köszönöm az érdeklődését.",
  "text2378": "Amint lehetséges, felvesszük Önnel a kapcsolatot.",
  "text2379": "Kezdőlap",
  "text2380": "Inspirációk",
  "text2381": "Inspirációk a kertedhez",
  "text2382": "Nézd meg egy kerti ház és pavilon építésének folyamatát",
  "text2383": "Mi kontra verseny",
  "text2384": "Miben vagyunk jobbak a versenytársainknál?",
  "text2385": "Verseny",
  "text2386": "Fa kerti pavilonok és házak a kertjébe",
  "text2387": "Minőség és megfizethető árak, szállítással Szlovákiában",
  "text2388": "Teremtse meg a tökéletes helyet a pihenéshez, tároláshoz vagy autó védelméhez fa pavilonjainkkal, házainkkal, pergoláinkkal és autóbeállóinkkal. Rendelje meg még ma!",
  "text2389": "Ár darabonként",
  "text2390": "Fizetés és szállítás",
  "text2391": "API-integrációnként csak egy aktív kategória engedélyezett.",
  "text2392": "Ha van fiókod nálunk, jelentkezz be, és mi kitöltjük az adatokat a fiókod adatai alapján.",
  "text2393": "Nézze meg, miért lelkesednek vásárlóink. Ezek a legjobbra értékelt termékek ötvözik a stílust, a funkcionalitást és a megfizethetőséget.",
  "text2394": "Tekintse meg legnépszerűbb fa szerkezeteinket, melyek minőségi lucfenyőből vagy fenyőből készülnek a tartósság és a báj érdekében. Tökéletesek bármilyen kültéri térbe.",
  "text2395": "Alkalmazás",
  "text2396": "Hasznos linkek",
  "text2397": "Legyen tag",
  "text2398": "Tagsági zóna",
  "text2399": "Vezetéknév / Cégnév",
  "text2400": "Munkahely (pl. biokémiai laboratórium)",
  "text2401": "Intézmény (pl. NsP Bratislava)",
  "text2402": "marketing és kapcsolatfelvételi célokra",
  "text2403": "Személyes adatok feldolgozása",
  "text2404": "További információ",
  "text2405": "Üdvözöljük a tagok oldalán",
  "text2406": "Dokumentumok",
  "text2407": "Alapszabály",
  "text2408": "Etikai kódex",
  "text2409": "Elnökség",
  "text2410": "Jegyzőkönyvek és dokumentumok",
  "text2411": "Az egyesületi tagok képviselőinek névsora",
  "text2412": "IVD piaci statisztika",
  "text2413": "Követelések",
  "text2414": "Járulok hozzá, hogy elégedettségi kérdőívet küldjenek a Heureka Verified by Customers program részeként.",
  "text2415": "Ismerje meg előadóját",
  "text2416": "Keresés cégnév vagy azonosítószám alapján",
  "text2417": "Nem találtunk cégeket",
  "text2418": "Ismeretlen fizetési átjáró",
  "text2419": "Nincsenek aktív előfizetései.",
  "text2420": "Vásárolja meg itt.",
  "text2421": "Fizető típusa",
  "text2422": "Eq. ár",
  "text2423": "Mérés",
  "text2424": "Tanfolyamokat vásárolt",
  "text2425": "Nem vásárolt tanfolyamokat.",
  "text2426": "A tanfolyamok áttekintése.",
  "text2427": "Lépjen hátrébb",
  "text2428": "Az alábbi gombra kattintva bármikor ellenőrizheti megrendelésének állapotát",
  "text2429": "Megkaptuk e-recept-foglalását. Ellenőrizze az e-mail postaládáját.",
  "text2430": "Töltetlen",
  "text2431": "Köszönjük, hogy elküldte a foglalást!",
  "text2432": "Foglalását sikeresen elküldtük.",
  "text2433": "Adat elküldve",
  "text2434": "Töltsön fel egy fotót a receptről",
  "text2435": "Kiválasztott fotók",
  "text2436": "Készítsen fényképet",
  "text2437": "E-recept képe",
  "text2438": "Ajánlattevőként",
  "text2439": "Már van fiókom, szeretnék egyet",
  "text2440": "Munkáltatóként",
  "text2441": "Azonosító szám (IČO)",
  "text2442": "A társaság címe és székhelye",
  "text2443": "Önéletrajz szerkesztése",
  "text2444": "A profilszerkesztések mentése sikeresen megtörtént",
  "text2445": "Kérdezze szakértőnket",
  "text2446": "Előnyben részesített hely",
  "text2447": "Hétvégi munka",
  "text2448": "Éjszakai munka",
  "text2449": "További információ",
  "text2450": "Munkapreferenciák",
  "text2451": "Egyetlen önéletrajz sem felel meg a kiválasztott szűrőknek",
  "text2452": "Új állásajánlat felvételéhez minden kötelező mezőt ki kell tölteni.",
  "text2453": "Alapvető információk a pozícióról",
  "text2454": "A kérelmezővel szemben támasztott követelmények",
  "text2455": "A foglalkoztatás típusa",
  "text2456": "Válassza ki a szükséges vezetői engedély típust",
  "text2457": "Másik nyelv hozzáadása",
  "text2458": "A kezdés becsült napja",
  "text2459": "Adja meg a munkavégzés helyére vonatkozó információkat.",
  "text2460": "Bérviszonyok",
  "text2461": "Tüntesse fel az ajánlattevő fizetési feltételeit",
  "text2462": "Menü eltávolítása",
  "text2463": "Aktuális ajánlatok",
  "text2464": "Ennek a cégnek nincsenek aktív ajánlatai",
  "text2465": "Jellemezze cégét",
  "text2466": "Gyakorlati lehetőséget biztosítunk a hallgatók számára",
  "text2467": "Együttműködünk iskolákkal",
  "text2468": "Blog tartalma",
  "text2469": "Hasonló cikkek",
  "text2470": "Olvasson hasznos cikkeket.",
  "text2471": "Nyilvántartás",
  "text2472": "Kosárba",
  "text2473": "Speciális keresés",
  "text2474": "Keresés itt",
  "text2475": "Kérjük, várjon e-mailt és SMS-t",
  "text2476": "Szűrő törlése",
  "text2477": "Részleges egyezés a termék nevével",
  "text2478": "Rövid termékleírás",
  "text2479": "EAN termékkód",
  "text2480": "Külső termékkód",
  "text2481": "Termékkód",
  "text2482": "Kezdjen el írni egy címet",
  "text2483": "Jelöltek",
  "text2484": "A legrégebbi jelöltek",
  "text2485": "A legfiatalabb jelöltek",
  "text2486": "Legújabb reakciók",
  "text2487": "A legrégebbi reakciók",
  "text2488": "Elfogadott",
  "text2489": "Nem fogadták el",
  "text2490": "Dátum hamarosan",
  "text2491": "Nem található tanfolyam",
  "text2492": "üzlet",
  "text2493": "Képzési folyamat",
  "text2494": "Hiányzó e-mail-sablonbeállítás a rendelés állapotában",
  "text2495": "Balíkovo önkiszolgáló boxok",
  "text2496": "Balíkovo üzlethelyiség",
  "text2497": "Feladás",
  "text2498": "Válasszon",
  "text2499": "Kiválasztott hely",
  "text2500": "Utánvéttel",
  "text2501": "A rendelés teljes összege",
  "text2502": "Vásárlás",
  "text2503": "Használd ki az ingyenes feltéteket",
  "text2504": "hitel",
  "text2505": "hitelek",
  "text2506": "hitelek",
  "text2507": "Fizetés jóváírással",
  "text2508": "A rendelés szállítmánya nem készült el",
  "text2509": "A rendelést már kiszállították",
  "text2510": "A fuvarozó nem kínál automatizált szállítást",
  "text2511": "Ne jelenjen meg legközelebb",
  "text2512": "Személyek száma",
  "text2513": "A fizetési mód újrapróbálkozása nem engedélyezett",
  "text2514": "A fizetési átjáró jelenleg nem támogatja az API-visszatérítéseket",
  "text2515": "Emlékeztető létrehozása",
  "text2516": "Emlékeztető szerkesztése",
  "text2517": "Emlékeztető törlése",
  "text2518": "Termék létrehozása",
  "text2519": "Termékmódosítás",
  "text2520": "A termék törlése",
  "text2521": "Díj létrehozása",
  "text2522": "Árkorrekció",
  "text2523": "A nyeremény törlése",
  "text2524": "Tulajdonságtípus létrehozása",
  "text2525": "Az ingatlan típusának módosítása",
  "text2526": "Tulajdontípus törlése",
  "text2527": "Ingatlan ajánlattípus létrehozása",
  "text2528": "Ingatlan ajánlat típusának módosítása",
  "text2529": "Tulajdon listatípus törlése",
  "text2530": "Szoba létrehozása",
  "text2531": "Szobamódosítás",
  "text2532": "A szoba kiürítése",
  "text2533": "Tulajdonságcímke létrehozása",
  "text2534": "Tulajdonságcímke módosítása",
  "text2535": "Tulajdonságcímke törlése",
  "text2536": "További ingatlaninformációk létrehozása",
  "text2537": "További ingatlaninformációk módosítása",
  "text2538": "További tulajdonságadatok törlése",
  "text2539": "További ingatlaninformációk értékének létrehozása",
  "text2540": "Kiegészítő ingatlaninformáció értékének módosítása",
  "text2541": "További tulajdonságadatok értékének törlése",
  "text2542": "Város létrehozása",
  "text2543": "Városigazítás",
  "text2544": "Törölje ki a várost",
  "text2545": "Az önkormányzat létrehozása",
  "text2546": "Az önkormányzat módosítása",
  "text2547": "A falu törlése",
  "text2548": "Tulajdonság szövegmező létrehozása",
  "text2549": "Tulajdonság szövegmezőjének szerkesztése",
  "text2550": "Tulajdonság szövegmezőjének törlése",
  "text2551": "Ingatlankategória létrehozása",
  "text2552": "Ingatlankategória módosítása",
  "text2553": "Az ingatlan kategória törlése",
  "text2554": "Tulajdonságszabály létrehozása",
  "text2555": "A tulajdoni szabály módosítása",
  "text2556": "A tulajdonságszabály törlése",
  "text2557": "Tulajdonságszabály-válasz létrehozása",
  "text2558": "Tulajdonságszabály-válasz módosítása",
  "text2559": "A tulajdonságszabály válaszának törlése",
  "text2560": "Ingatlanfoglalás létrehozása",
  "text2561": "Ingatlanfoglalás módosítása",
  "text2562": "Az ingatlanfoglalás törlése",
  "text2563": "Tulajdoncél létrehozása",
  "text2564": "Az ingatlan rendeltetésének módosítása",
  "text2565": "Tulajdon céljának törlése",
  "text2566": "Ingatlan pozíció létrehozása",
  "text2567": "Az ingatlan helyzetének módosítása",
  "text2568": "A tulajdonság pozíciójának törlése",
  "text2569": "Ingatlaniroda alapítása",
  "text2570": "Ingatlanközvetítés módosítása",
  "text2571": "Ingatlaniroda törlése",
  "text2572": "Ingatlanközvetítő létrehozása",
  "text2573": "Ingatlanközvetítő módosítása",
  "text2574": "Ingatlanügynök törlése",
  "text2575": "Ingatlanfejlesztő létrehozása",
  "text2576": "Az ingatlanfejlesztő módosítása",
  "text2577": "Az ingatlanfejlesztő törlése",
  "text2578": "Ingatlan létrehozása",
  "text2579": "Ingatlan módosítása",
  "text2580": "Ingatlan törlése",
  "text2581": "Ingatlanár kialakítása",
  "text2582": "Az ingatlan árának kiigazítása",
  "text2583": "Az ingatlan árának törlése",
  "text2584": "Egyéni tulajdonságszabály létrehozása",
  "text2585": "Az ingatlan saját szabályának módosítása",
  "text2586": "Egyéni tulajdonságszabály törlése",
  "text2587": "Foglalható ingatlannap létrehozása",
  "text2588": "Az ingatlan foglalható napjának módosítása",
  "text2589": "Az ingatlan foglalható napjának törlése",
  "text2590": "Tanfolyamtípus létrehozása",
  "text2591": "A tanfolyam típusának módosítása",
  "text2592": "Tanfolyamtípus törlése",
  "text2593": "Tanfolyam kategória létrehozása",
  "text2594": "Tanfolyam kategóriájának módosítása",
  "text2595": "Tanfolyam kategória törlése",
  "text2596": "Tanfolyam szövegmezőjének létrehozása",
  "text2597": "Tanfolyam szövegmezőjének módosítása",
  "text2598": "A kurzus szövegmezőjének törlése",
  "text2599": "Tanfolyam létrehozása",
  "text2600": "Pályamódosítás",
  "text2601": "A tanfolyam törlése",
  "text2602": "A tanácsadó szoba kategória létrehozása",
  "text2603": "Konzultációs szoba kategória kiigazítása",
  "text2604": "A tanácsadó iroda kategória törlése",
  "text2605": "Tanfolyam árának létrehozása",
  "text2606": "A tanfolyam árának módosítása",
  "text2607": "A tanfolyam árának törlése",
  "text2608": "Tanfolyam fejezet készítése",
  "text2609": "Tanfolyamfejezet szerkesztése",
  "text2610": "Tanfolyamfejezet törlése",
  "text2611": "Tanfolyamoktató létrehozása",
  "text2612": "A tanfolyam oktatójának szerkesztése",
  "text2613": "A tanfolyam oktatójának törlése",
  "text2614": "Tanfolyamszint létrehozása",
  "text2615": "Tanfolyami szint beállítása",
  "text2616": "Tanfolyami szint törlése",
  "text2617": "Tanfolyam létrehozása",
  "text2618": "Tanfolyammódosítás",
  "text2619": "Tanfolyam törlése",
  "text2620": "Tanfolyamesemény létrehozása",
  "text2621": "Tanfolyamesemény módosítása",
  "text2622": "Tanfolyamesemények törlése",
  "text2623": "Tanfolyam ütemezése",
  "text2624": "Tanfolyam ütemezésének módosítása",
  "text2625": "Tanfolyam ütemezésének törlése",
  "text2626": "Munkahelytípus létrehozása",
  "text2627": "A munkaidő típusának módosítása",
  "text2628": "A munkaidő típusának törlése",
  "text2629": "Állási portál címke létrehozása",
  "text2630": "Az állásportál címke módosítása",
  "text2631": "Állásportál címke törlése",
  "text2632": "Állási portál szövegmezőjének létrehozása",
  "text2633": "Az állásportál szövegmezőjének szerkesztése",
  "text2634": "Az állásportál szövegmezőjének törlése",
  "text2635": "Állási portál kategória létrehozása",
  "text2636": "Az állásportál kategóriájának módosítása",
  "text2637": "Állási portál kategória törlése",
  "text2638": "Állásportál fizetési mód létrehozása",
  "text2639": "Az állásportál fizetési típusának módosítása",
  "text2640": "Az állásportál fizetési típusának törlése",
  "text2641": "Állásportál cégméret létrehozása",
  "text2642": "Állásportál cégméret-korrekció",
  "text2643": "Állásportál cégméret törlése",
  "text2644": "Állásportál cég létrehozása",
  "text2645": "Az állásportál cég módosítása",
  "text2646": "Az állásportál cég törlése",
  "text2647": "Állási portál állapot létrehozása",
  "text2648": "Az állásportál állapotának módosítása",
  "text2649": "Állási portál állapotának törlése",
  "text2650": "Állásportál attribútumérték létrehozása",
  "text2651": "Az állásportál attribútumértékének módosítása",
  "text2652": "A munkaportál attribútumértékének törlése",
  "text2653": "Állásportál attribútum létrehozása",
  "text2654": "Az állásportál attribútumának módosítása",
  "text2655": "Állásportál attribútum törlése",
  "text2656": "Állásportál munkaidő létrehozása",
  "text2657": "Az állásportál munkaidejének módosítása",
  "text2658": "Az állásportál munkaidő törlése",
  "text2659": "Munkaportál álláshely létrehozása",
  "text2660": "Az állásportál teljesítési helyének módosítása",
  "text2661": "A munkaportál munkavégzési helyének törlése",
  "text2662": "Korosztályos állásportál készítése",
  "text2663": "Az állásportál korhatárának módosítása",
  "text2664": "Az állásportál korosztályának törlése",
  "text2665": "Szükséges korábbi munkaportál-tapasztalat kialakítása",
  "text2666": "Szükséges korábbi munkaportál-tapasztalat kiigazítása",
  "text2667": "A szükséges korábbi munkaportál-tapasztalat eltávolítása",
  "text2668": "Alkalmasság megállapítása állásportál pozícióra",
  "text2669": "Alkalmassági korrekció az állásportál pozícióhoz",
  "text2670": "Az állásportál pozícióra való jogosultság törlése",
  "text2671": "Befejezett oktatási állásportál létrehozása",
  "text2672": "Befejezett oktatási állásportál szerkesztése",
  "text2673": "A befejezett oktatási állásportál törlése",
  "text2674": "Jogosítványi állásportál készítése",
  "text2675": "A vezetői engedélyes állásportál módosítása",
  "text2676": "Az állásportál vezetői engedélyének törlése",
  "text2677": "Állásportál iskolatípus létrehozása",
  "text2678": "Az állásportál iskolatípusának módosítása",
  "text2679": "A munkaportál iskolatípusának törlése",
  "text2680": "Az állásportál iskolai részlegének létrehozása",
  "text2681": "Az állásportál iskolai rovatának módosítása",
  "text2682": "Az állásportál iskolai részlegének törlése",
  "text2683": "Állásportál iskola létrehozása",
  "text2684": "Az iskolai állásportál módosítása",
  "text2685": "Az állásportál iskola törlése",
  "text2686": "Az állásportál iskolai projektjének elkészítése",
  "text2687": "Az állásportál iskolaprojekt módosítása",
  "text2688": "Az állásportál iskolai projekt törlése",
  "text2689": "Iskolai együttműködési munkaportál létrehozása",
  "text2690": "Az állásportál iskolai együttműködésének kiigazítása",
  "text2691": "Az állásportál iskolai együttműködésének törlése",
  "text2692": "Állásajánlat készítése az állásportálon",
  "text2693": "Az állásportál állásajánlatának módosítása",
  "text2694": "Az állásportál állásajánlatának törlése",
  "text2695": "Állásportál létrehozása Álláshirdetési készség",
  "text2696": "Az állásportál álláshirdetési készségének módosítása",
  "text2697": "Állásportál álláshirdetési készség törlése",
  "text2698": "Állásportál állásajánlati fizetés létrehozása",
  "text2699": "Az állásportál állásajánlatának bérmódosítása",
  "text2700": "Az állásportál állásajánlatának fizetésének törlése",
  "text2701": "Állásportál önéletrajzának készítése",
  "text2702": "Az állásportál folytatja a szerkesztést",
  "text2703": "Az állásportál önéletrajzának törlése",
  "text2704": "Önéletrajzi készség létrehozása állásportálról",
  "text2705": "Az állásportál önéletrajzának készségeinek módosítása",
  "text2706": "Az állásportál önéletrajzi készség törlése",
  "text2707": "Munkatapasztalat-önéletrajzi állásportál létrehozása",
  "text2708": "Az állásportál önéletrajzának munkatapasztalatának módosítása",
  "text2709": "Munkatapasztalat törlése az állásportál önéletrajzából",
  "text2710": "Állási portál létrehozása önéletrajzzal",
  "text2711": "Az állásportál önéletrajzának módosítása",
  "text2712": "Az állásportál önéletrajzának törlése",
  "text2713": "Állási portál önéletrajzának létrehozása",
  "text2714": "Az állásportál újrakezdi a bérkorrekciót",
  "text2715": "Az állásportál önéletrajzának törlése",
  "text2716": "Utazási irodai státusz létrehozása",
  "text2717": "Az utazási iroda státuszának módosítása",
  "text2718": "Az utazási iroda státuszának törlése",
  "text2719": "Utazási iroda címke létrehozása",
  "text2720": "Az utazási iroda címkéjének módosítása",
  "text2721": "Az utazási iroda címke törlése",
  "text2722": "Utazási iroda szövegmezőjének létrehozása",
  "text2723": "Az utazási iroda szövegmezőjének szerkesztése",
  "text2724": "Az utazási iroda szövegmezőjének törlése",
  "text2725": "Az utazási iroda attribútumértékének létrehozása",
  "text2726": "Az utazási iroda attribútuma értékének szerkesztése",
  "text2727": "Az utazási iroda attribútumértékének törlése",
  "text2728": "Utazási iroda attribútum létrehozása",
  "text2729": "Az utazási iroda attribútumának szerkesztése",
  "text2730": "Az utazási iroda attribútumának törlése",
  "text2731": "Utazási iroda kategória létrehozása",
  "text2732": "Az utazási iroda kategóriájának módosítása",
  "text2733": "Az utazási iroda kategória törlése",
  "text2734": "Utazási irodai körút készítése",
  "text2735": "Az utazási iroda körútjának módosítása",
  "text2736": "Utazási irodai körutazás törlése",
  "text2737": "Utazási irodai turnédátum létrehozása",
  "text2738": "Az utazási iroda turnédátumainak módosítása",
  "text2739": "Az utazási iroda utazási dátumának törlése",
  "text2740": "Utazási irodai túrafoglalás létrehozása",
  "text2741": "Utazási iroda túrafoglalásának módosítása",
  "text2742": "Utazási irodai túrafoglalás törlése",
  "text2743": "Utazási irodai utazás résztvevőjének létrehozása",
  "text2744": "Az utazási iroda utazási résztvevőjének módosítása",
  "text2745": "Az utazási iroda utazási résztvevőjének törlése",
  "text2746": "Vevőtípus létrehozása",
  "text2747": "Ügyféltípus módosítása",
  "text2748": "Ügyféltípus törlése",
  "text2749": "Ügyfél létrehozása",
  "text2750": "Ügyfél módosítása",
  "text2751": "Ügyfél törlése",
  "text2752": "Ügyfél létrehozása egy ügyfélcsoportban",
  "text2753": "Ügyfél szerkesztése egy ügyfélcsoportban",
  "text2754": "Ügyfél törlése az ügyfélcsoportból",
  "text2755": "Ügyfélcsoport létrehozása",
  "text2756": "Ügyfélcsoport módosítása",
  "text2757": "Ügyfélcsoport törlése",
  "text2758": "Felhasználói szerepkör létrehozása",
  "text2759": "Felhasználói szerepkör szerkesztése",
  "text2760": "Felhasználói szerepkör törlése",
  "text2761": "Felhasználó létrehozása",
  "text2762": "Felhasználó szerkesztése",
  "text2763": "Felhasználó törlése",
  "text2764": "Termékkupon készítése",
  "text2765": "Termékkupon módosítása",
  "text2766": "Termékkupon törlése",
  "text2767": "Kupon létrehozása",
  "text2768": "Kupon szerkesztése",
  "text2769": "A kupon törlése",
  "text2770": "Kedvezménykupon létrehozása",
  "text2771": "Kupon kedvezmény korrekció",
  "text2772": "A kuponkedvezmény törlése",
  "text2773": "Termékajándék készítése",
  "text2774": "Termékajándék szerkesztése",
  "text2775": "Termékajándék törlése",
  "text2776": "Termékkiegészítők készítése",
  "text2777": "Terméktartozékok módosítása",
  "text2778": "Terméktartozékok törlése",
  "text2779": "Termékcsomag készítése",
  "text2780": "Termékcsomag módosítása",
  "text2781": "Termékcsomag törlése",
  "text2782": "Termékkérdés létrehozása",
  "text2783": "Termékkérdés szerkesztése",
  "text2784": "Termékkérdés törlése",
  "text2785": "Virtuális termék létrehozása egy termékhez",
  "text2786": "Virtuális termék módosítása termékké",
  "text2787": "Virtuális termék törlése termékből",
  "text2788": "Termékszolgáltatás létrehozása",
  "text2789": "A szolgáltatás módosítása termékre",
  "text2790": "Termékszolgáltatás törlése",
  "text2791": "Termékértékelés készítése",
  "text2792": "Termékértékelés szerkesztése",
  "text2793": "Termékértékelés törlése",
  "text2794": "Termékváltozat létrehozása",
  "text2795": "Termékváltozat szerkesztése",
  "text2796": "Termékváltozat törlése",
  "text2797": "Termékváltozat árának létrehozása",
  "text2798": "Termékváltozat árkorrekciója",
  "text2799": "A termékváltozat árának törlése",
  "text2800": "Kategória margó létrehozása",
  "text2801": "Kategória árrés korrekciója",
  "text2802": "Kategória margó törlése",
  "text2803": "Kategória kedvezmény létrehozása",
  "text2804": "Kategória kedvezmény módosítása",
  "text2805": "Kategóriakedvezmény törlése",
  "text2806": "Kategória létrehozása",
  "text2807": "Kategória szerkesztése",
  "text2808": "Kategória törlése",
  "text2809": "Attribútumérték létrehozása",
  "text2810": "Attribútum értékének módosítása",
  "text2811": "Attribútum értékének törlése",
  "text2812": "Attribútum létrehozása",
  "text2813": "Attribútum szerkesztése",
  "text2814": "Attribútum törlése",
  "text2815": "Szállítói árrés kialakítása",
  "text2816": "Szállítói árrés korrekciója",
  "text2817": "Szállítói árrés törlése",
  "text2818": "Szállítói engedmény létrehozása",
  "text2819": "Szállítói árengedmény-korrekció",
  "text2820": "Szállítói kedvezmény törlése",
  "text2821": "Szállító létrehozása",
  "text2822": "Beszállító módosítása",
  "text2823": "Szállító törlése",
  "text2824": "Gyártó létrehozása",
  "text2825": "Gyártó módosítása",
  "text2826": "A gyártó törlése",
  "text2827": "Szövegmező létrehozása",
  "text2828": "Szövegmező szerkesztése",
  "text2829": "Szövegmező törlése",
  "text2830": "Termékállapot létrehozása",
  "text2831": "A termék állapotának módosítása",
  "text2832": "Termékállapot törlése",
  "text2833": "Termékcímke készítése",
  "text2834": "Termékcímke szerkesztése",
  "text2835": "Törölje a termékcímkét",
  "text2836": "Termékajándék készítése",
  "text2837": "Termékajándék szerkesztése",
  "text2838": "Termékajándék törlése",
  "text2839": "Ajándék készítése",
  "text2840": "Ajándék szerkesztése",
  "text2841": "Ajándék törlése",
  "text2842": "Termék létrehozása művelethez",
  "text2843": "Módosítsa a terméket cselekvésre",
  "text2844": "A termék törlése a promócióhoz",
  "text2845": "Akció létrehozása",
  "text2846": "Művelet szerkesztése",
  "text2847": "Művelet törlése",
  "text2848": "Részvényárfolyam kialakítása",
  "text2849": "A részvényárfolyam kiigazítása",
  "text2850": "A részvényárfolyam törlése",
  "text2851": "Szolgáltatási lehetőség létrehozása",
  "text2852": "Szolgáltatási opció módosítása",
  "text2853": "Szolgáltatási lehetőség törlése",
  "text2854": "Szolgáltatási opció árának kialakítása",
  "text2855": "Szolgáltatási opció ármódosítása",
  "text2856": "Szolgáltatási opció árának törlése",
  "text2857": "Fizetési mód létrehozása",
  "text2858": "Fizetési mód módosítása",
  "text2859": "Fizetési mód törlése",
  "text2860": "Fizetési mód árának létrehozása",
  "text2861": "Fizetési mód árának módosítása",
  "text2862": "A fizetési mód árának törlése",
  "text2863": "Fizetési mód kedvezmény létrehozása",
  "text2864": "Fizetési mód kedvezményének módosítása",
  "text2865": "Fizetési mód kedvezmény törlése",
  "text2866": "Szállítási mód létrehozása",
  "text2867": "A szállítás módjának módosítása",
  "text2868": "A szállítási mód törlése",
  "text2869": "Szállítási mód árának meghatározása",
  "text2870": "A szállítási mód árának módosítása",
  "text2871": "A szállítási mód árának törlése",
  "text2872": "Kiadópont létrehozása",
  "text2873": "Adagolási pont módosítás",
  "text2874": "Adagolási pont törlése",
  "text2875": "Többprojekt létrehozása",
  "text2876": "Többprojekt módosítása",
  "text2877": "Többprojekt törlése",
  "text2878": "Régió létrehozása",
  "text2879": "Régió szerkesztése",
  "text2880": "Régió törlése",
  "text2881": "Nyelvalkotás",
  "text2882": "Nyelvmódosítás",
  "text2883": "Nyelv törlése",
  "text2884": "Pénznem létrehozása",
  "text2885": "Pénznem kiigazítás",
  "text2886": "Pénznem törlése",
  "text2887": "Földteremtés",
  "text2888": "Tájmódosítás",
  "text2889": "Ország törlése",
  "text2890": "Menü létrehozása",
  "text2891": "Szerkesztés menü",
  "text2892": "A menü törlése",
  "text2893": "Menüpont létrehozása",
  "text2894": "Menüpont szerkesztése",
  "text2895": "Menüpont törlése",
  "text2896": "E-mail sablon létrehozása",
  "text2897": "E-mail sablon szerkesztése",
  "text2898": "E-mail sablon törlése",
  "text2899": "Áfa létrehozása",
  "text2900": "Áfa kiigazítása",
  "text2901": "Áfa törlése",
  "text2902": "Nagykereskedelmi típus létrehozása",
  "text2903": "Nagykereskedelmi típusmódosítás",
  "text2904": "A nagykereskedelmi típus törlése",
  "text2905": "Nagykereskedelmi alkotás",
  "text2906": "Nagykereskedelmi kiigazítás",
  "text2907": "A nagykereskedelem törlése",
  "text2908": "Nagykereskedelmi cím létrehozása",
  "text2909": "Nagykereskedelmi cím szerkesztése",
  "text2910": "A nagykereskedelmi cím törlése",
  "text2911": "Hozzon létre egy nagykereskedelmi domaint",
  "text2912": "A nagykereskedelmi domain szerkesztése",
  "text2913": "A nagykereskedelmi domain törlése",
  "text2914": "Követelés létrehozása",
  "text2915": "A követelés kiigazítása",
  "text2916": "A panasz törlése",
  "text2917": "A panasz okának megfogalmazása",
  "text2918": "A panasz okának módosítása",
  "text2919": "A panasz okának törlése",
  "text2920": "A követelés állapotának létrehozása",
  "text2921": "A követelés státuszának módosítása",
  "text2922": "A követelés állapotának törlése",
  "text2923": "Oldal létrehozása",
  "text2924": "Oldal szerkesztése",
  "text2925": "Oldal törlése",
  "text2926": "Szalaghirdetés létrehozása",
  "text2927": "Szalaghirdetés módosítása",
  "text2928": "Szalaghirdetés törlése",
  "text2929": "Nemek létrehozása",
  "text2930": "Nem szerinti kiigazítás",
  "text2931": "Nem törlése",
  "text2932": "Blogtermék készítése",
  "text2933": "A termék módosítása blogra",
  "text2934": "Termék törlése a blogból",
  "text2935": "Blog létrehozása",
  "text2936": "Blogszerkesztés",
  "text2937": "Blog törlése",
  "text2938": "Blogkategória létrehozása",
  "text2939": "Blogkategória szerkesztése",
  "text2940": "Blogkategória törlése",
  "text2941": "Bejegyzés létrehozása egy közösségi hálózaton",
  "text2942": "Bejegyzés szerkesztése egy közösségi hálózaton",
  "text2943": "Bejegyzés törlése közösségi hálózaton",
  "text2944": "Közösségi hálózat létrehozása",
  "text2945": "Közösségi hálózat szerkesztése",
  "text2946": "A közösségi hálózat törlése",
  "text2947": "Hírlevél készítés",
  "text2948": "A hírlevél módosítása",
  "text2949": "A hírlevél törlése",
  "text2950": "Tömeges levél létrehozása",
  "text2951": "Tömeges küldemény módosítása",
  "text2952": "Tömeges levelek törlése",
  "text2953": "Hírlevélcímke létrehozása",
  "text2954": "A hírlevél címke módosítása",
  "text2955": "Hírlevélcímke törlése",
  "text2956": "E-mailes hírlevél készítése",
  "text2957": "Hírlevél e-mail módosítása",
  "text2958": "Hírlevél e-mail törlése",
  "text2959": "Hűségpontok generálása",
  "text2960": "Hűségpontok módosítása",
  "text2961": "Hűségpontok törlése",
  "text2962": "Konzultációs válasz létrehozása",
  "text2963": "A tanácsadó iroda válaszának módosítása",
  "text2964": "A tanácsadó központ válaszának törlése",
  "text2965": "Tanácsadó helyiség kialakítása",
  "text2966": "A szaktanácsadó helyiség átalakítása",
  "text2967": "A tanácsadó szoba törlése",
  "text2968": "Referenciakategória létrehozása",
  "text2969": "A referenciakategória módosítása",
  "text2970": "Referenciakategória törlése",
  "text2971": "Referencia létrehozása",
  "text2972": "Hivatkozás szerkesztése",
  "text2973": "Hivatkozás törlése",
  "text2974": "Szolgáltatás létrehozása",
  "text2975": "Szolgáltatás módosítása",
  "text2976": "Szolgáltatás törlése",
  "text2977": "Szolgáltatási ár kialakítása",
  "text2978": "Szolgáltatásár-módosítás",
  "text2979": "A szolgáltatás árának törlése",
  "text2980": "Karrier létrehozása",
  "text2981": "Pályamódosítás",
  "text2982": "Karriertörlés",
  "text2983": "Kötelező közzététel megállapítása",
  "text2984": "A kötelező közzététel szabályozása",
  "text2985": "A kötelező közzététel törlése",
  "text2986": "Galéria létrehozása",
  "text2987": "Galéria szerkesztése",
  "text2988": "Galéria törlése",
  "text2989": "Csapattag létrehozása",
  "text2990": "Csapattag szerkesztése",
  "text2991": "Csapattag törlése",
  "text2992": "Ügyfél létrehozása előfizetéshez",
  "text2993": "Ügyfél módosítása az előfizetéshez",
  "text2994": "Előfizetéses ügyfél törlése",
  "text2995": "Előfizetési kategória létrehozása",
  "text2996": "Előfizetési kategória szerkesztése",
  "text2997": "Előfizetési kategória törlése",
  "text2998": "Előfizetés típusának létrehozása",
  "text2999": "Előfizetés típusának szerkesztése",
  "text3000": "Az előfizetés típusának törlése",
  "text3001": "Előfizetési típusú ár létrehozása",
  "text3002": "Előfizetési típusú ármódosítás",
  "text3003": "Az előfizetési típus árának törlése",
  "text3004": "Előfizetés létrehozása",
  "text3005": "Előfizetés módosítása",
  "text3006": "Előfizetés törlése",
  "text3007": "API konfiguráció módosítása",
  "text3008": "Megrendelés állapotának létrehozása",
  "text3009": "A megrendelés állapotának módosítása",
  "text3010": "Rendelés állapotának törlése",
  "text3011": "Megrendelés állapotbeállítás létrehozása",
  "text3012": "A rendelés állapotának beállítása",
  "text3013": "A megrendelés állapot beállításának törlése",
  "text3014": "Megrendelés létrehozása",
  "text3015": "Módosítsa a sorrendet",
  "text3016": "Megrendelés törlése",
  "text3017": "Megrendelés-szállítmány létrehozása",
  "text3018": "Kiszállítási korrekció rendelése",
  "text3019": "Megrendelés szállítmányának törlése",
  "text3020": "Ikon létrehozása",
  "text3021": "Szerkesztés ikon",
  "text3022": "Törlés ikon",
  "text3023": "Menedékhely létrehozása",
  "text3024": "A menedékház módosítása",
  "text3025": "A menedék kiürítése",
  "text3026": "Véleménytípus létrehozása",
  "text3027": "Vélemény típusának szerkesztése",
  "text3028": "Véleménytípus eltávolítása",
  "text3029": "Vélemény készítése",
  "text3030": "Vélemény szerkesztése",
  "text3031": "Vélemény eltávolítása",
  "text3032": "Konfigurációk létrehozása",
  "text3033": "Konfigurációk módosítása",
  "text3034": "Konfigurációk törlése",
  "text3035": "Seo létrehozása",
  "text3036": "Seo szerkesztése",
  "text3037": "Seo törlése",
  "text3038": "Átirányítás létrehozása",
  "text3039": "Átirányítás szerkesztése",
  "text3040": "Átirányítás törlése",
  "text3041": "Számológép szolgáltatás létrehozása",
  "text3042": "A számológép szolgáltatás módosítása",
  "text3043": "A számológép szolgáltatás törlése",
  "text3044": "Számológép szolgáltatási ár készítése",
  "text3045": "A számológép szolgáltatás árkorrekciója",
  "text3046": "A számológép szolgáltatás árának törlése",
  "text3047": "További számológép-információk létrehozása",
  "text3048": "A számológép további információinak módosítása",
  "text3049": "További számológép-információk törlése",
  "text3050": "További számológép-információk értékének létrehozása",
  "text3051": "A számológép kiegészítő információi értékének szerkesztése",
  "text3052": "A számológép kiegészítő információs értékének törlése",
  "text3053": "A számológép kiegészítő információi értékének árképzése",
  "text3054": "A számológép kiegészítő információi értékének árának módosítása",
  "text3055": "A kalkulátor kiegészítő információi árértékének törlése",
  "text3056": "Számológép-termék készítése",
  "text3057": "Számológép termékmódosítás",
  "text3058": "A számológép szorzatának törlése",
  "text3059": "Termékár-kalkulátor készítése",
  "text3060": "Kalkulátor termékár-korrekció",
  "text3061": "Elszámolási kalkulátor termék ára",
  "text3062": "Számológép-rendelés létrehozása",
  "text3063": "Számológép sorrend módosítása",
  "text3064": "Számológép-sorrend törlése",
  "text3065": "Számológép rendelési értékének létrehozása",
  "text3066": "Számológép rendelési érték módosítása",
  "text3067": "A számológép rendelési értékének törlése",
  "text3068": "Számológép rendelési szolgáltatás létrehozása",
  "text3069": "Számológép rendelési szolgáltatás szerkesztése",
  "text3070": "A számológép rendelési szolgáltatás törlése",
  "text3071": "Az utazási iroda konfigurációjának módosítása",
  "text3072": "A hírlevél konfigurációjának módosítása",
  "text3073": "A tömeges küldemény konfigurációjának módosítása",
  "text3074": "Hűségprogram konfigurációjának módosítása",
  "text3075": "Az elhagyott bevásárlókosár konfigurációjának módosítása",
  "text3076": "Szerkessze a keresőoptimalizálási konfigurációt",
  "text3077": "E-recept állapot létrehozása",
  "text3078": "E-recept státuszának módosítása",
  "text3079": "Az e-recept állapotának törlése",
  "text3080": "E-recept készítése",
  "text3081": "E-recept módosítása",
  "text3082": "E-recept törlése",
  "text3083": "Gyógyszerfoglalási állapot létrehozása",
  "text3084": "A gyógyszerfoglalás állapotának módosítása",
  "text3085": "A gyógyszerfoglalási állapot törlése",
  "text3086": "Drogfoglalási termék létrehozása",
  "text3087": "Drogfoglalási termék módosítása",
  "text3088": "Drogfoglalási termék törlése",
  "text3089": "Gyógyszerfoglalás létrehozása",
  "text3090": "Gyógyszerfoglalás módosítása",
  "text3091": "Gyógyszerfoglalás törlése",
  "text3092": "Foglalási szolgáltatás létrehozása",
  "text3093": "Foglalási szolgáltatás módosítása",
  "text3094": "A foglalási szolgáltatás törlése",
  "text3095": "Foglalási szolgáltatás árának kialakítása",
  "text3096": "A foglalási szolgáltatás árának módosítása",
  "text3097": "A foglalási szolgáltatás árának törlése",
  "text3098": "Automatikus foglalási ütemezés létrehozása",
  "text3099": "Automatikus foglalási ütemezés módosítása",
  "text3100": "Automatikus foglalási ütemezés törlése",
  "text3101": "Foglalási idő létrehozása",
  "text3102": "Foglalási idő módosítása",
  "text3103": "Foglalási idő törlése",
  "text3104": "Foglalási személy létrehozása",
  "text3105": "Lefoglaló személy módosítása",
  "text3106": "Foglalási személy törlése",
  "text3107": "Foglalás létrehozása",
  "text3108": "Foglalás módosítása",
  "text3109": "Foglalás törlése",
  "text3110": "Általános beállítások konfigurációjának módosítása",
  "text3111": "A bejelentkezés sikeres volt",
  "text3112": "Fiókja sikeresen összekapcsolva.",
  "text3113": "Most már nyugodtan bezárhatja ezt az ablakot – az eredményt elküldtük az alkalmazásnak.",
  "text3114": "Zárja be az ablakot",
  "text3115": "Zárja be ezt az ablakot manuálisan.",
  "text3116": "Kövess minket az Instagramon",
  "text3117": "A link sikeresen átmásolása a vágólapra",
  "text3118": "Az előfizetés hamarosan lejár",
  "text3119": "A profilmódosítások mentése sikeresen megtörtént",
  "text3120": "A profil sikeresen létrehozva",
  "text3121": "Készülünk",
  "text3122": "Nincs aktív előfizetésed",
  "text3123": "Vásároljon 1 éves előfizetést, és korlátlan hozzáférést kap az összes online tanfolyamhoz, valamint 10% kedvezményt kap az eseményekre!",
  "text3124": "Vásároljon előfizetést",
  "text3125": "Termékeim",
  "text3126": "A SEDMA egyesület elnöksége",
  "text3127": "Már vásároltál egy előfizetést.",
  "text3128": "Menjen tanfolyamokra",
  "text3129": "A rendelési dokumentumokat a profilodban találod",
  "text3130": "Ez a termék nem érhető el e-shopunkban",
  "text3131": "Termékinformációkat keresek...",
  "text3132": "Ez a termék nem érhető el e-shopunkban",
  "text3133": "Kategóriaajándék létrehozása",
  "text3134": "Ajándék kategória szerkesztése",
  "text3135": "Kategóriaajándék törlése",
  "text3136": "Az ajándékot már kiosztották",
  "text3137": "Ennél a terméknél nem adható ajándék",
  "text3138": "Vásároljon tanfolyamokat rendezvényeinken.",
  "text3139": "A megerősítő e-mailt sikeresen elküldtük",
  "text3140": "A jelszó-visszaállítási hivatkozás érvénytelen",
  "text3141": "Keresés a mezőkben",
  "text3142": "Pontos keresés",
  "text3143": "A rendelést törölték",
  "text3144": "A fizetési megbízást törölték, és nem hajtották végre.",
  "text3145": "Kijelentkezett",
  "text3146": "Valaki bejelentkezett a fiókjába egy másik eszközről.",
  "text3147": "A tanácsadó szoba konfigurációjának módosítása",
  "text3148": "Léttár létrehozása",
  "text3149": "Tárhely módosítása",
  "text3150": "Tárhely törlése",
  "text3151": "Készlettétel létrehozása",
  "text3152": "Tárhelyi elem módosítása",
  "text3153": "Készlettétel törlése",
  "text3154": "A fájlt már korábban feldolgozták",
  "text3155": "A nap vásárlásának létrehozása",
  "text3156": "A nap vásárlásának szerkesztése",
  "text3157": "A nap vásárlásának törlése",
  "text3158": "A napi vásárlási cikk létrehozása",
  "text3159": "A nap vásárlási tételének módosítása",
  "text3160": "A napi vásárlási tétel törlése",
  "text3161": "Az összes megjelenítése",
  "text3162": "Kedvezmény létrehozása a napi cikk vásárlására",
  "text3163": "A napi termékkedvezmény vásárlásának korrekciója",
  "text3164": "A napi vásárlási cikk kedvezményének törlése",
  "text3165": "Termékcsoport létrehozása",
  "text3166": "Termékcsoport módosítása",
  "text3167": "Termékcsoport törlése",
  "text3168": "Termékcsoport-kedvezmény létrehozása",
  "text3169": "Termékcsoport kedvezmény módosítása",
  "text3170": "Termékcsoport-kedvezmény törlése",
  "text3171": "Az ajándékot hozzáadtuk a rendeléshez",
  "text3172": "Az ajándékot már hozzáadtuk a rendeléshez",
  "text3173": "Közlekedési kategória létrehozása",
  "text3174": "Szállítási kategória módosítása",
  "text3175": "Szállítási kategória törlése",
  "text3176": "Szállítási ár kategória létrehozása",
  "text3177": "Kategória szállítási árának módosítása",
  "text3178": "Szállítási árkategória törlése",
  "text3179": "Név / Cégnév",
  "text3180": "Termék paraméterei",
  "text3181": "Kérjük, adja meg e-mail címét, és küldünk egy jelszó-visszaállítási linket.",
  "text3182": "Fiók létrehozása",
  "text3183": "Jelszó újra",
  "text3184": "Hivatkozási szám",
  "text3185": "Vissza a bejelentkezéshez",
  "text3186": "Akciós termékek",
  "text3187": "Teljes kiárusítás",
  "text3188": "A nap vásárlása",
  "text3189": "perc",
  "text3190": "óra",
  "text3191": "óra",
  "text3192": "óra",
  "text3193": "másodperc",
  "text3194": "másodperc",
  "text3195": "másodperc",
  "text3196": "A promóció lejár:",
  "text3197": "perc",
  "text3198": "Vásárolja meg ezt a terméket",
  "text3199": "Feliratkozás hírekért és kedvezményekért.",
  "text3200": "Sikeresen megkezdte a hírlevélre való feliratkozást",
  "text3201": "Bejelentkeztél. Az összes rendelésedet a profilodban találod.",
  "text3202": "Árlista letöltése",
  "text3203": "Küldjön faxot",
  "text3204": "Javítás",
  "text3205": "Banki kapcsolat (EUR)",
  "text3206": "Forgalmazóink",
  "text3207": "elégedett ügyfelek",
  "text3208": "Fiókja sikeresen létrejött!",
  "text3209": "További cikkek betöltése",
  "text3210": "Szükséged van tanácsra? Ne habozzon kapcsolatba lépni velünk akár a kapcsolatfelvételi űrlapon keresztül, akár közvetlenül telefonon és e-mailben.",
  "text3211": "Vegye fel velünk a kapcsolatot, szívesen adunk tanácsot",
  "text3212": "Számlázási és szállítási adatok",
  "text3213": "Termék szállítási árának meghatározása",
  "text3214": "A termék szállítási árának módosítása",
  "text3215": "A termék szállítási árának törlése",
  "text3216": "A megadott kupon nem létezik",
  "text3217": "Van egy kedvezménykuponom",
  "text3218": "Köszönjük a rendelési számot",
  "text3219": "A rendelés visszaigazolását elküldtük a megadott e-mail címre.",
  "text3220": "Nem található termék",
  "text3221": "Érdekes cikkek",
  "text3222": "Feliratkozva",
  "text3223": "Előfizetés lemondása",
  "text3224": "Valóban le szeretne iratkozni a hírlevélről?",
  "text3225": "A hírlevél-előfizetést törölték",
  "text3226": "Leiratkozás a hírlevélről",
  "text3227": "Minden megrendeléshez",
  "text3228": "Tartalmazza",
  "text3229": "Rendelés innen",
  "text3230": "Minden megrendeléshez",
  "text3231": "Mit mondanak elégedett ügyfeleink?",
  "text3232": "Lejárt",
  "text3233": "A tag területére való belépéshez az kell, hogy legyen",
  "text3234": "bejelentkezett",
  "text3235": "Ha még nem regisztrált, kattintson a linkre",
  "text3236": "Regisztráció.",
  "text3237": "Elfelejtette jelszavát?",
  "text3238": "Kategória megtekintése",
  "text3239": "Akciós termékek",
  "text3240": "A túrák aktuális kínálata",
  "text3241": "Menü",
  "text3242": "A termék a kosárba került",
  "text3243": "Változat szállító létrehozása",
  "text3244": "Változat gyártójának módosítása",
  "text3245": "Változat szállítójának törlése",
  "text3246": "Szállítói árváltozat létrehozása",
  "text3247": "Változatos szállítói árkorrekció",
  "text3248": "Változat szállítói ár törlése",
  "text3249": "A kupon érvénytelen",
  "text3250": "A visszaküldési lehetőségekről és az árukkal kapcsolatos panaszokról a weboldalon talál információkat.",
  "text3251": "Visszaküldések és reklamációk",
  "text3252": "Ügyfélszolgálati idő",
  "text3253": "Hétfő-Péntek: 8:30 - 17:00",
  "text3254": "Több mint",
  "text3255": "Az összes szolgáltatás megjelenítése",
  "text3256": "Elrejtés",
  "text3257": "Ajándékok a termékhez",
  "text3258": "Vásárláskor ajándék",
  "text3259": "A törlesztőrészletek kiszámítása",
  "text3260": "ellenőrzött vélemények",
  "text3261": "A kapcsolatfelvétel oka",
  "text3262": "Érvénytelen hitelesítés. Kérjük, próbálja újra",
  "text3263": "A telefonszám megadása kötelező",
  "text3264": "A feliratkozással elfogadja",
  "text3265": "Akció",
  "text3266": "Gyors szállítás",
  "text3267": "Gyors és biztonságos ingyenes szállítás 100 euró feletti rendelés esetén.",
  "text3268": "Kézbesítési lehetőségek",
  "text3269": "30 nap a visszaküldésig",
  "text3270": "Nem elégedett a termékkel? 30 nap áll rendelkezésére a termék visszaküldésére és a visszatérítésre.",
  "text3271": "Fizetési lehetőségek",
  "text3272": "Ügyfél",
  "text3273": "Ügyfél aránya",
  "text3274": "Még órák vannak hátra",
  "text3275": "Előfizetés állapota",
  "text3276": "Az előfizetés aktiválva",
  "text3277": "Az előfizetés nincs aktiválva",
  "text3278": "Lejár",
  "text3279": "Számlázó e-mail",
  "text3280": "Felelős vezető (ügyvezető)",
  "text3281": "Navigáljon a címhez",
  "text3282": "Banki kapcsolat",
  "text3283": "Panaszszám:",
  "text3284": "A kereset benyújtásának időpontja",
  "text3285": "Vásárlás dátuma",
  "text3286": "Ügyfél aláírása",
  "text3287": "Az eladó aláírása",
  "text3288": "nap",
  "text3289": "A hiba és az áru állapotának részletes leírása",
  "text3290": "Kiegészítők",
  "text3291": "A panasz tárgya",
  "text3292": "Vásárlási igazolás",
  "text3293": "Eredeti csomagolás",
  "text3294": "számú kereset feldolgozása:",
  "text3295": "Befejezés dátuma",
  "text3296": "Az elvégzett javítás további leírása",
  "text3297": "Baleset jegyzőkönyv készítése",
  "text3298": "A baleseti jegyzőkönyv szerkesztése",
  "text3299": "A baleseti jegyzőkönyv törlése",
  "text3300": "Ügyfélszolgálati idő",
  "text3301": "Google Vélemények",
  "text3302": "Feliratkozás a hírlevélre",
  "text3303": "Értesüljön időben kedvezményeinkről és akcióinkról.",
  "text3304": "Keressen egy körutat",
  "text3305": "Keressen egy körutat",
  "text3306": "Az összes körút megjelenítése",
  "text3307": "Egyre szabott turné érdekel",
  "text3308": "Amit biztosíthatunk Önnek",
  "text3309": "Úticél",
  "text3310": "Hányan szeretnének utazni",
  "text3311": "Melyik kifejezés illik hozzád a legjobban",
  "text3312": "Előnyben részesített kifejezés",
  "text3313": "Sikeresen elküldtük a személyre szabott túrára vonatkozó kérését",
  "text3314": "Jelenleg nem támogatjuk a funkciót",
  "text3315": "A fájlok nem találhatók",
  "text3316": "Termékkatalógus",
  "text3317": "Besorolt",
  "text3318": "több mint 1000 ügyfél",
  "text3319": "Menjen az e-shopba",
  "text3320": "E-könyv letöltése ingyen",
  "text3321": "Ajándék konfiguráció módosítása",
  "text3322": "Írjon nekünk e-mailt",
  "text3323": "Érdekes cikkeink",
  "text3324": "Még nem regisztrált?",
  "text3325": "Lásd, amiről lemaradsz:",
  "text3326": "Regisztráljon",
  "text3327": "Dokumentumok INGYENES",
  "text3328": "Kifizetett dokumentumok",
  "text3329": "Nem találta meg a választ a kérdésre? Vegye fel velünk a kapcsolatot közvetlenül a kapcsolatfelvételen keresztül.",
  "text3330": "Foglalkozási megbetegedések, veszélyes események, munkabalesetek nyilvántartása",
  "text3331": "Egészségügyi és biztonsági törvények és előírások",
  "text3332": "Elsősegély életveszélyes állapotok esetén",
  "text3333": "Traumatológiai terv",
  "text3334": "Naplók, ellenőrzések és jelentések",
  "text3335": "Irányelvek és törvények",
  "text3336": "A műszaki felszerelés feltételei",
  "text3337": "Jegyzőkönyv az alkalmazottak képzéséről",
  "text3338": "Dokumentumminták",
  "text3339": "Ellenőrzés és eljárások",
  "text3340": "Tanúsítvány",
  "text3341": "A marketing konfigurációjának módosítása",
  "text3342": "Foglalási kategória létrehozása",
  "text3343": "A foglalási kategória módosítása",
  "text3344": "Foglalási kategória törlése",
  "text3345": "Van fiókja? Jelentkezzen be és mi kitöltjük helyette az adatokat.",
  "text3346": "Sikeresen bejelentkezett",
  "text3347": "Tagságod részeként a következő előnyöket kapod",
  "text3348": "Használja a kupont",
  "text3349": "Teljes védelem",
  "text3350": "ami a legfontosabb számodra",
  "text3351": "Töltse ki az űrlapot, és felvesszük Önnel a kapcsolatot.",
  "text3352": "Az Ön üzenete/érdeklődése",
  "text3353": "Egy üzenet elküldésével elfogadja",
  "text3354": "kapcsolatfelvétel céljából.",
  "text3355": "Olvass tovább",
  "text3356": "Panasz",
  "text3357": "Szerződéstől való elállás",
  "text3358": "Szerződéstől való elállás és áruigénylés",
  "text3359": "minden megjelenítése",
  "text3360": "perc olvasás",
  "text3361": "Nem találta meg a választ a kérdésére? Vegye fel velünk a kapcsolatot telefonon vagy e-mailben, és szívesen válaszolunk.",
  "text3362": "További információ a Sonicube-ról",
  "text3363": "Legyen partner",
  "text3364": "Az emlékeztetők konfigurációjának módosítása",
  "text3365": "Emlékeztető ütemezési konfiguráció szerkesztése",
  "text3366": "Emlékeztető létrehozása",
  "text3367": "Emlékeztető szerkesztése",
  "text3368": "Emlékeztető törlése",
  "text3369": "A hírlevélre való feliratkozással elfogadja",
  "text3370": "marketing és hírlevél céljára.",
  "text3371": "Töltse ki az űrlapot, és felvesszük Önnel a kapcsolatot\n24 órán belül.",
  "text3372": "A késedelmes napok száma",
  "text3373": "A helyreállítás dátuma",
  "text3374": "Ajándék a termékért",
  "text3375": "Információra van szüksége a termékekről vagy a rendeléséről?",
  "text3376": "A feljegyzést már elküldtük az ügyfélnek",
  "text3377": "Keresés",
  "text3378": "További fotók",
  "text3379": "A művelet meghiúsult",
  "text3380": "Kézbesítés módja",
  "text3381": "A hiba leírása",
  "text3382": "Fiókja sikeresen létrejött!",
  "text3383": "A megadott e-mail címre küldtük",
  "text3384": "Szűrő visszaállítása",
  "text3385": "A rendelés elküldése sikeres volt",
  "text3386": "Sikeresen regisztráltuk megrendelését. A megrendelés során megadott e-mail címére visszaigazolást kap.",
  "text3387": "Iratkozzon fel, és kapjon tippeket a regeneráció és az egészség támogatásához.",
  "text3388": "Panaszok",
  "text3389": "marketing célokra.",
  "text3390": "Vállalati ügyfél",
  "text3391": "Olvassa el a cikket",
  "text3392": "Van egy kérdésem",
  "text3393": "A termék EAN-száma",
  "text3394": "Termékcsoportok típusának létrehozása",
  "text3395": "A termékcsoportok típusának szerkesztése",
  "text3396": "Termékcsoportok típusának törlése",
  "text3397": "Vélemény hozzáadása",
  "text3398": "Adókötelezettség",
  "text3399": "Termékértékelés",
  "text3400": "Értékelje ezt a terméket",
  "text3401": "A regisztráció sikeres volt",
  "text3402": "Küldtünk egy ellenőrző e-mailt a megadott e-mail címre.",
  "text3403": "Szöveges leírás",
  "text3404": "a termékértékelés feldolgozása céljából.",
  "text3405": "Az Ön kódja",
  "text3406": "Fizetésért",
  "text3407": "Vissza a szállításhoz és fizetéshez",
  "text3408": "Megrendelés fizetési kötelezettséggel",
  "text3409": "Remek! A rendelés úton van",
  "text3410": "Köszönjük, hogy minket választott.",
  "text3411": "A megrendelés visszaigazolását e-mailben találja, és folyamatosan tájékoztatjuk az állapotáról",
  "text3412": "Van fiókod nálunk?",
  "text3413": "Jelentkezzen be, és mi kitöltjük az adatokat.",
  "text3414": "Megrendelés",
  "text3415": "Jelenlegi jelszó",
  "text3416": "A megadott e-mail címre egy jelszómódosítási visszaigazolást küldtünk.",
  "text3417": "Termék keresése",
  "text3418": "Tanúsítványok",
  "text3419": "Projektjeim",
  "text3420": "Nincs aktív SMS-integráció",
  "text3421": "Hiba az SMS-korlátok érvényesítése során",
  "text3422": "Nem sikerült ellenőrizni az SMS-jóváírás állapotát. Ellenőrizze a konfigurációt",
  "text3423": "Sms-jóváírás hiánya",
  "text3424": "Az elküldött emlékeztetők összefoglalása",
  "text3425": "a következő emlékeztetőket küldtük el az ügyfeleknek",
  "text3426": "Elindult a dokumentum kibontása. Értesítést kap, ha elkészült",
  "text3427": "Kérjen időpontot konzultációra",
  "text3428": "Ebben is tudunk segíteni",
  "text3429": "Diákoknak",
  "text3430": "ajánlatot",
  "text3431": "Megtalál minket",
  "text3432": "Az ajánlat bekerült a kedvencek közé",
  "text3433": "Dokumentum konfigurációjának szerkesztése",
  "text3434": "Ajánlatok száma",
  "text3435": "További ajánlatok",
  "text3436": "Az ajánlat módosult",
  "text3437": "Az ajánlat létrejött",
  "text3438": "Segítség a rendelésben",
  "text3439": "Az összes megtekintése",
  "text3440": "nyitott pozíciók",
  "text3441": "Pozíciók",
  "text3442": "A rendelést már kifizették",
  "text3443": "A számla egyben szállítólevél is.",
  "text3444": "termékekből",
  "text3445": "A mesterséges intelligencia generálta",
  "text3446": "havonta",
  "text3447": "Teljes önéletrajz megtekintése",
  "text3448": "Miért címkézni egy AI-képet?",
  "text3449": "A bejelöléssel megerősíti, hogy a képet mesterséges intelligencia hozta létre.\n        Ily módon segít nekünk megfelelni az AI-törvénynek, és növeli az átláthatóságot a jelentkezők számára.",
  "text3450": "A mesterséges intelligencia által generált tartalom megfelelő címkézéséért a hirdető a felelős.",
  "text3451": "A jelöletlen mesterséges intelligencia tartalmat a moderátor később szerkesztheti vagy eltávolíthatja.",
  "text3452": "Nem találta meg a választ a kérdésre?",
  "text3453": "Vegye fel velünk a kapcsolatot, és a lehető leghamarabb válaszolunk.",
  "text3454": "Születési éve",
  "text3455": "A születési dátum kizárólag a felhasználó törvényes életkorának igazolására és a törvényi előírások betartásának biztosítására szolgál. Ezeket az adatokat más célokra nem használjuk fel",
  "text3456": "Válasszon fájlokat",
  "text3457": "A fájlok maximális száma",
  "text3458": "A fájl maximális mérete 2 MB",
  "text3459": "Hiba a fájl feltöltésekor",
  "text3460": "Fizetési módok",
  "text3461": "Kézbesítési módok",
  "text3462": "Ne maradj le egyetlen hírről és aktuális akcióról sem!",
  "text3463": "Iratkozzon fel hírlevelünkre, hogy értesüljön a hírekről",
  "text3464": "Az Ön e-mail címe",
  "text3465": "Értékelések száma",
  "text3466": "Ennek a terméknek nincs véleménye.",
  "text3467": "Kézbesítés részletei",
  "text3468": "Töltsön ki egy e-mailt a jelszó-visszaállítási link elküldéséhez.",
  "text3469": "Cikkeink",
  "text3470": "Akció",
  "text3471": "Nem férhet hozzá az önéletrajzokhoz",
  "text3472": "Ez a rész az előre fizetett önéletrajz-hozzáféréssel rendelkező üzleti fiókok számára érhető el.",
  "text3473": "Árlista megtekintése",
  "text3474": "Az önéletrajzokhoz csak üzleti fiókok érhetők el.",
  "text3475": "Egész kategória",
  "text3476": "Telefon elrejtése",
  "text3477": "A pozíciók listája",
  "text3478": "A kiválasztott sorozat nem alkalmazható a dokumentumtípusra",
  "text3479": "Nyitott kosár",
  "text3480": "Mennyiségi engedmények",
  "text3481": "Vásároljon hozzáférést az önéletrajzokhoz",
  "text3482": "Hozzáférés az önéletrajzokhoz",
  "text3483": "Cégek számára",
  "text3484": "Állásajánlat közzététele",
  "text3485": "Ajánlatfeltöltés",
  "text3486": "Korlátozott idejű ajánlat",
  "text3487": "A kupon lejárati dátuma",
  "text3488": "Iratkozzon fel a hírlevélre, és kedvezményt kap!",
  "text3489": "Hírek, aktuális trendek és események közvetlenül az Ön e-mailjére. Az előfizetés kedvezménykupont is tartalmaz. Kijelentkezés bármikor ingyenes.",
  "text3490": "Nem, köszönöm, nem akarok kedvezményt",
  "text3491": "Szerezzen kupont",
  "text3492": "Átrendeléskor",
  "text3493": "Minden rendelésre",
  "text3494": "A kupont elküldtük az Ön e-mail címére",
  "text3495": "Szerezzen kupont",
  "text3496": "Az elsők között kaphat információkat az új termékekről és a kedvezményekről.",
  "text3497": "Kézbesítés",
  "text3498": "Fedezze fel a koncepciót",
  "text3499": "Legyen partner",
  "text3500": "Ismerje meg az együttműködés lehetőségeit",
  "text3501": "pont",
  "text3502": "1 eurós vásárlás után szerzett pontok száma",
  "text3503": "Egy pontos érték",
  "text3504": "Maximális kedvezmény százalékban rendelésenként",
  "text3505": "Ha szeretné használni a hűségprogramot, jelentkezzen be",
  "text3506": "Váltsd be az összes pontot",
  "text3507": "Hűségpontokat alkalmaztak",
  "text3508": "Jelentkezzen",
  "text3509": "Bejelentkezési e-mail",
  "text3510": "Nincsenek mellékletek",
  "text3511": "értékelés",
  "text3512": "értékelések",
  "text3513": "értékelések",
  "text3514": "Válassz besorolást",
  "text3515": "További információ itt",
  "text3516": "Minden paraméter megjelenítése",
  "text3517": "Fennmaradó feloldások",
  "text3518": "Az önéletrajz feloldása után minden adat elérhető lesz.",
  "text3519": "Zárolt profil",
  "text3520": "Jelölt profil",
  "text3521": "Válasszon 1-3 kategóriát/pozíciót",
  "text3522": "Az összes blog megtekintése",
  "text3523": "Nem kötelező érvényű idézet",
  "text3524": "Fő szalaghirdetés",
  "text3525": "Előző képkocka",
  "text3526": "Következő képkocka",
  "text3527": "Előugró ablak megnyitása",
  "text3528": "Referencia megjelenítése a térképen",
  "text3529": "Előző oldal",
  "text3530": "Következő oldal",
  "text3531": "Ugrás az oldalra",
  "text3532": "Ugrás a diára",
  "text3533": "Korábbi előzetesek",
  "text3534": "További képek megtekintése",
  "text3535": "További előzetesek",
  "text3536": "Kérjen partner konzultációt",
  "text3537": "Ezt a címkét partnereink használhatják",
  "text3538": "GYIK létrehozása",
  "text3539": "Szerkesztési GYIK",
  "text3540": "GYIK törlése",
  "text3541": "A Schema.org létrehozása",
  "text3542": "Schema.org szerkesztése",
  "text3543": "A Schema.org törlése",
  "text3544": "Töltse ki az űrlapot, és szervezzen egy kezdeti partnerkonzultációt.",
  "text3545": "Őrzőkutya létrehozása",
  "text3546": "Watchdog módosítás",
  "text3547": "A felügyelőkutya törlése",
  "text3548": "HASQO csomag",
  "text3549": "További információ",
  "text3550": "Csomag",
  "text3551": "A csomag tartalmazza",
  "text3552": "Alkalmas",
  "text3553": "Konzultáljon a  címen.",
  "text3554": "Művelet neve",
  "text3555": "Működési város",
  "text3556": "Művelet típusa",
  "text3557": "Méret (m²)",
  "text3558": "Tervezett időpont",
  "text3559": "Tel. számot",
  "text3560": "Az Ön adatai",
  "text3561": "Az önéletrajz zárolva van",
  "text3562": "Az önéletrajz csak vásárlás után érhető el. A zárolás feloldása után megjelenik a jelentkező teljes profilja.",
  "text3563": "Őrző kutya",
  "text3564": "A Watchdog sikeresen létrehozva",
  "text3565": "Értesíteni fogunk, ha ez a termék újra elérhető lesz",
  "text3566": "A watchdog létrehozása nem sikerült",
  "text3567": "Adja meg e-mail címét, és értesítést kap, ha ez a termék újra elérhető lesz",
  "text3568": "Őrzők",
  "text3569": "A Watchdog eltávolítva",
  "text3570": "A watchdog eltávolítása nem sikerült",
  "text3571": "Nincsenek őrzők",
  "text3572": "Ingyenes feltétek",
  "text3573": "Quatro számológép",
  "text3574": "Válasszon egy GLS-aljzatot",
  "text3575": "A projekt leírása",
  "text3576": "Melyik megvalósítás érdekli?",
  "text3577": "Válassza ki a  címet.",
  "text3578": "A megvalósítás helye",
  "text3579": "Adja meg a címet",
  "text3580": "Indikatív végrehajtási dátum",
  "text3581": "Név / cég",
  "text3582": "Adja meg a cég nevét/nevét",
  "text3583": "Töltse ki az e-mail címét",
  "text3584": "Töltse ki a telefont",
  "text3585": "Az Ön megjegyzése",
  "text3586": "Jegyzet",
  "text3587": "A beküldéssel elfogadja",
  "text3588": "Ismerje meg szolgáltatásainkat",
  "text3589": "Mutasson több megvalósítást",
  "text3590": "Van még kérdése?",
  "text3591": "Van még kérdés, vagy nem találta meg a választ?",
  "text3592": "Munkaidő",
  "text3593": "Méretre készült",
  "text3594": "Minőségi anyagok",
  "text3595": "Tervezési részlet",
  "text3596": "Megvalósítási folyamat",
  "text3597": "feliratkozni a hírekre",
  "text3598": "Szerezze meg a legfrissebb információkat a KAUFMANN-tól.",
  "text3599": "Az Ön e-mail címe",
  "text3600": "A hírlevélre való feliratkozással elfogadja",
  "text3601": "Megjelenítés a térképen",
  "text3602": "vagy",
  "text3603": "Munkatársaink itt állnak az Ön rendelkezésére",
  "text3604": "munkanapokon 8:00-tól 16:00-ig",
  "text3605": "Raktár",
  "text3606": "További megvalósítások betöltése",
  "text3607": "Nem találtunk találatot ebben a kategóriában",
  "text3608": "A legkelendőbb termék létrehozása",
  "text3609": "A legkelendőbb termék módosítása",
  "text3610": "A legkelendőbb termék törlése",
  "text3611": "Jelentés",
  "text3612": "A bejelentés oka",
  "text3613": "Érettségi",
  "text3614": "éjszakák",
  "text3615": "A látogatás dátuma",
  "text3616": "A körút hossza",
  "text3617": "Ár",
  "text3618": "Kérésre",
  "text3619": "A túra részleteinek megjelenítése",
  "text3620": "Üres helyek",
  "text3621": "Frissítem a dátumokat",
  "text3622": "Minden túra rejtve van",
  "text3623": "A kiválasztott időszakban nincsenek elérhető túrák",
  "text3624": "Csökkentse",
  "text3625": "Teljes képernyő",
  "text3626": "A dátumok nem tölthetők be",
  "text3627": "alkategóriák",
  "text3628": "Kijelölés eltávolítása",
  "text3629": "Ajánlat bejelentése",
  "text3630": "A cég jelentése",
  "text3631": "Önéletrajz benyújtása",
  "text3632": "A jelentést nem sikerült elküldeni",
  "text3633": "A jelentés elküldve",
  "text3634": "életrajzok",
  "text3635": "életrajzok",
  "text3636": "Megrendelés folyamatban",
  "text3637": "Kezdőlap",
  "text3638": "Megrendelés fizetés létrehozása",
  "text3639": "Megrendelés fizetési korrekciója",
  "text3640": "Megrendelés fizetésének törlése",
  "text3641": "Legyen Ön is egyedi partnerünk!",
  "text3642": "Iratkozzon fel hírekért és információkért\núj funkciókkal bővült.",
  "text3643": "Új ingatlanok",
  "text3644": "Ingatlan kiváló áron",
  "text3645": "Elégedett ügyfelek referenciái",
  "text3646": "Nézze meg, mit gondolnak rólunk ügyfeleink.",
  "text3647": "Olvassa el a ciprusi látnivalókról szóló cikkeket",
  "text3648": "Minden fotó",
  "text3649": "Megosztás",
  "text3650": "Befejezés dátuma",
  "text3651": "Az ingatlan leírása",
  "text3652": "Túra az üdülőhelyen",
  "text3653": "PDF létrehozása",
  "text3654": "Körút lefoglalása",
  "text3655": "Online konzultáció időpontjának kiválasztása",
  "text3656": "Ingatlanok Észak-Cipruson",
  "text3657": "Szobák száma",
  "text3658": "Ingatlanügynökség",
  "text3659": "Ingatlan",
  "text3660": "Viszonteladás / Fizetett intercia",
  "text3661": "Kérjen időpontot konzultációra",
  "text3662": "A Zoom hívás maximum 1 óráig tart és minden kérdésedre válaszolunk + kapsz\n              ingyenes bemutatása az összes elérhető projektünknek Cipruson.",
  "text3663": "Ajánlatok",
  "text3664": "Van még kérdése? Szívesen bemutatjuk Önnek a HASQO koncepciót a gyakorlatban.",
  "text3665": "Kérjen konzultációt",
  "text3666": "Ügyfélzóna",
  "text3667": "Szállítmány",
  "text3668": "A kézbesítés sikeres",
  "text3669": "Ügyfélvonal",
  "text3670": "Ajánlatot szeretnék kérni",
  "text3671": "A hírlevélre való feliratkozással elfogadja",
  "text3672": "Válassz a hírek közül",
  "text3673": "Vásároljon kategóriák szerint",
  "text3674": "A termékek legjobb választéka",
  "text3675": "Feliratkozik a hírlevélre, és mindig naprakész információkat kap az akciókról és hírekről.",
  "text3676": "Az Ön e-mail címe...",
  "text3677": "Biztonságos vásárlás garancia",
  "text3678": "Szállítási módok",
  "text3679": "Megvalósításaink",
  "text3680": "Gyűjtemények",
  "text3681": "Az összes gyűjtemény megtekintése",
  "text3682": "Bíznak bennünk",
  "text3683": "A Google ellenőrizte és szerezte be",
  "text3684": "Minden vélemény",
  "text3685": "Ellenőrzött",
  "text3686": "Minden szűrő",
  "text3687": "Nem található termék",
  "text3688": "Mélység",
  "text3689": "Kérjen árajánlatot szállítmányára",
  "text3690": "Web létrehozva",
  "text3691": "reggel 9:00 és 17:00 között",
  "text3692": "A szolgáltatásról",
  "text3693": "Mit tartalmaz a szolgáltatás?",
  "text3694": "Milyen szállítmányokra alkalmas a szolgáltatás?",
  "text3695": "Hogy megy?",
  "text3696": "Másik szolgáltatás megtekintése",
  "text3697": "Amit elégedett ügyfeleink mondanak",
  "text3698": "Regisztrációs e-mail",
  "text3699": "Töltse ki az űrlapot, és kérjen ajánlatot",
  "text3700": "Szállítmány keresése",
  "text3701": "Írjon nekünk üzenetet",
  "text3702": "Kérjen ajánlatot",
  "text3703": "Kilépés",
  "text3704": "Hűségrendszer",
  "text3705": "A szállítási cím megegyezik a számlázási címmel",
  "text3706": "A kapcsolattartó személy neve",
  "text3707": "A kapcsolattartó személy vezetékneve",
  "text3708": "Az e-mail cím nem módosítható, kérjük, forduljon ügyfélszolgálatunkhoz.",
  "text3709": "Tanácsok, trendek és gyakorlati cikkek",
  "text3710": "Egyéb cikkek, amelyek érdekelhetik",
  "text3711": "Üzemeltető",
  "text3712": "Szükséged van tanácsra?\nVegye fel velünk a kapcsolatot, és szívesen segítünk Önnek.",
  "text3713": "Lépjen kapcsolatba ügyfélszolgálatunkkal, vagy írjon nekünk a kapcsolatfelvételi űrlapon keresztül, és munkatársaink tanácsot adnak Önnek.",
  "text3714": "Az Ön kérése",
  "text3715": "Jelszómódosítási kérelem küldése",
  "text3716": "Tételek sorrendben",
  "text3717": "Rendelési összeg",
  "text3718": "rögzítették. Várjuk a befizetést, majd miután jóváírtuk a számlánkon, folytatjuk a megvalósítást. Kérjük, ellenőrizze e-mailjét",
  "text3719": "Lásd az elérhető pozíciókat",
  "text3720": "Legújabb ajánlat",
  "text3721": "Legyen tagja csapatunknak",
  "text3722": "Töltse ki az űrlapot, és küldje el önéletrajzát. Ha a profilja felkelt minket és megfelel az Ön igényeinek, felvesszük Önnel a kapcsolatot.",
  "text3723": "Küldje el önéletrajzát",
  "text3724": "Betöltési hely",
  "text3725": "Cél cél",
  "text3726": "Az áru típusa",
  "text3727": "Súly (kb.)",
  "text3728": "Térfogat (m3)",
  "text3729": "Útvonal megjelenítése",
  "text3730": "Végezze el a rendelést",
  "text3731": "Változat",
  "text3732": "Adja meg a kedvezmény kódját",
  "text3733": "Használj pontokat",
  "text3734": "Pontok száma (egész szám beírása)",
  "text3735": "Figyelmeztetés: A számlán az ügyfél további módosítása nem lehetséges.",
  "text3736": "Szeretnék vásárolni egy cégnek",
  "text3737": "A szállítási cím eltér a számlázási címtől",
  "text3738": "Számlázási és kézbesítési adatok",
  "text3739": "Megrendelését kiszállították",
  "text3740": "A szám alatt regisztráltuk megrendelését",
  "text3741": "a rendelés visszaigazolását a rendelés létrehozásakor megadott e-mail címre kézbesítjük.",
  "text3742": "Vissza a főoldalra",
  "text3743": "Termékek keresése",
  "text3744": "elemek",
  "text3745": "Az összes keresés megjelenítése",
  "text3746": "Termékek összehasonlítása",
  "text3747": "Nincs összehasonlítható termék. Adjon hozzá termékeket az összehasonlítás ikonra kattintva.",
  "text3748": "Súly",
  "text3749": "Színváltozatok",
  "text3750": "Fiókja sikeresen létrejött",
  "text3751": "Regisztráció itt",
  "text3752": "1 tanfolyam = 5 edzés",
  "text3753": "A hírlevélre való feliratkozással elfogadja",
  "text3754": "Olvassa el gyakorlati cikkeinket, vagy merítsen ihletet a teak bútorok trendjeiből.",
  "text3755": "Nézet menü",
  "text3756": "Akciótermékek",
  "text3757": "Rakománytípus létrehozása",
  "text3758": "Rakománytípus módosítása",
  "text3759": "Rakománytípus törlése",
  "text3760": "Rakomány létrehozása",
  "text3761": "Terhelés beállítása",
  "text3762": "Rakomány törlése",
  "text3763": "Foglalási fizetés létrehozása",
  "text3764": "Foglalás fizetésének módosítása",
  "text3765": "A foglalási fizetés törlése",
  "text3766": "A szállásról",
  "text3767": "Az adatai biztonságban vannak",
  "text3768": "Csatlakozzon több mint",
  "text3769": "elégedett ügyfelek",
  "text3770": "A Google ellenőrizte és szerezte be",
  "text3771": "Bemutatóterem nyitva tartása",
  "text3772": "A termék megvásárlásával Ön megkapja",
  "text3773": "pont",
  "text3774": "A fiókjában van",
  "text3775": "Ismertesse a terméket",
  "text3776": "(+) Pozitív",
  "text3777": "(-) Negatív",
  "text3778": "Pozitív hozzáadása",
  "text3779": "Negatív hozzáadása",
  "text3780": "A szülőelem nem lehet ez az elem vagy annak alárendelt eleme.\nAz",
  "text3781": "áfaszám érvénytelen",
  "text3782": "A megadott áfaszám érvénytelen",
  "text3783": "{{param}} pontod van",
  "text3784": "Foglalási rendszer",
  "text3785": "Max.",
  "text3786": "A pontok beváltva",
  "text3787": "Stúdióbérlet",
  "text3788": "Pontok száma",
  "text3789": "Az értékesítés véget ért",
  "text3790": "Jelenleg előkészítjük ezt a terméket",
  "text3791": "Idézetet kérek",
  "text3792": "Árajánlat 24 órán belül",
  "text3793": "Ajánlatra van szüksége projektjéhez? 24 órán belül válaszolunk",
  "text3794": "Professzionális hegesztés és fémgyártás professzionális szinten",
  "text3795": "Csapatunk készen áll a projekt azonnali elindítására. Vegye fel velünk a kapcsolatot még ma.",
  "text3796": "vagy hívjon minket",
  "text3797": "Töltse ki a kérdőívet, és a lehető leghamarabb felvesszük Önnel a kapcsolatot, ahol részletesen megbeszéljük projektjét.",
  "text3798": "Legújabb felismeréseink",
  "text3799": "Európa egész területén tevékenykedünk",
  "text3800": "Mit tudunk nyújtani partnereinknek?",
  "text3801": "Munkaállások megtekintése",
  "text3802": "Melyik szolgáltatás érdekli?",
  "text3803": "Válasszon szolgáltatást a listából",
  "text3804": "Kért kézbesítési dátum",
  "text3805": "A projekt dokumentációja",
  "text3806": "Fájl csatolása",
  "text3807": "Üzenet küldésével hozzájárul személyes adatainak kapcsolatfelvételi célú kezeléséhez.",
  "text3808": "Jelenleg nem kínálunk nyitott pozíciókat",
  "text3809": "Ebben a kategóriában nem található hivatkozás.",
  "text3810": "Fájl törlése",
  "text3811": "A kitöltött ajánlatkérő űrlap alapján a lehető legrövidebb időn belül megkeresem Önt árajánlatjavaslattal. Köszönjük türelmét.",
  "text3812": "állásajánlat érdekel",
  "text3813": "Használt szolgáltatások",
  "text3814": "Lépés",
  "text3815": "Projekteket valósítunk meg az EU-n belül - elsősorban Németországban, Ausztriában, Csehországban és Szlovákiában, de a megrendelő igényei szerint más országokban is.",
  "text3816": "Kérjen árajánlatot projektjére még ma!",
  "text3817": "Munkakezdés",
  "text3818": "Foglalkoztatás típusa",
  "text3819": "Fizetés (bruttó)",
  "text3820": "A végrehajtásról",
  "text3821": "További felismerések",
  "text3822": "Vissza az összes cikkhez",
  "text3823": "Egyéb cikkek",
  "text3824": "Tartalom",
  "text3825": "Folytatás",
  "text3826": "vagy",
  "text3827": "A bejelentkezés sikertelen",
  "text3828": "A közösségi fiókon keresztül történő regisztrációhoz a személyes adatok kezeléséhez hozzájárulás szükséges.",
  "text3829": "A bejelentkezés sikeres volt",
  "text3830": "A közösségi fiókból származó e-mail nincs ellenőrizve.",
  "text3831": "A felhasználói fiókba nem lehet bejelentkezni.",
  "text3832": "A közösségi fiókon keresztüli bejelentkezés lejárt.",
  "text3833": "A közösségi fiókon keresztüli bejelentkezés sikertelen.",
  "text3834": "Keressen gyógyszereket, vitaminokat, kozmetikumokat...",
  "text3835": "A hivatkozás a vágólapra másolva",
  "text3836": "Csomagszám / Nyomon követési szám...",
  "text3837": "Itt mégsem",
  "text3838": "Ez is érdekelheti.",
  "text3839": "További információ a kategóriáról",
  "text3840": "Regisztrált fiók",
  "text3841": "Áru visszaküldése - elállás a szerződéstől",
  "text3842": "Áru javítása",
  "text3843": "",
  "text3844": "Termékek szűrése",
  "text3845": "Benyújtás összefoglalója",
  "text3846": "Elfogadás",
  "text3847": "Felmondás",
  "text3848": "Új keresetszám:",
  "text3849": "Biztonságos vásárlás",
  "text3850": "Visszaállítás",
  "text3851": "Olvassa el a teljes leírást",
  "text3852": "A csomag tartalma",
  "text3853": "A regisztrációhoz most a következőket kapja:",
  "text3854": "Ingyenes ajánlatok",
  "text3855": "Legjobb ajánlatok ingyen",
  "text3856": "Ingyenes tanfolyamok",
  "text3857": "Ingyenes pályafeltöltés",
  "text3858": "Ingyenes hozzáférés az önéletrajzokhoz",
  "text3859": "az előfizetésedért",
  "text3860": "flotta hozzáférési kód jött létre:",
  "text3861": "Megoszthatja ezt a kódot a felhasználókkal, hogy csatlakozzanak az előfizetéséhez.",
  "text3862": "A tagok maximális száma:",
  "text3863": "Flotta-előfizetési kód",
  "text3864": "Aktív előfizetés szükséges egy újabb hibajelentés elküldéséhez.",
  "text3865": "Erősítse meg a szerződéstől való elállást",
  "text3866": "elállás a szerződéstől:",
  "text3867": "árucsere sz.:",
  "text3868": "panaszszám:",
  "text3869": "árucsere",
  "text3870": "a szerződéstől való elállás",
  "text3871": "panasz",
  "text3872": "1750+ eredeti alkatrész raktáron",
  "text3873": "Milyen részt keres?",
  "text3874": "Keresse meg a legközelebbi üzletet",
  "text3875": "Nyitott katalógus",
  "text3876": "Az összes megjelenítése",
  "text3877": "Pótalkatrészek",
  "text3878": "Vásárlói vélemények",
  "text3879": "Termékértékelés írásához bejelentkezés szükséges",
  "text3880": "Kedvezmény kód",
  "text3881": "Írja be a kódot",
  "text3882": "Rendelés összefoglalója",
  "text3883": "Tovább a Szállítás és fizetés részhez",
  "text3884": "Tovább a kézbesítés részleteihez",
  "text3885": "Tovább a Megrendelés összegzéséhez",
  "text3886": "Megjegyzés a parancshoz",
  "text3887": "A rendelés megerősítve!",
  "text3888": "Köszönjük a vásárlást",
  "text3889": "A visszaigazolást a címre küldtük",
  "text3890": "Mi a következő lépés?",
  "text3891": "Megrendelés feldolgozva",
  "text3892": "Befizetése sikeres volt.",
  "text3893": "A csomag előkészítése",
  "text3894": "A raktár előkészíti a megrendelését",
  "text3895": "Átadás fuvarozónak",
  "text3896": "A szállító átveszi a csomagot kézbesítésre.",
  "text3897": "Kézbesítés",
  "text3898": "Felvesszük veled a kapcsolatot",
  "text3899": "Nyitvatartás",
  "text3900": "Expedíció és raktár",
  "text3901": "Hordozók",
  "text3902": "A gyűjtemény termékei",
  "text3903": "Nincsenek termékek ebben a gyűjteményben",
  "text3904": "További cikkek megjelenítése",
  "text3905": "Árkalkulátor",
  "text3906": "Az átdolgozás érdekel",
  "text3907": "Ajánlat érdekel",
  "text3908": "Rendeljen ingyenes konzultációt",
  "text3909": "Küldjön ajánlatkérést",
  "text3910": "Részletek megtekintése",
  "text3911": "Mutass további 5 kérdést",
  "text3912": "Kezdje el még ma",
  "text3913": "Kérjen nem kötelező érvényű árajánlatot szennyvíztisztító telepre",
  "text3914": "Szeretnél inkább felhívni?",
  "text3915": "Hétfőtől péntekig, 8:00-tól 17:00-ig",
  "text3916": "Egy patak közelében vagyok",
  "text3917": "Hányan fogják használni a tisztítóművet?",
  "text3918": "Van egy lejtős telkem",
  "text3919": "Költség-összehasonlítás",
  "text3920": "Miért jövedelmezőbb egy gyökér szennyvíztisztító telep, mint egy akna és egy aktiváló tisztító?",
  "text3921": "Éves működési költségek",
  "text3922": "Teljes költség 10 év alatt",
  "text3923": "Gondtalan működés",
  "text3924": "A megrendeléstől az indulásig",
  "text3925": "Hogy zajlik a szennyvíztisztító telep telepítése",
  "text3926": "Mechanikai előtisztítás szeptikus tartályban",
  "text3927": "Biológiai tisztítás baktériumokkal",
  "text3928": "Gyökérszűrés növények által",
  "text3929": "Természetes folyamat 4 lépésben",
  "text3930": "Hogyan működik egy gyökér szennyvíztisztító telep",
  "text3931": "Részletes útmutató",
  "text3932": "Szennyvíztisztítók családi házakhoz Szlovákiában",
  "text3933": "Miért válassza az ECOPLANET SLOVAKIA-t?",
  "text3934": "Teljes útmutató",
  "text3935": "ECOKOCKA szennyvíztisztító",
  "text3936": "kérésre",
  "text3937": "egyedi számítás",
  "text3938": "Válaszok a kérdéseire",
  "text3939": "Gyakran ismételt kérdések a szennyvíztisztító telepekről",
  "text3940": "Az Ön biztonsága",
  "text3941": "Miért bízhatna az ECOPLANET SLOVAKIA-ban?",
  "text3942": "Gyakorlati információ",
  "text3943": "Amit tudnia kell szennyvíztisztító telep vásárlása előtt",
  "text3944": "Valódi élmények",
  "text3945": "Amit ügyfeleink mondanak",
  "text3946": "Google vélemény",
  "text3947": "Görgessen a nyilakkal további véleményekhez",
  "text3948": "Egész Szlovákia",
  "text3949": "Szennyvíztisztítókat telepítünk Szlovákia egész területén",
  "text3950": "háztartások",
  "text3951": "szerte Szlovákia",
  "text3952": "önkormányzatok és nyugdíjak",
  "text3953": "Leggyakrabban kérdezik",
  "text3954": "Oldal neve",
  "text3955": "Kapcsolattartók",
  "text3956": "Kapcsolattartási cím",
  "text3957": "Dátumok és árak",
  "text3958": "A túra leírása",
  "text3959": "Videók",
  "text3960": "Turnus",
  "text3961": "Napok/éjszakák száma",
  "text3962": "Fenntartva",
  "text3963": "Ismeretlen állapot",
  "text3964": "Az ár tartalmazza",
  "text3965": "Az ár nem tartalmazza",
  "text3966": "Minden turné",
  "text3967": "Foglaljon időpontot",
  "text3968": "Ülésfoglalás",
  "text3969": "Feliratkozás a hírlevélre",
  "text3970": "Legyen Ön az első, aki értesül a kakikról, dátumokról és kedvezményekről.",
  "text3971": "Az elküldéssel Ön hozzájárul személyes adatai kezeléséhez.",
  "text3972": "A kifejezések áttekintése",
  "text3973": "Tekintse meg a programot",
  "text3974": "Hasonló túrák",
  "text3975": "Kész",
  "text3976": "Már minden időpont megtörtént",
  "text3977": "Olvass el cikkeket Madeiráról!",
  "text3978": "Nem kötelező érvényű fenntartás",
  "text3979": "Nem kötelező érvényű túrafoglalás",
  "text3980": "Nem kötelező érvényű fenntartás",
  "text3981": "Adja meg telefonszámát. számot",
  "text3982": "Vegyél fel egy másik résztvevőt",
  "text3983": "Résztvevő törlése",
  "text3984": "Találkozás típusa",
  "text3985": "Találkozó város",
  "text3986": "Dátum és idő",
  "text3987": "Következő",
  "text3988": "Küldés...",
  "text3989": "Erősítse meg a foglalást",
  "text3990": "Válasszon találkozóhelyet",
  "text3991": "Találkozó helye",
  "text3992": "Iratkozzon fel a hírlevélre, és mindig a legfrissebb információkat kapja kínálatunkból.",
  "text3993": "Hol találhat meg minket?",
  "text3994": "Mitől különleges utazási irodánk FEDEZD fel A VILÁGOT?",
  "text3995": "Iroda (művelet)",
  "text3996": "INFORMATIKA épület 2. emeletén",
  "text3997": "Köszönjük a foglalást!...",
  "text3998": "Legközelebbi túrák",
  "text3999": "Adja meg elérhetőségeit és hozzávetőleges költségvetését.",
  "text4000": "Kérdezem, hogyan",
  "text4001": "6000 és több",
  "text4002": "Mire készüljünk fel?",
  "text4003": "A kérést elküldtük",
  "text4004": "Köszönöm. A feldolgozás után árajánlatot küldünk e-mailben.",
  "text4005": "Kérjen számot",
  "text4006": "Küldjön újabb kérést",
  "text4007": "A maximális költségkeretnek magasabbnak kell lennie a minimálisnál.",
  "text4008": "Ellenőrizze a megjelölt mezőket.",
  "text4009": "Túl sok kérelmet nyújtott be. Kérjük, próbálja újra egy pillanat múlva.",
  "text4010": "",
  "text4011": "",
  "text4012": "",
  "text4013": "",
  "text4014": "",
  "text4015": "",
  "text4016": "",
  "text4017": "",
  "text4018": "",
  "text4019": "",
  "text4020": "",
  "text4021": "",
  "text4022": "",
  "text4023": "",
  "text4024": "",
  "text4025": "",
  "text4026": "",
  "text4027": "",
  "text4028": "",
  "text4029": "",
  "text4030": "",
  "text4031": "",
  "text4032": "",
  "text4033": "",
  "text4034": "",
  "text4035": "",
  "text4036": "",
  "text4037": "",
  "text4038": "",
  "text4039": "",
  "text4040": "",
  "text4041": "",
  "text4042": "",
  "text4043": "",
  "text4044": "",
  "text4045": "",
  "text4046": "",
  "text4047": "",
  "text4048": "",
  "text4049": "",
  "text4050": "",
  "text4051": "",
  "text4052": "Ezek az Ön céges adatai?",
  "text4053": "",
  "text4054": "Kupon eltávolítása",
  "text4055": "Inaktív",
  "text4056": "Biztosítva",
  "text4057": "Nincs biztosítva",
  "text4058": "Jármű hozzáadása",
  "text4059": "Jármű szerkesztése",
  "text4060": "Törli a járművet?",
  "text4061": "Garázsom",
  "text4062": "Műszaki és környezetvédelmi vizsga dátuma",
  "text4063": "Az exportálás nem sikerült. Kérjük, próbálja újra.",
  "text4064": "Videó szüneteltetése",
  "text4065": "Anyag",
  "text4066": "Új konfiguráció",
  "text4067": "A konfiguráció lépései",
  "text4068": "Fájl feltöltése",
  "text4069": "Időpontfoglalás",
  "text4070": "Nem sikerült másolni a hivatkozást",
  "text4071": "Az adatok sikeresen frissítve",
  "text4072": "Hozzáadás az összehasonlításhoz",
  "text4073": "Eltávolítás az összehasonlításból",
  "text4074": "Vissza a listához",
  "text4075": "Régió",
  "text4076": "Katalógusok",
  "text4077": "Flottám",
  "text4078": "Káráttekintés",
  "text4079": "Rendszám",
  "text4080": "Indulás dátuma és időpontja",
  "text4081": "Érkezés dátuma és időpontja",
  "text4082": "Jegyszám",
  "text4083": "Útlevélszám",
  "text4084": "Vissza a paraméterekhez",
  "text4085": "Összegzés és kapcsolat",
  "text4086": "A konfiguráció elküldve",
  "text4087": "Legalacsonyabb fizetés",
  "text4088": "Legmagasabb fizetés",
  "text4089": "Konfiguráció összegzése",
  "text4090": "Frissítve:",
  "text4091": "Kapcsolattartási e-mail *",
  "text4092": "Konfigurációk betöltése...",
  "text4093": "Kód alkalmazása",
  "text4094": "Megjegyzés (opcionális)...",
  "text4095": "Folyamatban lévő konfigurációk",
  "text4096": "Itt még nincsenek termékek",
  "text4097": "A konfiguráció betöltése nem sikerült",
  "text4098": "A konfiguráció elküldése nem sikerült",
  "text4099": "A konfiguráció megnyitása nem sikerült",
  "text4100": "A konfiguráció mentése nem sikerült",
  "text4101": "Betöltés a nyilvántartásból",
  "text4102": "Becsült ár",
  "text4103": "Elküldve",
  "text4104": "Elküldött árajánlatok",
  "text4105": "Az árajánlatot e-mailben küldjük el",
  "text4106": "árajánlat készítése céljából, a GDPR rendelkezéseinek megfelelően.",
  "text4107": "Kérdés hozzáadása a termékhez",
  "text4108": "",
  "text4109": "",
  "text4110": "",
  "text4111": "",
  "text4112": "",
  "text4113": "",
  "text4114": "",
  "text4115": "",
  "text4116": "",
  "text4117": "",
  "text4118": "",
  "text4119": "",
  "text4120": "",
  "text4121": "",
  "text4122": "",
  "text4123": "",
  "text4124": "",
  "text4125": "",
  "text4126": "",
  "text4127": "",
  "text4128": "",
  "text4129": "",
  "text4130": "",
  "text4131": "",
  "text4132": "",
  "text4133": "",
  "text4134": "",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": ""
}) satisfies TranslationDictionary;
